// THIS FILE IS AUTO GENERATED
import { GenIcon } from '../lib';
export function Tb2Fa(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16h-4l3.47 -4.66a2 2 0 1 0 -3.47 -1.54"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16v-8h4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "13",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 16v-6a2 2 0 0 1 4 0v6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "13",
        "x2": "21",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function Tb3DCubeSphere(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 17.6l-2 -1.1v-2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 10v-2.5l2 -1.1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4.1l2 -1.1l2 1.1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6.4l2 1.1v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 14v2.5l-2 1.12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 19.9l-2 1.1l-2 -1.1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "14",
        "y2": "10.9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "8.6",
        "x2": "20",
        "y2": "7.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "14.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18.5",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-2 -1.12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "8.6",
        "x2": "4",
        "y2": "7.5"
      }
    }]
  })(props);
}
;
export function Tb3DRotate(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 15.5l4 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 13l4 2.5v4.996l4 -2.496v-5l-4 -2.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 13v5l4 2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 4a7 7 0 0 1 7 7v4l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12l-3 3"
      }
    }]
  })(props);
}
;
export function TbABOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8h3a2 2 0 1 1 0 4h-3m3 0a2 2 0 0 1 .83 3.82m-3.83 -3.82v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbAB(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "6",
        "x2": "12",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v-8h3a2 2 0 0 1 0 4h-3m3 0a2 2 0 0 1 0 4h-3"
      }
    }]
  })(props);
}
;
export function TbAbacus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 3v18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 21v-18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7h14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 15h14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 13v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 13v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 5v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 5v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 5v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21h18"
      }
    }]
  })(props);
}
;
export function TbAccessPointOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.828 9.172a4 4 0 0 1 1.172 2.828"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.657 6.343a8 8 0 0 1 1.635 8.952"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.168 14.828a4 4 0 0 1 0 -5.656"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.337 17.657a8 8 0 0 1 0 -11.314"
      }
    }]
  })(props);
}
;
export function TbAccessPoint(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.828 9.172a4 4 0 0 1 0 5.656"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.657 6.343a8 8 0 0 1 0 11.314"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.168 14.828a4 4 0 0 1 0 -5.656"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.337 17.657a8 8 0 0 1 0 -11.314"
      }
    }]
  })(props);
}
;
export function TbAccessibleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16.5l2 -3l2 3m-2 -3v-1.5m2.627 -1.376l.373 -.124m-6 0l2.231 .744"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8a0.5 .5 0 1 0 -.5 -.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbAccessible(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16.5l2 -3l2 3m-2 -3v-2l3 -1m-6 0l3 1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbActivityHeartbeat(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5"
      }
    }]
  })(props);
}
;
export function TbActivity(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h4l3 8l4 -16l3 8h4"
      }
    }]
  })(props);
}
;
export function TbAd2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.933 5h-6.933v16h13v-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17h-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 13h5v-4h-5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6l2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 9h2"
      }
    }]
  })(props);
}
;
export function TbAd(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 15v-4a2 2 0 0 1 4 0v4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "13",
        "x2": "11",
        "y2": "13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 9v6h-1.5a1.5 1.5 0 1 1 1.5 -1.5"
      }
    }]
  })(props);
}
;
export function TbAddressBook(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16h6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "13",
        "cy": "11",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16h3"
      }
    }]
  })(props);
}
;
export function TbAdjustmentsAlt(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "8",
        "width": "4",
        "height": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "4",
        "x2": "6",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "6",
        "y2": "20"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "14",
        "width": "4",
        "height": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12",
        "y2": "20"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "16",
        "y": "5",
        "width": "4",
        "height": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "4",
        "x2": "18",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "9",
        "x2": "18",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbAdjustmentsHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "12",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "6",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "18",
        "x2": "15",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "18",
        "x2": "20",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbAdjustmentsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "10",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12v8"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "16",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "7",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 9v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbAdjustments(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "10",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "4",
        "x2": "6",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "6",
        "y2": "20"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "16",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12",
        "y2": "20"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "7",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "4",
        "x2": "18",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "9",
        "x2": "18",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbAerialLift(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 5l16 -2m-8 1v10m-5.106 -6h10.306c2.45 3 2.45 9 -.2 12h-10.106c-2.544 -3 -2.544 -9 0 -12zm-1.894 6h14"
      }
    }]
  })(props);
}
;
export function TbAffiliate(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.931 6.936l1.275 4.249m5.607 5.609l4.251 1.275"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.683 12.317l5.759 -5.759"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5.5",
        "cy": "5.5",
        "r": "1.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18.5",
        "cy": "5.5",
        "r": "1.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18.5",
        "cy": "18.5",
        "r": "1.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "15.5",
        "r": "4.5"
      }
    }]
  })(props);
}
;
export function TbAlarmOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.587 7.566a7 7 0 1 0 9.833 9.864m1.35 -2.645a7 7 0 0 0 -8.536 -8.56"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v1h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.261 5.265l-1.011 .735"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4l2.75 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbAlarm(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "13",
        "r": "7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 10 12 13 14 13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "4",
        "x2": "4.25",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "4",
        "x2": "19.75",
        "y2": "6"
      }
    }]
  })(props);
}
;
export function TbAlbum(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v7l2 -2l2 2v-7"
      }
    }]
  })(props);
}
;
export function TbAlertCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12.01",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbAlertOctagon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12.01",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbAlertTriangle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9v2m0 4v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
      }
    }]
  })(props);
}
;
export function TbAlien(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 17a2.5 2.5 0 0 0 2 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3c-4.664 0 -7.396 2.331 -7.862 5.595a11.816 11.816 0 0 0 2 8.592a10.777 10.777 0 0 0 3.199 3.064c1.666 1 3.664 1 5.33 0a10.777 10.777 0 0 0 3.199 -3.064a11.89 11.89 0 0 0 2 -8.592c-.466 -3.265 -3.198 -5.595 -7.862 -5.595z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "11",
        "x2": "10",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "11",
        "x2": "14",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbAlignCenter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "16",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "18",
        "x2": "18",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbAlignJustified(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "18",
        "x2": "16",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbAlignLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "14",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "18",
        "x2": "18",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbAlignRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "18",
        "x2": "20",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbAmbulance(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10h4m-2 -2v4"
      }
    }]
  })(props);
}
;
export function TbAnchorOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13a8 8 0 0 0 14.138 5.13m1.44 -2.56a7.99 7.99 0 0 0 .422 -2.57"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 13h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 13h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.866 8.873a3.001 3.001 0 1 0 -3.737 -3.747"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbAnchor(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9v12m-8 -8a8 8 0 0 0 16 0m1 0h-2m-14 0h-2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "6",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbAngle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 19h-18l9 -15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.615 15.171h.015"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.515 11.771h.015"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.715 8.671h.015"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.415 5.971h.015"
      }
    }]
  })(props);
}
;
export function TbAnkh(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 13h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-8l-.422 -.211a6.472 6.472 0 0 1 -3.578 -5.789a4 4 0 1 1 8 0a6.472 6.472 0 0 1 -3.578 5.789l-.422 .211"
      }
    }]
  })(props);
}
;
export function TbAntennaBars1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "18",
        "x2": "6",
        "y2": "18.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "18",
        "x2": "10",
        "y2": "18.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "18",
        "x2": "14",
        "y2": "18.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "18",
        "x2": "18",
        "y2": "18.01"
      }
    }]
  })(props);
}
;
export function TbAntennaBars2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "18",
        "x2": "6",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "18",
        "x2": "10",
        "y2": "18.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "18",
        "x2": "14",
        "y2": "18.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "18",
        "x2": "18",
        "y2": "18.01"
      }
    }]
  })(props);
}
;
export function TbAntennaBars3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "18",
        "x2": "6",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "18",
        "x2": "10",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "18",
        "x2": "14",
        "y2": "18.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "18",
        "x2": "18",
        "y2": "18.01"
      }
    }]
  })(props);
}
;
export function TbAntennaBars4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "18",
        "x2": "6",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "18",
        "x2": "10",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "18",
        "x2": "14",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "18",
        "x2": "18",
        "y2": "18.01"
      }
    }]
  })(props);
}
;
export function TbAntennaBars5(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "18",
        "x2": "6",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "18",
        "x2": "10",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "18",
        "x2": "14",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "18",
        "x2": "18",
        "y2": "6"
      }
    }]
  })(props);
}
;
export function TbAntennaBarsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 18v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 18v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 18v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 14v-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbAntenna(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4.5v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 5.5v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8h-16"
      }
    }]
  })(props);
}
;
export function TbAperture(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3.6",
        "y1": "15",
        "x2": "14.15",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3.6",
        "y1": "15",
        "x2": "14.15",
        "y2": "15",
        "transform": "rotate(72 12 12)"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3.6",
        "y1": "15",
        "x2": "14.15",
        "y2": "15",
        "transform": "rotate(144 12 12)"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3.6",
        "y1": "15",
        "x2": "14.15",
        "y2": "15",
        "transform": "rotate(216 12 12)"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3.6",
        "y1": "15",
        "x2": "14.15",
        "y2": "15",
        "transform": "rotate(288 12 12)"
      }
    }]
  })(props);
}
;
export function TbApiAppOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 15v3.5a2.5 2.5 0 1 1 -5 0v-.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h5.5a2.5 2.5 0 1 1 0 5h-.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12v-3m.042 -3.957a2.5 2.5 0 0 1 4.958 .457v.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbApiApp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12v6.5a2.5 2.5 0 1 1 -5 0v-.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9h6.5a2.5 2.5 0 1 1 0 5h-.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12v-6.5a2.5 2.5 0 0 1 5 0v.5"
      }
    }]
  })(props);
}
;
export function TbApiOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v-4m0 -4h3a2 2 0 0 1 2 2v1c0 .554 -.225 1.055 -.589 1.417m-3.411 .583h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbApi(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5"
      }
    }]
  })(props);
}
;
export function TbAppWindow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 8h.01"
      }
    }]
  })(props);
}
;
export function TbApple(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11v-6a2 2 0 0 1 2 -2h2v1a2 2 0 0 1 -2 2h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10.5c1.333 .667 2.667 .667 4 0"
      }
    }]
  })(props);
}
;
export function TbAppsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h1a1 1 0 0 1 1 1v1m-.29 3.704a0.997 .997 0 0 1 -.71 .296h-4a1 1 0 0 1 -1 -1v-4c0 -.276 .111 -.525 .292 -.706"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 14h1a1 1 0 0 1 1 1v1m-.29 3.704a0.997 .997 0 0 1 -.71 .296h-4a1 1 0 0 1 -1 -1v-4c0 -.276 .111 -.525 .292 -.706"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "14",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 7h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbApps(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "14",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "14",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "7",
        "x2": "20",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "4",
        "x2": "17",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbArchiveOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h11a2 2 0 1 1 0 4h-7m-4 0h-3a2 2 0 0 1 -.826 -3.822"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 1.824 -1.18m.176 -3.82v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbArchive(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "14",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbArmchair2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 10v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 15v-2a3 3 0 1 1 3 3v3h-14v-3a3 3 0 1 1 3 -3v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 19v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 19v2"
      }
    }]
  })(props);
}
;
export function TbArmchair(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 11a2 2 0 0 1 2 2v2h10v-2a2 2 0 1 1 4 0v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 11v-5a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 19v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19v2"
      }
    }]
  })(props);
}
;
export function TbArrowAutofitContent(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4l-3 3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4l3 3l-3 3"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "14",
        "width": "16",
        "height": "6",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 7h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 7h-7"
      }
    }]
  })(props);
}
;
export function TbArrowAutofitDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4v17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 18l3 3l3 -3"
      }
    }]
  })(props);
}
;
export function TbArrowAutofitHeight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 14v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 3v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 18l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6l3 -3l3 3"
      }
    }]
  })(props);
}
;
export function TbArrowAutofitLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 18h-17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15l-3 3l3 3"
      }
    }]
  })(props);
}
;
export function TbArrowAutofitRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v-6a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18h17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbArrowAutofitUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20v-17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6l3 -3l3 3"
      }
    }]
  })(props);
}
;
export function TbArrowAutofitWidth(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 18h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 18h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15l-3 3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbArrowBackUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 13l-4 -4l4 -4m-4 4h11a4 4 0 0 1 0 8h-1"
      }
    }]
  })(props);
}
;
export function TbArrowBack(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1"
      }
    }]
  })(props);
}
;
export function TbArrowBarDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "16",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "8",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "20",
        "y2": "4"
      }
    }]
  })(props);
}
;
export function TbArrowBarLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "14",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "8",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "8",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbArrowBarRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "10",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "16",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "16",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbArrowBarToDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "20",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "12",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "16",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "8",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbArrowBarToLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "14",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "14",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbArrowBarToRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "12",
        "x2": "4",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "12",
        "x2": "10",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "12",
        "x2": "10",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbArrowBarToUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "10",
        "x2": "12",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "10",
        "x2": "16",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "10",
        "x2": "8",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "20",
        "y2": "4"
      }
    }]
  })(props);
}
;
export function TbArrowBarUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "16",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "8",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "20",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbArrowBearLeft2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3h-5v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 5l-4.5 4.5"
      }
    }]
  })(props);
}
;
export function TbArrowBearLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 3h-5v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93"
      }
    }]
  })(props);
}
;
export function TbArrowBearRight2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3h5v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 5l4.5 4.5"
      }
    }]
  })(props);
}
;
export function TbArrowBearRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3h5v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
      }
    }]
  })(props);
}
;
export function TbArrowBigDownLine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-6h6v6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3h-6"
      }
    }]
  })(props);
}
;
export function TbArrowBigDownLines(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-3h6v3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3h-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6h-6"
      }
    }]
  })(props);
}
;
export function TbArrowBigDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4v8h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-8a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1z"
      }
    }]
  })(props);
}
;
export function TbArrowBigLeftLine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h6v6h-6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 15v-6"
      }
    }]
  })(props);
}
;
export function TbArrowBigLeftLines(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h3v6h-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 15v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15v-6"
      }
    }]
  })(props);
}
;
export function TbArrowBigLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 15h-8v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1z"
      }
    }]
  })(props);
}
;
export function TbArrowBigRightLine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-6v-6h6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9v6"
      }
    }]
  })(props);
}
;
export function TbArrowBigRightLines(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-3v-6h3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9v6"
      }
    }]
  })(props);
}
;
export function TbArrowBigRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 9h8v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1z"
      }
    }]
  })(props);
}
;
export function TbArrowBigTop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 20v-8h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v8a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
      }
    }]
  })(props);
}
;
export function TbArrowBigUpLine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v6h-6v-6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21h6"
      }
    }]
  })(props);
}
;
export function TbArrowBigUpLines(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v3h-6v-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18h6"
      }
    }]
  })(props);
}
;
export function TbArrowBottomBar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3h6"
      }
    }]
  })(props);
}
;
export function TbArrowBottomCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18l3 3l3 -3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbArrowBottomSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4h-4v-4z"
      }
    }]
  })(props);
}
;
export function TbArrowBottomTail(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3l3 3l3 -3"
      }
    }]
  })(props);
}
;
export function TbArrowCurveLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 7l-4 -4l-4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3v4.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v2.394"
      }
    }]
  })(props);
}
;
export function TbArrowCurveRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 7l4 -4l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v2.394"
      }
    }]
  })(props);
}
;
export function TbArrowDownCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "12",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "12",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbArrowDownLeftCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "9",
        "y2": "15"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 15 9 15 9 9"
      }
    }]
  })(props);
}
;
export function TbArrowDownLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "7",
        "x2": "7",
        "y2": "17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 17 7 17 7 8"
      }
    }]
  })(props);
}
;
export function TbArrowDownRightCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "15",
        "x2": "9",
        "y2": "15"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 9 15 15 9 9"
      }
    }]
  })(props);
}
;
export function TbArrowDownRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "7",
        "x2": "17",
        "y2": "17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 8 17 17 8 17"
      }
    }]
  })(props);
}
;
export function TbArrowDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "13",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "13",
        "x2": "12",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbArrowFork(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3h5v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 3h-5v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v.93"
      }
    }]
  })(props);
}
;
export function TbArrowForwardUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 13l4 -4l-4 -4m4 4h-11a4 4 0 0 0 0 8h1"
      }
    }]
  })(props);
}
;
export function TbArrowForward(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11l4 4l-4 4m4 -4h-11a4 4 0 0 1 0 -8h1"
      }
    }]
  })(props);
}
;
export function TbArrowLeftBar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12h-18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9l-3 3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 9v6"
      }
    }]
  })(props);
}
;
export function TbArrowLeftCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12h-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9l-3 3l3 3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "12",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbArrowLeftRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13l4 -4l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 13l-4 -4l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14a5 5 0 0 1 5 -5h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19v-5a5 5 0 0 0 -5 -5h-4"
      }
    }]
  })(props);
}
;
export function TbArrowLeftSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12h-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9l-3 3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 14h-4v-4h4z"
      }
    }]
  })(props);
}
;
export function TbArrowLeftTail(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 12h-15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9l-3 3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 9l-3 3l3 3"
      }
    }]
  })(props);
}
;
export function TbArrowLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "11",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "11",
        "y2": "6"
      }
    }]
  })(props);
}
;
export function TbArrowLoopLeft2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 21v-6m0 -6v-1a4 4 0 1 1 4 4h-13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16l-4 -4l4 -4"
      }
    }]
  })(props);
}
;
export function TbArrowLoopLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 21v-13a4 4 0 1 1 4 4h-13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16l-4 -4l4 -4"
      }
    }]
  })(props);
}
;
export function TbArrowLoopRight2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 16l4 -4l-4 -4"
      }
    }]
  })(props);
}
;
export function TbArrowLoopRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-13a4 4 0 1 0 -4 4h13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 16l4 -4l-4 -4"
      }
    }]
  })(props);
}
;
export function TbArrowMerge(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 7l4 -4l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v5.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v1.394"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v5.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v1.394"
      }
    }]
  })(props);
}
;
export function TbArrowNarrowDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "15",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "15",
        "x2": "12",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbArrowNarrowLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "9",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "9",
        "y2": "8"
      }
    }]
  })(props);
}
;
export function TbArrowNarrowRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "16",
        "x2": "19",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "8",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbArrowNarrowUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "9",
        "x2": "12",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "9",
        "x2": "12",
        "y2": "5"
      }
    }]
  })(props);
}
;
export function TbArrowRampLeft2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 3v8.707"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14l-4 -4l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 21c0 -6.075 -4.925 -11 -11 -11h-3"
      }
    }]
  })(props);
}
;
export function TbArrowRampLeft3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 3v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16l-4 -4l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 21v-6a3 3 0 0 0 -3 -3h-11"
      }
    }]
  })(props);
}
;
export function TbArrowRampLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "3",
        "x2": "17",
        "y2": "11.707"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 7l4 -4l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 14l-4 -4l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21a11 11 0 0 0 -11 -11h-3"
      }
    }]
  })(props);
}
;
export function TbArrowRampRight2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 3v8.707"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 14l4 -4l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21c0 -6.075 4.925 -11 11 -11h3"
      }
    }]
  })(props);
}
;
export function TbArrowRampRight3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 3v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16l4 -4l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21v-6a3 3 0 0 1 3 -3h11"
      }
    }]
  })(props);
}
;
export function TbArrowRampRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "3",
        "x2": "7",
        "y2": "11.707"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7l-4 -4l-4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 14l4 -4l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 21a11 11 0 0 1 11 -11h3"
      }
    }]
  })(props);
}
;
export function TbArrowRightBar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l3 -3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9v6"
      }
    }]
  })(props);
}
;
export function TbArrowRightCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l3 -3l-3 -3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12h14"
      }
    }]
  })(props);
}
;
export function TbArrowRightSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l3 -3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10h4v4h-4z"
      }
    }]
  })(props);
}
;
export function TbArrowRightTail(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l3 -3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 15l3 -3l-3 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbArrowRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "18",
        "x2": "19",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "6",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbArrowRotaryFirstLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "matrix(-1 0 0 1 32 0)",
        "cx": "16",
        "cy": "7",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 10v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 9.5l-8.5 8.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 18h-5v-5"
      }
    }]
  })(props);
}
;
export function TbArrowRotaryFirstRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "7",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 9.5l8.5 8.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 18h5v-5"
      }
    }]
  })(props);
}
;
export function TbArrowRotaryLastLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "matrix(-1 0 0 1 30 0)",
        "cx": "15",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 15v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 9.5l-6.5 -6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 3h-5v5"
      }
    }]
  })(props);
}
;
export function TbArrowRotaryLastRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 9.5l6.5 -6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 3h5v5"
      }
    }]
  })(props);
}
;
export function TbArrowRotaryLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "matrix(-1 0 0 1 32 0)",
        "cx": "16",
        "cy": "7",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 10v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 7h-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11l-4 -4l4 -4"
      }
    }]
  })(props);
}
;
export function TbArrowRotaryRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "7",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11l4 -4l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h10"
      }
    }]
  })(props);
}
;
export function TbArrowRotaryStraight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "13",
        "cy": "13",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 16v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 3v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 7l4 -4l4 4"
      }
    }]
  })(props);
}
;
export function TbArrowSharpTurnLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 18v-11.31a0.7 .7 0 0 0 -1.195 -.495l-9.805 9.805"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 16h-5v-5"
      }
    }]
  })(props);
}
;
export function TbArrowSharpTurnRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18v-11.31a0.7 .7 0 0 1 1.195 -.495l9.805 9.805"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 16h5v-5"
      }
    }]
  })(props);
}
;
export function TbArrowTopBar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6l-3 -3l-3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "21",
        "x2": "15",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbArrowTopCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6l-3 -3l-3 3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "19",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbArrowTopSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6l-3 -3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21v-4h4v4z"
      }
    }]
  })(props);
}
;
export function TbArrowTopTail(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6l-3 -3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 21l-3 -3l-3 3"
      }
    }]
  })(props);
}
;
export function TbArrowUpCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "8",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "12",
        "y2": "8"
      }
    }]
  })(props);
}
;
export function TbArrowUpLeftCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "9",
        "x2": "15",
        "y2": "15"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 9 9 9 9 15"
      }
    }]
  })(props);
}
;
export function TbArrowUpLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "7",
        "x2": "17",
        "y2": "17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 7 7 7 7 16"
      }
    }]
  })(props);
}
;
export function TbArrowUpRightCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "9",
        "y2": "15"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 15 15 9 9 9"
      }
    }]
  })(props);
}
;
export function TbArrowUpRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "7",
        "x2": "7",
        "y2": "17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 7 17 7 17 16"
      }
    }]
  })(props);
}
;
export function TbArrowUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "11",
        "x2": "12",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "11",
        "x2": "12",
        "y2": "5"
      }
    }]
  })(props);
}
;
export function TbArrowWaveLeftDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 13.998h-4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 11.998c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3.113 -.716 -4 -2s-2.48 -2.033 -4 -2c-1.52 -.033 -3 1 -4 2l-2 2"
      }
    }]
  })(props);
}
;
export function TbArrowWaveLeftUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 9.996h-4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 11.996c-.887 -1.285 -2.48 -2.033 -4 -2c-1.52 -.033 -3.113 .715 -4 2c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3 -1 -4 -2l-2 -2"
      }
    }]
  })(props);
}
;
export function TbArrowWaveRightDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13.998h4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11.998c.887 1.284 2.48 2.033 4 2c1.52 .033 3.113 -.716 4 -2s2.48 -2.033 4 -2c1.52 -.033 3 1 4 2l2 2"
      }
    }]
  })(props);
}
;
export function TbArrowWaveRightUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 10h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12c.887 -1.284 2.48 -2.033 4 -2c1.52 -.033 3.113 .716 4 2s2.48 2.033 4 2c1.52 .033 3 -1 4 -2l2 -2"
      }
    }]
  })(props);
}
;
export function TbArrowsCross(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 9l5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20l5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4l16 16"
      }
    }]
  })(props);
}
;
export function TbArrowsDiagonal2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 20 20 20 20 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "14",
        "x2": "20",
        "y2": "20"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 4 4 4 4 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "10",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbArrowsDiagonalMinimize2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 10h-4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4l-6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 14h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14l-6 6"
      }
    }]
  })(props);
}
;
export function TbArrowsDiagonalMinimize(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10h4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4l6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 14h-4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 14l6 6"
      }
    }]
  })(props);
}
;
export function TbArrowsDiagonal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 4 20 4 20 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "10",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 20 4 20 4 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "10",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbArrowsDoubleNeSw(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14l11 -11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 17v4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10l-11 11"
      }
    }]
  })(props);
}
;
export function TbArrowsDoubleNwSe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 21l-11 -11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14v-4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 14h4v-4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "3",
        "x2": "21",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbArrowsDoubleSeNw(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "14",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17v4h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3h-4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 14l-11 -11"
      }
    }]
  })(props);
}
;
export function TbArrowsDoubleSwNe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3l-11 11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10v4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 10h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21l11 -11"
      }
    }]
  })(props);
}
;
export function TbArrowsDownUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "3",
        "x2": "17",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 18l-3 3l-3 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "21",
        "x2": "7",
        "y2": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 6l-3 -3l-3 3"
      }
    }]
  })(props);
}
;
export function TbArrowsDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "21",
        "x2": "7",
        "y2": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 18l-3 3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18l3 3l3 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "21",
        "x2": "17",
        "y2": "3"
      }
    }]
  })(props);
}
;
export function TbArrowsHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 8 3 12 7 16"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 8 21 12 17 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbArrowsJoin2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7h1.948c1.913 0 3.705 .933 4.802 2.5a5.861 5.861 0 0 0 4.802 2.5h6.448"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17h1.95a5.854 5.854 0 0 0 4.798 -2.5a5.854 5.854 0 0 1 4.798 -2.5h5.454"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l3 -3l-3 -3"
      }
    }]
  })(props);
}
;
export function TbArrowsJoin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7h5l3.5 5h9.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17h5l3.495 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l3 -3l-3 -3"
      }
    }]
  })(props);
}
;
export function TbArrowsLeftDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3l-4 4l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7h11a3 3 0 0 1 3 3v11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 17l4 4l4 -4"
      }
    }]
  })(props);
}
;
export function TbArrowsLeftRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "17",
        "x2": "3",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10l-3 -3l3 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "7",
        "x2": "21",
        "y2": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20l3 -3l-3 -3"
      }
    }]
  })(props);
}
;
export function TbArrowsLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "7",
        "x2": "21",
        "y2": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20l-3 -3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4l-3 3l3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "17",
        "x2": "21",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbArrowsMaximize(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 4 20 4 20 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "10",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 20 4 20 4 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "10",
        "y2": "14"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 20 20 20 20 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "14",
        "x2": "20",
        "y2": "20"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 4 4 4 4 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "10",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbArrowsMinimize(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "5 9 9 9 9 5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "9",
        "y2": "9"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "5 15 9 15 9 19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "9",
        "y2": "15"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "19 9 15 9 15 5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "21",
        "y2": "3"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "19 15 15 15 15 19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "15",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbArrowsRandom(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 21.004h-4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 21.004l5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 9.504l-3.5 -2l2 -3.504"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7.504l6.83 -1.87"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16.004l4 -1l1 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 15.004l-3.5 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 5.004l-.5 4l-4 -.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.5 9.004l-4.5 -5.5"
      }
    }]
  })(props);
}
;
export function TbArrowsRightDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17l4 4l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 21v-11a3 3 0 0 1 3 -3h11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11l4 -4l-4 -4"
      }
    }]
  })(props);
}
;
export function TbArrowsRightLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "7",
        "x2": "3",
        "y2": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 10l3 -3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20l-3 -3l3 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "17",
        "x2": "21",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbArrowsRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "17",
        "x2": "3",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20l3 -3l-3 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "7",
        "x2": "3",
        "y2": "7"
      }
    }]
  })(props);
}
;
export function TbArrowsShuffle2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20l3 -3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17h3a5 5 0 0 0 5 -5a5 5 0 0 1 5 -5h5"
      }
    }]
  })(props);
}
;
export function TbArrowsShuffle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20l3 -3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 7h-5a4.978 4.978 0 0 0 -2.998 .998m-4.002 8.003a4.984 4.984 0 0 1 -3 .999h-3"
      }
    }]
  })(props);
}
;
export function TbArrowsSort(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9l4 -4l4 4m-4 -4v14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 15l-4 4l-4 -4m4 4v-14"
      }
    }]
  })(props);
}
;
export function TbArrowsSplit2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 17h-5.397a5 5 0 0 1 -4.096 -2.133l-.514 -.734a5 5 0 0 0 -4.096 -2.133h-3.897"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 7h-5.395a5 5 0 0 0 -4.098 2.135l-.51 .73a5 5 0 0 1 -4.097 2.135h-3.9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 10l3 -3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20l3 -3l-3 -3"
      }
    }]
  })(props);
}
;
export function TbArrowsSplit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 17h-8l-3.5 -5h-6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 7h-8l-3.495 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 10l3 -3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20l3 -3l-3 -3"
      }
    }]
  })(props);
}
;
export function TbArrowsUpDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "3",
        "x2": "7",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6l-3 -3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 18l-3 3l-3 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "21",
        "x2": "17",
        "y2": "3"
      }
    }]
  })(props);
}
;
export function TbArrowsUpLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 7l-4 -4l-4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3v11a3 3 0 0 1 -3 3h-11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 13l-4 4l4 4"
      }
    }]
  })(props);
}
;
export function TbArrowsUpRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21l4 -4l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 17h-11a3 3 0 0 1 -3 -3v-11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7l-4 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbArrowsUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "3",
        "x2": "17",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6l3 -3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 6l-3 -3l-3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "3",
        "x2": "7",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbArrowsVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 7 12 3 16 7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 17 12 21 16 17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbArtboardOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8h3a1 1 0 0 1 1 1v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.716 15.698a0.997 .997 0 0 1 -.716 .302h-6a1 1 0 0 1 -1 -1v-6c0 -.273 .11 -.52 .287 -.7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 8h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 16h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 3v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 16h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 20v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbArtboard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "8",
        "width": "8",
        "height": "8",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "8",
        "x2": "4",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "16",
        "x2": "4",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "3",
        "x2": "8",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "3",
        "x2": "16",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "21",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "16",
        "x2": "21",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "8",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "20",
        "x2": "16",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbAspectRatioOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12v-3h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12v1m-2 2h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbAspectRatio(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12v-3h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12v3h-3"
      }
    }]
  })(props);
}
;
export function TbAsset(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "15",
        "r": "6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "15",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.218 17.975l6.619 -12.174"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.079 9.756l12.217 -6.631"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "15",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbAsteriskSimple(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v-9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-9 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l9 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l6 8.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-6 8.5"
      }
    }]
  })(props);
}
;
export function TbAsterisk(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l8 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-8 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l8 4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-8 4.5"
      }
    }]
  })(props);
}
;
export function TbAtOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.174 9.17a4 4 0 0 0 5.646 5.668m1.18 -2.838a4 4 0 0 0 -4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.695 15.697a2.5 2.5 0 0 0 1.305 -2.197v-1.5a9 9 0 0 0 -13.055 -8.047m-2.322 1.683a9 9 0 0 0 9.877 14.644"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbAt(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12v1.5a2.5 2.5 0 0 0 5 0v-1.5a9 9 0 1 0 -5.5 8.28"
      }
    }]
  })(props);
}
;
export function TbAtom2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "21.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "9",
        "x2": "3",
        "y2": "9.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "9",
        "x2": "21",
        "y2": "9.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 20.1a9 9 0 0 1 -5 -7.1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20.1a9 9 0 0 0 5 -7.1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.2 5a9 9 0 0 1 11.4 0"
      }
    }]
  })(props);
}
;
export function TbAtomOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.172 9.172c-3.906 3.905 -5.805 8.337 -4.243 9.9c1.562 1.561 5.994 -.338 9.9 -4.244m1.884 -2.113c2.587 -3.277 3.642 -6.502 2.358 -7.786c-1.284 -1.284 -4.508 -.23 -7.784 2.357"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.929 4.929c-1.562 1.562 .337 5.994 4.243 9.9c3.905 3.905 8.337 5.804 9.9 4.242m-.072 -4.071c-.767 -1.794 -2.215 -3.872 -4.172 -5.828c-1.944 -1.945 -4.041 -3.402 -5.828 -4.172"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbAtom(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 2a4 10 0 0 0 -4 10a4 10 0 0 0 4 10a4 10 0 0 0 4 -10a4 10 0 0 0 -4 -10",
        "transform": "rotate(45 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 2a4 10 0 0 0 -4 10a4 10 0 0 0 4 10a4 10 0 0 0 4 -10a4 10 0 0 0 -4 -10",
        "transform": "rotate(-45 12 12)"
      }
    }]
  })(props);
}
;
export function TbAugmentedReality(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12.5l4 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10l4 2.5v4.5l4 -2.5v-4.5l-4 -2.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10v4.5l4 2.5"
      }
    }]
  })(props);
}
;
export function TbAwardOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.72 12.704a6 6 0 0 0 -8.433 -8.418m-1.755 2.24a6 6 0 0 0 7.936 7.944"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.002 15.003l3.4 5.89l1.598 -3.233l.707 .046m1.108 -2.902l-1.617 -2.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.802 12.003l-3.4 5.89l3.598 -.233l1.598 3.232l3.4 -5.889"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbAward(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "9",
        "r": "6"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 14.2 9 21 12 19 15 21 15 14.2",
        "transform": "rotate(-30 12 9)"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 14.2 9 21 12 19 15 21 15 14.2",
        "transform": "rotate(30 12 9)"
      }
    }]
  })(props);
}
;
export function TbAxe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.66 15.66l-3.32 -3.32a1.25 1.25 0 0 1 .42 -2.044l3.24 -1.296l6 -6l3 3l-6 6l-1.296 3.24a1.25 1.25 0 0 1 -2.044 .42z"
      }
    }]
  })(props);
}
;
export function TbAxisX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 9v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 5v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 20l3 -3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17h16"
      }
    }]
  })(props);
}
;
export function TbAxisY(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 20h-.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 20h-.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 20h-.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7l3 -3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20v-16"
      }
    }]
  })(props);
}
;
export function TbBabyCarriage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 5h2.5l1.632 4.897a6 6 0 0 0 5.693 4.103h2.675a5.5 5.5 0 0 0 0 -11h-.5v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9h14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17l1 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 14l1 3"
      }
    }]
  })(props);
}
;
export function TbBackhoe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "4",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "13",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "19",
        "x2": "4",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "15",
        "x2": "13",
        "y2": "15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12v-5h2a3 3 0 0 1 3 3v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 15v-2a1 1 0 0 1 1 -1h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21.12 9.88l-3.12 -4.88l-5 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21.12 9.88a3 3 0 0 1 -2.12 5.12a3 3 0 0 1 -2.12 -.88l4.24 -4.24z"
      }
    }]
  })(props);
}
;
export function TbBackpack(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h2a6 6 0 0 1 6 6v6a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-6a6 6 0 0 1 6 -6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 7v-1a2 2 0 1 1 4 0v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 15h4"
      }
    }]
  })(props);
}
;
export function TbBackspace(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-11l-5 -5a1.5 1.5 0 0 1 0 -2l5 -5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbBadgeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7v10l5 3l5 -3m0 -4v-9l-5 3l-2.496 -1.497"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBadge(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v-13l-5 3l-5 -3v13l5 3z"
      }
    }]
  })(props);
}
;
export function TbBadgesOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.505 14.497l-2.505 1.503l-5 -3v4l5 3l5 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.873 9.876l3.127 -1.876v-4l-5 3l-2.492 -1.495m-2.508 1.495v1l2.492 1.495"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBadges(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v-4l-5 3l-5 -3v4l5 3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 8v-4l-5 3l-5 -3v4l5 3z"
      }
    }]
  })(props);
}
;
export function TbBallAmericanFootball(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "9",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "12",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "10",
        "x2": "14",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 21a5 5 0 0 0 -5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3c-7.18 0 -13 5.82 -13 13a5 5 0 0 0 5 5c7.18 0 13 -5.82 13 -13a5 5 0 0 0 -5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3a5 5 0 0 0 5 5"
      }
    }]
  })(props);
}
;
export function TbBallBaseball(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.636 18.364a9 9 0 1 0 12.728 -12.728a9 9 0 0 0 -12.728 12.728z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.495 3.02a9 9 0 0 1 -9.475 9.475"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.98 11.505a9 9 0 0 0 -9.475 9.475"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 13l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7l2 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11l1 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 11l1 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 16l2 1"
      }
    }]
  })(props);
}
;
export function TbBallBasketball(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5.65",
        "y1": "5.65",
        "x2": "18.35",
        "y2": "18.35"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5.65",
        "y1": "18.35",
        "x2": "18.35",
        "y2": "5.65"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a9 9 0 0 0 9 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12a9 9 0 0 1 9 9"
      }
    }]
  })(props);
}
;
export function TbBallBowling(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "9",
        "x2": "11",
        "y2": "9.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "8",
        "x2": "15",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "12",
        "x2": "14",
        "y2": "12.01"
      }
    }]
  })(props);
}
;
export function TbBallFootballOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.041 16.046a9 9 0 0 0 -12.084 -12.09m-2.323 1.683a9 9 0 0 0 12.726 12.73"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7l4.755 3.455l-.566 1.743l-.98 3.014l-.209 .788h-6l-1.755 -5.545l1.86 -1.351l2.313 -1.681z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "16",
        "x2": "17.5",
        "y2": "19"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.755 10.455l3.745 -1.455"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.061 16.045l-2.561 2.955"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.245 10.455l-3.745 -1.455"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbBallFootball(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7l4.76 3.45l-1.76 5.55h-6l-1.76 -5.55z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m3 13l2.5 3m-.74 -8.55l3.74 -1.45m-11.44 7.05l-2.56 2.95m.74 -8.55l-3.74 -1.45"
      }
    }]
  })(props);
}
;
export function TbBallTennis(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 5.3a9 9 0 0 1 0 13.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 5.3a9 9 0 0 0 0 13.4"
      }
    }]
  })(props);
}
;
export function TbBallVolleyball(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12a8 8 0 0 0 8 4m-12.5 -2.5a12 12 0 0 0 8.5 6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12a8 8 0 0 0 8 4m-12.5 -2.5a12 12 0 0 0 8.5 6.5",
        "transform": "rotate(120 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12a8 8 0 0 0 8 4m-12.5 -2.5a12 12 0 0 0 8.5 6.5",
        "transform": "rotate(240 12 12)"
      }
    }]
  })(props);
}
;
export function TbBallonOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 8a2 2 0 0 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.762 3.753a6 6 0 0 1 10.238 4.247c0 1.847 -.37 3.564 -1.007 4.993m-1.59 2.42c-.967 1.001 -2.14 1.587 -3.403 1.587c-3.314 0 -6 -4.03 -6 -9c0 -.593 .086 -1.166 .246 -1.707"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v1a2 2 0 0 1 -2 2h-3a2 2 0 0 0 -2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBallon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 8a2 2 0 0 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8a6 6 0 1 1 12 0c0 4.97 -2.686 9 -6 9s-6 -4.03 -6 -9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v1a2 2 0 0 1 -2 2h-3a2 2 0 0 0 -2 2"
      }
    }]
  })(props);
}
;
export function TbBallpenOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 6l7 7l-2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10l-4.172 4.172a2.828 2.828 0 1 0 4 4l4.172 -4.172"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12l4.414 -4.414a2 2 0 0 0 0 -2.829l-1.171 -1.171a2 2 0 0 0 -2.829 0l-4.414 4.414"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20l1.768 -1.768"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBallpen(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 6l7 7l-4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.828 18.172a2.828 2.828 0 0 0 4 0l10.586 -10.586a2 2 0 0 0 0 -2.829l-1.171 -1.171a2 2 0 0 0 -2.829 0l-10.586 10.586a2.828 2.828 0 0 0 0 4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20l1.768 -1.768"
      }
    }]
  })(props);
}
;
export function TbBan(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5.7",
        "y1": "5.7",
        "x2": "18.3",
        "y2": "18.3"
      }
    }]
  })(props);
}
;
export function TbBandage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "12",
        "x2": "14",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "10",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "10",
        "x2": "12",
        "y2": "10.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "12",
        "y2": "14.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7"
      }
    }]
  })(props);
}
;
export function TbBarbellOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 12h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.298 6.288a0.997 .997 0 0 0 -.298 .712v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 15v2a1 1 0 0 0 1 1h1c.275 0 .523 -.11 .704 -.29m.296 -3.71v-7a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBarbell(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 12h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12h-1"
      }
    }]
  })(props);
}
;
export function TbBarcodeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7v-1c0 -.552 .224 -1.052 .586 -1.414"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17v1a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2c.551 0 1.05 -.223 1.412 -.584"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 11h1v2h-1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 11v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBarcode(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7v-1a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17v1a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "11",
        "width": "1",
        "height": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "11",
        "x2": "10",
        "y2": "13"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "11",
        "width": "1",
        "height": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "11",
        "x2": "19",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbBarrelOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h8.722a2 2 0 0 1 1.841 1.22c.958 2.26 1.437 4.52 1.437 6.78a16.35 16.35 0 0 1 -.407 3.609m-.964 3.013l-.066 .158a2 2 0 0 1 -1.841 1.22h-9.444a2 2 0 0 1 -1.841 -1.22c-.958 -2.26 -1.437 -4.52 -1.437 -6.78c0 -2.21 .458 -4.42 1.374 -6.63"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 4c.585 2.337 .913 4.674 .985 7.01m-.114 3.86a33.415 33.415 0 0 1 -.871 5.13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4a34.42 34.42 0 0 0 -.366 1.632m-.506 3.501a32.126 32.126 0 0 0 -.128 2.867c0 2.667 .333 5.333 1 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 16h11.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.5 8h-7.5m-4 0h-3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBarrel(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.278 4h9.444a2 2 0 0 1 1.841 1.22c.958 2.26 1.437 4.52 1.437 6.78c0 2.26 -.479 4.52 -1.437 6.78a2 2 0 0 1 -1.841 1.22h-9.444a2 2 0 0 1 -1.841 -1.22c-.958 -2.26 -1.437 -4.52 -1.437 -6.78c0 -2.26 .479 -4.52 1.437 -6.78a2 2 0 0 1 1.841 -1.22z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 4c.667 2.667 1 5.333 1 8s-.333 5.333 -1 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4c-.667 2.667 -1 5.333 -1 8s.333 5.333 1 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 16h15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.5 8h-15"
      }
    }]
  })(props);
}
;
export function TbBarrierBlockOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h8a1 1 0 0 1 1 1v7c0 .27 -.107 .516 -.282 .696"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16h-11a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 16l4.244 -4.244"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.745 9.755l2.755 -2.755"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 16l1.249 -1.249"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.741 12.759l3.259 -3.259"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13.5l4.752 -4.752"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 20h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 20h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 7v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBarrierBlock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "7",
        "width": "16",
        "height": "9",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 16l9 -9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 16l6.5 -6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13.5l6.5 -6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 16v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 20h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 20h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 7v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7v-2"
      }
    }]
  })(props);
}
;
export function TbBaseline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16v-8a4 4 0 1 1 8 0v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10h8"
      }
    }]
  })(props);
}
;
export function TbBasketOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 10l1.359 -1.63"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.176 6.188l1.824 -2.188l5 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.77 18.757c-.358 .768 -1.027 1.262 -1.77 1.243h-10c-.966 .024 -1.807 -.817 -2 -2l-2 -8h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10h7l-1.397 5.587"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "15",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBasket(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 10 12 4 17 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10l-2 8a2 2.5 0 0 1 -2 2h-10a2 2.5 0 0 1 -2 -2l-2 -8z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "15",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbBathOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12h4a1 1 0 0 1 1 1v3c0 .311 -.036 .614 -.103 .904m-1.61 2.378a3.982 3.982 0 0 1 -2.287 .718h-10a4 4 0 0 1 -4 -4v-3a1 1 0 0 1 1 -1h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12v-6m1.178 -2.824c.252 -.113 .53 -.176 .822 -.176h3v2.25"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21l1 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 21l-1 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBath(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h16a1 1 0 0 1 1 1v3a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4v-3a1 1 0 0 1 1 -1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12v-7a2 2 0 0 1 2 -2h3v2.25"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21l1 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 21l-1 -1.5"
      }
    }]
  })(props);
}
;
export function TbBattery1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "10",
        "x2": "7",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbBattery2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "10",
        "x2": "7",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "10",
        "x2": "10",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbBattery3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "10",
        "x2": "7",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "10",
        "x2": "10",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "10",
        "x2": "13",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbBattery4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "10",
        "x2": "7",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "10",
        "x2": "10",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "10",
        "x2": "13",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "10",
        "x2": "16",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbBatteryAutomotive(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "6",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6v-2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "4",
        "x2": "19",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6.5",
        "y1": "13",
        "x2": "9.5",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.5",
        "y1": "13",
        "x2": "17.5",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "11.5",
        "x2": "16",
        "y2": "14.5"
      }
    }]
  })(props);
}
;
export function TbBatteryCharging2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 9a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 15h6v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2v-2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 22v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15v-2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 15v-2.5"
      }
    }]
  })(props);
}
;
export function TbBatteryCharging(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7h1a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 7h-2a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8l-2 4h3l-2 4"
      }
    }]
  })(props);
}
;
export function TbBatteryEco(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 9a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 16.143c0 -2.84 2.09 -5.143 4.667 -5.143h2.333v.857c0 2.84 -2.09 5.143 -4.667 5.143h-2.333v-.857z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20v-3"
      }
    }]
  })(props);
}
;
export function TbBatteryOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h6a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5m-2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h1"
      }
    }]
  })(props);
}
;
export function TbBattery(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
      }
    }]
  })(props);
}
;
export function TbBeachOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.071 15.102a7.502 7.502 0 0 0 -8.124 1.648"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.27 6.269l9.926 5.731a6 6 0 0 0 -10.32 -6.123"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 9l-.739 1.279"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.794 12.82l-.794 1.376"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1.135 -.858"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBeach(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.553 16.75a7.5 7.5 0 0 0 -10.606 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 3.804a6 6 0 0 0 -8.196 2.196l10.392 6a6 6 0 0 0 -2.196 -8.196z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 9l-3 5.196"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 1 .25"
      }
    }]
  })(props);
}
;
export function TbBedOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7v11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14h11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 14h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 18v-8a2 2 0 0 0 -2 -2h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11v3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "10",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBed(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7v11m0 -4h18m0 4v-8a2 2 0 0 0 -2 -2h-8v6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "10",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbBeerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7v1.111c0 1.242 .29 2.467 .845 3.578l.31 .622a8 8 0 0 1 .845 3.578v4.111h6v-4.111a8 8 0 0 1 .045 -.85m.953 -3.035l.157 -.315a7.999 7.999 0 0 0 .845 -3.578v-4.111h-9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 8h1m4 0h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBeer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 20h6v-4.111a8 8 0 0 1 .845 -3.578l.31 -.622a8 8 0 0 0 .845 -3.578v-4.111h-10v4.111a8 8 0 0 0 .845 3.578l.31 .622a8 8 0 0 1 .845 3.578v4.111z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 8h10"
      }
    }]
  })(props);
}
;
export function TbBellMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17v1a3 3 0 0 0 6 0v-1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "11",
        "x2": "14",
        "y2": "11"
      }
    }]
  })(props);
}
;
export function TbBellOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h-13a4 4 0 0 0 2 -3v-3a7 7 0 0 1 1.279 -3.716m2.072 -1.934c.209 -.127 .425 -.244 .649 -.35a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17v1a3 3 0 0 0 6 0v-1"
      }
    }]
  })(props);
}
;
export function TbBellPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17v1a3 3 0 0 0 6 0v-1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "11",
        "x2": "14",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbBellRinging2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.364 4.636a2 2 0 0 1 0 2.828a7 7 0 0 1 -1.414 7.072l-2.122 2.12a4 4 0 0 0 -.707 3.536l-11.313 -11.312a4 4 0 0 0 3.535 -.707l2.121 -2.123a7 7 0 0 1 7.072 -1.414a2 2 0 0 1 2.828 0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.343 12.414l-.707 .707a3 3 0 0 0 4.243 4.243l.707 -.707"
      }
    }]
  })(props);
}
;
export function TbBellRinging(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17v1a3 3 0 0 0 6 0v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 6.727a11.05 11.05 0 0 0 -2.794 -3.727"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6.727a11.05 11.05 0 0 1 2.792 -3.727"
      }
    }]
  })(props);
}
;
export function TbBellSchool(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "10",
        "r": "6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 15h.5a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2h.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 17a5.698 5.698 0 0 0 4.467 -7.932l-.467 -1.068"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10v.01"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "20",
        "cy": "8",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbBellX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17v1a3 3 0 0 0 6 0v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 9.5l3 3m0 -3l-3 3"
      }
    }]
  })(props);
}
;
export function TbBellZ(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17v1a3 3 0 0 0 6 0v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 9h4l-4 4h4"
      }
    }]
  })(props);
}
;
export function TbBell(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17v1a3 3 0 0 0 6 0v-1"
      }
    }]
  })(props);
}
;
export function TbBible(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 16h-12a2 2 0 0 0 -2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 9h4"
      }
    }]
  })(props);
}
;
export function TbBikeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "18",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.437 16.44a3 3 0 0 0 4.123 4.123m1.44 -2.563a3 3 0 0 0 -3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19v-4l-3 -3l1.665 -1.332m2.215 -1.772l1.12 -.896l2 3h3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBike(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "18",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "18",
        "r": "3"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 19 12 15 9 12 14 8 16 11 19 11"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "5",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbBinary(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 10v-5h-1m8 14v-5h-1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "15",
        "y": "5",
        "width": "3",
        "height": "5",
        "rx": ".5"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "14",
        "width": "3",
        "height": "5",
        "rx": ".5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10h.01m-.01 9h.01"
      }
    }]
  })(props);
}
;
export function TbBiohazardOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.586 10.586a2 2 0 1 0 2.836 2.82"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.939 14c0 .173 .048 .351 .056 .533v.217a4.75 4.75 0 0 1 -4.533 4.745h-.217"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2.495 14.745a4.75 4.75 0 0 1 7.737 -3.693"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.745 19.495a4.75 4.75 0 0 1 -4.69 -5.503h-.06"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.533 10.538a4.75 4.75 0 0 1 6.957 3.987v.217"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.295 10.929a4.75 4.75 0 0 1 -2.988 -3.64m.66 -3.324a4.75 4.75 0 0 1 .5 -.66l.164 -.172"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.349 3.133a4.75 4.75 0 0 1 -.836 7.385"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBiohazard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.939 14c0 .173 .048 .351 .056 .533l0 .217a4.75 4.75 0 0 1 -4.533 4.745l-.217 0m-4.75 -4.75a4.75 4.75 0 0 1 7.737 -3.693m6.513 8.443a4.75 4.75 0 0 1 -4.69 -5.503l-.06 0m1.764 -2.944a4.75 4.75 0 0 1 7.731 3.477l0 .217m-11.195 -3.813a4.75 4.75 0 0 1 -1.828 -7.624l.164 -.172m6.718 0a4.75 4.75 0 0 1 -1.665 7.798"
      }
    }]
  })(props);
}
;
export function TbBlockquote(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15h15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 19h-15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 7h-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
      }
    }]
  })(props);
}
;
export function TbBluetoothConnected(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 8 17 16 12 20 12 4 17 8 7 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "5",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbBluetoothOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.438 16.45l-4.438 3.55v-8m0 -4v-4l5 4l-2.776 2.22m-2.222 1.779l-5 4"
      }
    }]
  })(props);
}
;
export function TbBluetoothX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 8l10 8l-5 4v-16l1.003 .802m0 6.396l-6.003 4.802"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 6l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 6l-4 4"
      }
    }]
  })(props);
}
;
export function TbBluetooth(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 8 17 16 12 20 12 4 17 8 7 16"
      }
    }]
  })(props);
}
;
export function TbBlur(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21a9.01 9.01 0 0 0 2.32 -.302a9.004 9.004 0 0 0 1.74 -16.733a9 9 0 1 0 -4.06 17.035z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15h8"
      }
    }]
  })(props);
}
;
export function TbBoldOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h4a3.5 3.5 0 0 1 2.222 6.204m-3.222 .796h-5v-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.107 17.112a3.5 3.5 0 0 1 -3.107 1.888h-7v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBold(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 5h6a3.5 3.5 0 0 1 0 7h-6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7"
      }
    }]
  })(props);
}
;
export function TbBoltOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.212 15.21l-4.212 5.79v-7h-6l3.79 -5.21m1.685 -2.32l2.525 -3.47v6m1 1h5l-2.104 2.893"
      }
    }]
  })(props);
}
;
export function TbBolt(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "13 3 13 10 19 10 11 21 11 14 5 14 13 3"
      }
    }]
  })(props);
}
;
export function TbBoneOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 8.502l.38 -.38a3 3 0 1 1 5.12 -2.122a3 3 0 1 1 -2.12 5.122l-.372 .372m-2.008 2.008l-2.378 2.378a3 3 0 1 1 -5.117 2.297l-.005 -.177l-.176 -.005a3 3 0 1 1 2.298 -5.115l2.378 -2.378"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3a3 3 0 0 1 3 3a3 3 0 1 1 -2.12 5.122l-4.758 4.758a3 3 0 1 1 -5.117 2.297l-.005 -.177l-.176 -.005a3 3 0 1 1 2.298 -5.115l4.758 -4.758a3 3 0 0 1 2.12 -5.122z"
      }
    }]
  })(props);
}
;
export function TbBook2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 16h-12a2 2 0 0 0 -2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 8h6"
      }
    }]
  })(props);
}
;
export function TbBookDownload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 16h-7a2 2 0 0 0 -2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 19l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 22v-9"
      }
    }]
  })(props);
}
;
export function TbBookOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19a9 9 0 0 1 9 0a8.999 8.999 0 0 1 5.899 -1.096"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6a8.995 8.995 0 0 1 2.114 -.884m3.8 -.21c1.07 .17 2.116 .534 3.086 1.094a9 9 0 0 1 9 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6v13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v2m0 4v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 6v11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBookUpload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 16h-5a2 2 0 0 0 -2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 16l3 -3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 13v9"
      }
    }]
  })(props);
}
;
export function TbBook(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "6",
        "x2": "3",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "6",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "6",
        "x2": "21",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbBookmarkOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v3l-5 -3l-5 3v-13m1.178 -2.818c.252 -.113 .53 -.176 .822 -.176h6a2 2 0 0 1 2 2v7"
      }
    }]
  })(props);
}
;
export function TbBookmark(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4h6a2 2 0 0 1 2 2v14l-5 -3l-5 3v-14a2 2 0 0 1 2 -2"
      }
    }]
  })(props);
}
;
export function TbBookmarksOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h2a2 2 0 0 1 2 2v2m0 4v6l-5 -3l-5 3v-12a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.265 4a2 2 0 0 1 1.735 -1h6a2 2 0 0 1 2 2v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBookmarks(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 7a2 2 0 0 1 2 2v12l-5 -3l-5 3v-12a2 2 0 0 1 2 -2h6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.265 4a2 2 0 0 1 1.735 -1h6a2 2 0 0 1 2 2v12l-1 -.6"
      }
    }]
  })(props);
}
;
export function TbBooksOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9v10a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4a1 1 0 0 1 1 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 13v6a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 8h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.254 10.244l-1.218 -4.424a1.02 1.02 0 0 1 .634 -1.219l.133 -.041l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.236 11.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.585 19.589l-1.572 .38c-.562 .136 -1.133 -.19 -1.282 -.731l-.952 -3.458"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 9l4 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.207 15.199l.716 -.18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBooks(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "4",
        "width": "4",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "4",
        "width": "4",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 8h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.803 4.56l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.695 13.418a1.02 1.02 0 0 1 -.634 1.219l-.133 .041l-2.184 .53c-.562 .135 -1.133 -.19 -1.282 -.732l-3.695 -13.418a1.02 1.02 0 0 1 .634 -1.219l.133 -.041z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 9l4 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16l3.923 -.98"
      }
    }]
  })(props);
}
;
export function TbBorderAll(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbBorderBottom(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "20",
        "x2": "4",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "4",
        "x2": "16",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "4",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "20",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "4",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "8",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "16",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "20",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "4",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "16",
        "x2": "20",
        "y2": "16.01"
      }
    }]
  })(props);
}
;
export function TbBorderHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "4",
        "x2": "16",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "4",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "20",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "4",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "16",
        "x2": "20",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "4",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "8",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "20",
        "x2": "16",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "20",
        "x2": "20",
        "y2": "20.01"
      }
    }]
  })(props);
}
;
export function TbBorderInner(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "4",
        "x2": "16",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "4",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "20",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "4",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "16",
        "x2": "20",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "4",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "8",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "20",
        "x2": "16",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "20",
        "x2": "20",
        "y2": "20.01"
      }
    }]
  })(props);
}
;
export function TbBorderLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "4",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "4",
        "x2": "16",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "20",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "8",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "16",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "20",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "16",
        "x2": "20",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "8",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "20",
        "x2": "16",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "20",
        "x2": "20",
        "y2": "20.01"
      }
    }]
  })(props);
}
;
export function TbBorderNone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "4",
        "x2": "16",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "4",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "20",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "4",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "8",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "16",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "20",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "4",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "16",
        "x2": "20",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "4",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "8",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "20",
        "x2": "16",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "20",
        "x2": "20",
        "y2": "20.01"
      }
    }]
  })(props);
}
;
export function TbBorderOuter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "8",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "16",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "16.01"
      }
    }]
  })(props);
}
;
export function TbBorderRadius(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v-4a4 4 0 0 1 4 -4h4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "4",
        "x2": "16",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "20",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "20",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "4",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "16",
        "x2": "20",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "4",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "8",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "20",
        "x2": "16",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "20",
        "x2": "20",
        "y2": "20.01"
      }
    }]
  })(props);
}
;
export function TbBorderRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "4",
        "x2": "16",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "4",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "4",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "8",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "16",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "4",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "4",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "8",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "20",
        "x2": "16",
        "y2": "20.01"
      }
    }]
  })(props);
}
;
export function TbBorderStyle2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 18v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 18v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 18v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6h16"
      }
    }]
  })(props);
}
;
export function TbBorderStyle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20v-14a2 2 0 0 1 2 -2h14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20v.01"
      }
    }]
  })(props);
}
;
export function TbBorderTop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "4",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "20",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "4",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "8",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "16",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "20",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "4",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "16",
        "x2": "20",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "4",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "8",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "20",
        "x2": "16",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "20",
        "x2": "20",
        "y2": "20.01"
      }
    }]
  })(props);
}
;
export function TbBorderVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "4",
        "x2": "16",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "4",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "20",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "4",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "8",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "16",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "20",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "4",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "16",
        "x2": "20",
        "y2": "16.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "4",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "8",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "20",
        "x2": "16",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "20",
        "x2": "20",
        "y2": "20.01"
      }
    }]
  })(props);
}
;
export function TbBottle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5h4v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3.5c0 1.626 .507 3.212 1.45 4.537l.05 .07a8.093 8.093 0 0 1 1.5 4.694v6.199a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-6.2c0 -1.682 .524 -3.322 1.5 -4.693l.05 -.07a7.823 7.823 0 0 0 1.45 -4.537"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.003 14.803a2.4 2.4 0 0 0 .997 -.803a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1 -.805"
      }
    }]
  })(props);
}
;
export function TbBow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3l-15 15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h3v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 20c1.576 -1.576 2.5 -4.095 2.5 -6.5c0 -4.81 -3.69 -8.5 -8.5 -8.5c-2.415 0 -4.922 .913 -6.5 2.5l12.5 12.5z"
      }
    }]
  })(props);
}
;
export function TbBoxMargin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8h8v8h-8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v.01"
      }
    }]
  })(props);
}
;
export function TbBoxModel2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8h8v8h-8z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbBoxModel(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8h8v8h-8z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16l3.3 3.3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8l3.3 -3.3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8l-3.3 -3.3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16l-3.3 3.3"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple0(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 6a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 14v-8l-2 2"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10a2 2 0 1 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12a2 2 0 1 0 2 -2"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 14v-8l-4 6h5"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple5(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14h2a2 2 0 1 0 0 -4h-2v-4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple6(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8a2 2 0 1 0 -4 0v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple7(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6h4l-2 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple8(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "8",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple9(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "8",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12a2 2 0 1 0 4 0v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }]
  })(props);
}
;
export function TbBoxMultiple(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "3",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }]
  })(props);
}
;
export function TbBoxOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.765 17.757l-5.765 3.243l-8 -4.5v-9l2.236 -1.258m2.57 -1.445l3.194 -1.797l8 4.5v8.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.561 10.559l5.439 -3.059"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-8 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBoxPadding(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v.01"
      }
    }]
  })(props);
}
;
export function TbBox(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "20",
        "y2": "7.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "4",
        "y2": "7.5"
      }
    }]
  })(props);
}
;
export function TbBracesOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.176 5.177c-.113 .251 -.176 .53 -.176 .823v3c0 1.657 -.895 3 -2 3c1.105 0 2 1.343 2 3v3a2 2 0 0 0 2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4a2 2 0 0 1 2 2v3c0 1.657 .895 3 2 3c-1.105 0 -2 1.343 -2 3m-.176 3.821a2 2 0 0 1 -1.824 1.179"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBraces(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 4a2 2 0 0 0 -2 2v3a2 3 0 0 1 -2 3a2 3 0 0 1 2 3v3a2 2 0 0 0 2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4a2 2 0 0 1 2 2v3a2 3 0 0 0 2 3a2 3 0 0 0 -2 3v3a2 2 0 0 1 -2 2"
      }
    }]
  })(props);
}
;
export function TbBracketsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5v15h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h3v11m0 4v1h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBrackets(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h-3v16h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h3v16h-3"
      }
    }]
  })(props);
}
;
export function TbBrandAdobe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.893 4.514l7.977 13.994a0.993 .993 0 0 1 -.394 1.365a1.04 1.04 0 0 1 -.5 .127h-3.476l-4.5 -8l-2.5 4h1.5l2 4h-8.977c-.565 0 -1.023 -.45 -1.023 -1.003c0 -.171 .045 -.34 .13 -.49l7.977 -13.993a1.034 1.034 0 0 1 1.786 0z"
      }
    }]
  })(props);
}
;
export function TbBrandAirbnb(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10c-2 0 -3 1 -3 3c0 1.5 1.494 3.535 3 5.5c1 1 1.5 1.5 2.5 2s2.5 1 4.5 -.5s1.5 -3.5 .5 -6s-2.333 -5.5 -5 -9.5c-.834 -1 -1.5 -1.5 -2.503 -1.5c-1 0 -1.623 .45 -2.497 1.5c-2.667 4 -4 7 -5 9.5s-1.5 4.5 .5 6s3.5 1 4.5 .5s1.5 -1 2.5 -2c1.506 -1.965 3 -4 3 -5.5c0 -2 -1 -3 -3 -3z"
      }
    }]
  })(props);
}
;
export function TbBrandAirtable(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10v8l7 -3v-2.6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6l9 3l9 -3l-9 -3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 12.3v8.7l7 -3v-8z"
      }
    }]
  })(props);
}
;
export function TbBrandAndroid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "10",
        "x2": "4",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "10",
        "x2": "20",
        "y2": "16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 9h10v8a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-8a5 5 0 0 1 10 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "3",
        "x2": "9",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "3",
        "x2": "15",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "18",
        "x2": "9",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "18",
        "x2": "15",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbBrandAngular(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.428 17.245l6.076 3.471a1 1 0 0 0 .992 0l6.076 -3.471a1 1 0 0 0 .495 -.734l1.323 -9.704a1 1 0 0 0 -.658 -1.078l-7.4 -2.612a1 1 0 0 0 -.665 0l-7.399 2.613a1 1 0 0 0 -.658 1.078l1.323 9.704a1 1 0 0 0 .495 .734z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15l3 -8l3 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13h4"
      }
    }]
  })(props);
}
;
export function TbBrandAppleArcade(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12.5v4.75a0.734 .734 0 0 1 -.055 .325a0.704 .704 0 0 1 -.348 .366l-5.462 2.58a4.998 4.998 0 0 1 -4.27 0l-5.462 -2.58a0.705 .705 0 0 1 -.401 -.691l-.002 -4.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.431 12.216l5.634 -2.332a5.065 5.065 0 0 1 3.87 0l5.634 2.332a0.692 .692 0 0 1 .028 1.269l-5.462 2.543a5.064 5.064 0 0 1 -4.27 0l-5.462 -2.543a0.691 .691 0 0 1 .028 -1.27z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "7",
        "x2": "12",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbBrandApple(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 7c-3 0 -4 3 -4 5.5c0 3 2 7.5 4 7.5c1.088 -.046 1.679 -.5 3 -.5c1.312 0 1.5 .5 3 .5s4 -3 4 -5c-.028 -.01 -2.472 -.403 -2.5 -3c-.019 -2.17 2.416 -2.954 2.5 -3c-1.023 -1.492 -2.951 -1.963 -3.5 -2c-1.433 -.111 -2.83 1 -3.5 1c-.68 0 -1.9 -1 -3 -1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4a2 2 0 0 0 2 -2a2 2 0 0 0 -2 2"
      }
    }]
  })(props);
}
;
export function TbBrandAppstore(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16l1.106 -1.99m1.4 -2.522l2.494 -4.488"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 14h5m2.9 0h2.1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16l-2.51 -4.518m-1.487 -2.677l-1.003 -1.805"
      }
    }]
  })(props);
}
;
export function TbBrandAsana(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "16",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "16",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbBrandBehance(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18v-12h4.5a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-4.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "7.5",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 13h7a3.5 3.5 0 0 0 -7 0v2a3.5 3.5 0 0 0 6.64 1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "6",
        "x2": "19",
        "y2": "6"
      }
    }]
  })(props);
}
;
export function TbBrandBing(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 3l4 1.5v12l6 -2.5l-2 -1l-1 -4l7 2.5v4.5l-10 5l-4 -2z"
      }
    }]
  })(props);
}
;
export function TbBrandBitbucket(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.648 4a0.64 .64 0 0 0 -.64 .744l3.14 14.528c.07 .417 .43 .724 .852 .728h10a0.644 .644 0 0 0 .642 -.539l3.35 -14.71a0.641 .641 0 0 0 -.64 -.744l-16.704 -.007z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15h-4l-1 -6h6z"
      }
    }]
  })(props);
}
;
export function TbBrandBooking(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18v-9.5a4.5 4.5 0 0 1 4.5 -4.5h7a4.5 4.5 0 0 1 4.5 4.5v7a4.5 4.5 0 0 1 -4.5 4.5h-9.5a2 2 0 0 1 -2 -2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12h3.5a2 2 0 1 1 0 4h-3.5v-7a1 1 0 0 1 1 -1h1.5a2 2 0 1 1 0 4h-1.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "16",
        "x2": "16.01",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbBrandBootstrap(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16v-8h3.5a2 2 0 1 1 0 4h-3.5h4a2 2 0 1 1 0 4h-4z"
      }
    }]
  })(props);
}
;
export function TbBrandChrome(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "20.4",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "20.4",
        "y2": "9",
        "transform": "rotate(120 12 12)"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "20.4",
        "y2": "9",
        "transform": "rotate(240 12 12)"
      }
    }]
  })(props);
}
;
export function TbBrandCodepen(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 15l9 6l9 -6l-9 -6l-9 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9l9 6l9 -6l-9 -6l-9 6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "9",
        "x2": "3",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "9",
        "x2": "21",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbBrandCodesandbox(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 7.5v9l-4 2.25l-4 2.25l-4 -2.25l-4 -2.25v-9l4 -2.25l4 -2.25l4 2.25z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l4 -2.25l4 -2.25"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-4 -2.25l-4 -2.25"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12l-4 2v4.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12l4 2l0 4.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 5.25l4 2.25l4 -2.25"
      }
    }]
  })(props);
}
;
export function TbBrandCss3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.5 8h7l-4.5 4h4l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"
      }
    }]
  })(props);
}
;
export function TbBrandCucumber(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 10.99c-.01 5.52 -4.48 10 -10 10.01v-2.26l-.01 -.01c-4.28 -1.11 -6.86 -5.47 -5.76 -9.75a8.001 8.001 0 0 1 9.74 -5.76c3.53 .91 6.03 4.13 6.03 7.78v-.01z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 8l-.5 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 14l.5 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12.5l-1 .5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 14l-.5 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 8l.5 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12.5l-1 -.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10l-1 -.5"
      }
    }]
  })(props);
}
;
export function TbBrandDebian(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17c-2.397 -.943 -4 -3.153 -4 -5.635c0 -2.19 1.039 -3.14 1.604 -3.595c2.646 -2.133 6.396 -.27 6.396 3.23c0 2.5 -2.905 2.121 -3.5 1.5c-.595 -.621 -1 -1.5 -.5 -2.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbBrandDeviantart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 3v4l-3.857 6h3.857v4h-6.429l-2.571 4h-3v-4l3.857 -6h-3.857v-4h6.429l2.571 -4z"
      }
    }]
  })(props);
}
;
export function TbBrandDiscord(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 7.5c3.5 -1 5.5 -1 9 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16.5c3.5 1 6.5 1 10 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.5 17c0 1 1.5 3 2 3c1.5 0 2.833 -1.667 3.5 -3c.667 -1.667 .5 -5.833 -1.5 -11.5c-1.457 -1.015 -3 -1.34 -4.5 -1.5l-1 2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.5 17c0 1 -1.356 3 -1.832 3c-1.429 0 -2.698 -1.667 -3.333 -3c-.635 -1.667 -.476 -5.833 1.428 -11.5c1.388 -1.015 2.782 -1.34 4.237 -1.5l1 2.5"
      }
    }]
  })(props);
}
;
export function TbBrandDisqus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.847 21c-2.259 0 -4.323 -.667 -5.919 -2h-3.928l1.708 -3.266c-.545 -1.174 -.759 -2.446 -.758 -3.734c0 -4.97 3.84 -9 8.898 -9c5.052 0 9.152 4.03 9.152 9c0 4.972 -4.098 9 -9.153 9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.485 15h-1.485v-6h1.485c2.112 0 3.515 .823 3.515 2.981v.035c0 2.18 -1.403 2.984 -3.515 2.984z"
      }
    }]
  })(props);
}
;
export function TbBrandDocker(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12.54c-1.804 -.345 -2.701 -1.08 -3.523 -2.94c-.487 .696 -1.102 1.568 -.92 2.4c.028 .238 -.32 1.002 -.557 1h-14c0 5.208 3.164 7 6.196 7c4.124 .022 7.828 -1.376 9.854 -5c1.146 -.101 2.296 -1.505 2.95 -2.46z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 10h3v3h-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10h3v3h-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 10h3v3h-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 7h3v3h-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h3v3h-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 4h3v3h-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.571 18c1.5 0 2.047 -.074 2.958 -.78"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "16",
        "x2": "10",
        "y2": "16.01"
      }
    }]
  })(props);
}
;
export function TbBrandDoctrine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3l6.9 6"
      }
    }]
  })(props);
}
;
export function TbBrandDribbble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3.6c5 6 7 10.5 7.5 16.2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.4 19c3.5 -3.5 6 -6.5 14.5 -6.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.1 10.75c5 0 9.814 -.38 15.314 -5"
      }
    }]
  })(props);
}
;
export function TbBrandEdge(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.978 11.372a9 9 0 1 0 -1.593 5.773"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.978 11.372c.21 2.993 -5.034 2.413 -6.913 1.486c1.392 -1.6 .402 -4.038 -2.274 -3.851c-1.745 .122 -2.927 1.157 -2.784 3.202c.28 3.99 4.444 6.205 10.36 4.79"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.022 12.628c-.283 -4.043 8.717 -7.228 11.248 -2.688"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.628 20.978c-2.993 .21 -5.162 -4.725 -3.567 -9.748"
      }
    }]
  })(props);
}
;
export function TbBrandFacebook(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3"
      }
    }]
  })(props);
}
;
export function TbBrandFigma(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "3",
        "width": "12",
        "height": "6",
        "rx": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9a3 3 0 0 0 0 6h3m-3 0a3 3 0 1 0 3 3v-15"
      }
    }]
  })(props);
}
;
export function TbBrandFirebase(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.53 17.05l6.15 -11.72h-.02c.38 -.74 1.28 -1.02 2.01 -.63c.26 .14 .48 .36 .62 .62l1.06 2.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.47 6.45c.58 -.59 1.53 -.59 2.11 -.01c.22 .22 .36 .5 .41 .81l1.5 9.11c.1 .62 -.2 1.24 -.76 1.54l-6.07 2.9c-.46 .25 -1.01 .26 -1.46 0l-6.02 -2.92c-.55 -.31 -.85 -.92 -.75 -1.54l1.96 -12.04c.12 -.82 .89 -1.38 1.7 -1.25c.46 .07 .87 .36 1.09 .77l1.24 1.76"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.57 17.18l10.93 -10.68"
      }
    }]
  })(props);
}
;
export function TbBrandFirefox(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.028 7.82a9 9 0 1 0 12.823 -3.4c-1.636 -1.02 -3.064 -1.02 -4.851 -1.02h-1.647"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.914 9.485c-1.756 -1.569 -.805 -5.38 .109 -6.17c.086 .896 .585 1.208 1.111 1.685c.88 -.275 1.313 -.282 1.867 0c.82 -.91 1.694 -2.354 2.628 -2.093c-1.082 1.741 -.07 3.733 1.371 4.173c-.17 .975 -1.484 1.913 -2.76 2.686c-1.296 .938 -.722 1.85 0 2.234c.949 .506 3.611 -.995 4.545 .354c-1.698 .102 -1.536 3.107 -3.983 2.727c2.523 .957 4.345 .462 5.458 -.34c1.965 -1.52 2.879 -3.542 2.879 -5.557c-.014 -1.398 .194 -2.695 -1.26 -4.75"
      }
    }]
  })(props);
}
;
export function TbBrandFlickr(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "12",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbBrandFoursquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h10c.644 0 1.11 .696 .978 1.33l-1.984 9.859a1.014 1.014 0 0 1 -.994 .811h-2.254c-.308 0 -.6 .141 -.793 .382l-4.144 5.25c-.599 .752 -1.809 .331 -1.809 -.632v-16c0 -.564 .44 -1 1 -1z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "17",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbBrandFramer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15h12l-12 -12h12v6h-12v6l6 6v-6"
      }
    }]
  })(props);
}
;
export function TbBrandGit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "8",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "16",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11l-2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7l-1.9 -1.9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
      }
    }]
  })(props);
}
;
export function TbBrandGithub(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"
      }
    }]
  })(props);
}
;
export function TbBrandGitlab(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7z"
      }
    }]
  })(props);
}
;
export function TbBrandGmail(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h3a1 1 0 0 0 1 -1v-14a1 1 0 0 0 -1 -1h-3v16z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 20h3v-16h-3a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4l-4 4l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6.5l8 7.5l8 -7.5"
      }
    }]
  })(props);
}
;
export function TbBrandGoogleAnalytics(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "9",
        "width": "4",
        "height": "12",
        "rx": "1.105"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "17",
        "y": "3",
        "width": "4",
        "height": "18",
        "rx": "1.105"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbBrandGoogleDrive(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10l-6 10l-3 -5l6 -10z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15h12l-3 5h-12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 15l-6 -10h6l6 10z"
      }
    }]
  })(props);
}
;
export function TbBrandGooglePlay(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 3.71v16.58a0.7 .7 0 0 0 1.05 .606l14.622 -8.42a0.55 .55 0 0 0 0 -.953l-14.622 -8.419a0.7 .7 0 0 0 -1.05 .607z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "4.5",
        "y2": "20.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.5",
        "y1": "3.5",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbBrandGoogle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.788 5.108a9 9 0 1 0 3.212 6.892h-8"
      }
    }]
  })(props);
}
;
export function TbBrandGravatar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714"
      }
    }]
  })(props);
}
;
export function TbBrandHipchat(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.802 17.292s.077 -.055 .2 -.149c1.843 -1.425 2.998 -3.49 2.998 -5.789c0 -4.286 -4.03 -7.764 -8.998 -7.764c-4.97 0 -9.002 3.478 -9.002 7.764c0 4.288 4.03 7.646 9 7.646c.424 0 1.12 -.028 2.088 -.084c1.262 .82 3.104 1.493 4.716 1.493c.499 0 .734 -.41 .414 -.828c-.486 -.596 -1.156 -1.551 -1.416 -2.29z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 13.5c2.5 2.5 6.5 2.5 9 0"
      }
    }]
  })(props);
}
;
export function TbBrandHtml5(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.5 8h-7l.5 4h6l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"
      }
    }]
  })(props);
}
;
export function TbBrandInstagram(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.5",
        "y1": "7.5",
        "x2": "16.5",
        "y2": "7.501"
      }
    }]
  })(props);
}
;
export function TbBrandIntercom(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 8v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 7v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 7v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 8v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 15c4 2.667 6 2.667 10 0"
      }
    }]
  })(props);
}
;
export function TbBrandJavascript(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 8h3v8l-2 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 8h-2.5a0.5 .5 0 0 0 -.5 .5v3a0.5 .5 0 0 0 .5 .5h1.423a0.5 .5 0 0 1 .495 .57l-.418 2.93l-2 .5"
      }
    }]
  })(props);
}
;
export function TbBrandKickstarter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 9l2.975 -4.65c.615 -.9 1.405 -1.35 2.377 -1.35c.79 0 1.474 .286 2.054 .858c.576 .574 .866 1.256 .866 2.054c0 .588 -.153 1.109 -.46 1.559l-2.812 4.029l3.465 4.912c.356 .46 .535 .998 .535 1.613a2.92 2.92 0 0 1 -.843 2.098c-.561 .584 -1.242 .877 -2.04 .877c-.876 0 -1.545 -.29 -2.005 -.87l-4.112 -5.697v3.067c0 .876 -.313 1.69 -.611 2.175c-.543 .883 -1.35 1.325 -2.389 1.325c-.944 0 -1.753 -.327 -2.271 -.974c-.486 -.6 -.729 -1.392 -.729 -2.38v-11.371c0 -.934 .247 -1.706 .74 -2.313c.512 -.641 1.347 -.962 2.26 -.962c.868 0 1.821 .321 2.4 .962c.323 .356 .515 .714 .6 1.08c.052 .224 0 .643 0 1.26v2.698z"
      }
    }]
  })(props);
}
;
export function TbBrandKotlin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20h-16v-16h16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12l8 -8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "20",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbBrandLastfm(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8c-.83 -1 -1.388 -1 -2 -1c-.612 0 -2 .271 -2 2s1.384 2.233 3 3c1.616 .767 2.125 1.812 2 3s-1 2 -3 2s-3 -1 -3.5 -2s-1.585 -4.78 -2.497 -5.997a5 5 0 1 0 -1.003 6.997"
      }
    }]
  })(props);
}
;
export function TbBrandLinkedin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "11",
        "x2": "8",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "8",
        "x2": "8",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v-3a2 2 0 0 0 -4 0"
      }
    }]
  })(props);
}
;
export function TbBrandLoom(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.464 6.518a6.001 6.001 0 1 0 -3.023 7.965"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.482 17.464a6.001 6.001 0 1 0 -7.965 -3.023"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.54 17.482a6.001 6.001 0 1 0 3.024 -7.965"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.518 6.54a6.001 6.001 0 1 0 7.965 3.024"
      }
    }]
  })(props);
}
;
export function TbBrandMastercard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9.765a3 3 0 1 0 0 4.47"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbBrandMedium(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 9h1l3 3l3 -3h1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "15",
        "x2": "10",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "15",
        "x2": "16",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "9",
        "x2": "9",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbBrandMercedes(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l7 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-7 5"
      }
    }]
  })(props);
}
;
export function TbBrandMessenger(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13l3 -2l2 2l3 -2"
      }
    }]
  })(props);
}
;
export function TbBrandMeta(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10.174c1.766 -2.784 3.315 -4.174 4.648 -4.174c2 0 3.263 2.213 4 5.217c.704 2.869 .5 6.783 -2 6.783c-1.114 0 -2.648 -1.565 -4.148 -3.652a27.627 27.627 0 0 1 -2.5 -4.174z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10.174c-1.766 -2.784 -3.315 -4.174 -4.648 -4.174c-2 0 -3.263 2.213 -4 5.217c-.704 2.869 -.5 6.783 2 6.783c1.114 0 2.648 -1.565 4.148 -3.652c1 -1.391 1.833 -2.783 2.5 -4.174z"
      }
    }]
  })(props);
}
;
export function TbBrandNetbeans(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.5 9.43a1 1 0 0 1 .5 .874v3.268a1 1 0 0 1 -.515 .874l-3 1.917a1 1 0 0 1 -.97 0l-3 -1.917a1 1 0 0 1 -.515 -.873v-3.269a1 1 0 0 1 .514 -.874l3 -1.786c.311 -.173 .69 -.173 1 0l3 1.787h-.014z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-9l-7.5 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l7.5 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.5 16l-3.5 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14l-3.5 2"
      }
    }]
  })(props);
}
;
export function TbBrandNetflix(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 20v-16l7 16v-16"
      }
    }]
  })(props);
}
;
export function TbBrandNextjs(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15v-6l7.745 10.65a9 9 0 1 1 2.255 -1.993"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12v-3"
      }
    }]
  })(props);
}
;
export function TbBrandNotion(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7h3l6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 7v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 17h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 7h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7v10h-1l-7 -7"
      }
    }]
  })(props);
}
;
export function TbBrandNuxt(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.146 8.583l-1.3 -2.09a1.046 1.046 0 0 0 -1.786 .017l-5.91 9.908a1.046 1.046 0 0 0 .897 1.582h3.913"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.043 18c.743 0 1.201 -.843 .82 -1.505l-4.044 -7.013a0.936 .936 0 0 0 -1.638 0l-4.043 7.013c-.382 .662 .076 1.505 .819 1.505h8.086z"
      }
    }]
  })(props);
}
;
export function TbBrandNytimes(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.036 5.058a8.001 8.001 0 1 0 8.706 9.965"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-11l-7.5 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.5 3a2.5 2.5 0 1 1 0 5l-11 -5a2.5 2.5 0 0 0 -.67 4.91"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 13h-.01"
      }
    }]
  })(props);
}
;
export function TbBrandOpenSource(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a9 9 0 0 1 3.618 17.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603a9 9 0 0 1 3.617 -17.244z"
      }
    }]
  })(props);
}
;
export function TbBrandOpera(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "12",
        "rx": "3",
        "ry": "5"
      }
    }]
  })(props);
}
;
export function TbBrandPagekit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.077 20h-5.077v-16h11v14h-5.077"
      }
    }]
  })(props);
}
;
export function TbBrandPatreon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3h3v18h-3z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "9.5",
        "r": "6.5"
      }
    }]
  })(props);
}
;
export function TbBrandPaypal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13l2.5 0c2.5 0 5 -2.5 5 -5c0 -3 -1.9 -5 -5 -5h-5.5c-.5 0 -1 .5 -1 1l-2 14c0 .5 .5 1 1 1h2.8l1.2 -5c.1 -.6 .4 -1 1 -1zm7.5 -5.8c1.7 1 2.5 2.8 2.5 4.8c0 2.5 -2.5 4.5 -5 4.5h-2.6l-.6 3.6a1 1 0 0 1 -1 .8l-2.7 0a0.5 .5 0 0 1 -.5 -.6l.2 -1.4"
      }
    }]
  })(props);
}
;
export function TbBrandPhp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "12",
        "rx": "10",
        "ry": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.5 15l.395 -1.974l.605 -3.026h1.32a1 1 0 0 1 .986 1.164l-.167 1a1 1 0 0 1 -.986 .836h-1.653"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.5 15l.395 -1.974l.605 -3.026h1.32a1 1 0 0 1 .986 1.164l-.167 1a1 1 0 0 1 -.986 .836h-1.653"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7.5l-1 5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.6 10h2.4l-.5 3"
      }
    }]
  })(props);
}
;
export function TbBrandPinterest(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "20",
        "x2": "12",
        "y2": "11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.7 14c.437 1.263 1.43 2 2.55 2c2.071 0 3.75 -1.554 3.75 -4a5 5 0 1 0 -9.7 1.7"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbBrandPocket(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h14a2 2 0 0 1 2 2v6a9 9 0 0 1 -18 0v-6a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 11 12 15 16 11"
      }
    }]
  })(props);
}
;
export function TbBrandProducthunt(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbBrandPython(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9h-7a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15h7a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 9v-4a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v5a2 2 0 0 1 -2 2h-4a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "6",
        "x2": "11",
        "y2": "6.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "18",
        "x2": "13",
        "y2": "18.01"
      }
    }]
  })(props);
}
;
export function TbBrandReactNative(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.357 9c-2.637 .68 -4.357 1.845 -4.357 3.175c0 2.107 4.405 3.825 9.85 3.825c.74 0 1.26 -.039 1.95 -.097"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.837 15.9c-.413 -.596 -.806 -1.133 -1.18 -1.8c-2.751 -4.9 -3.488 -9.77 -1.63 -10.873c1.15 -.697 3.047 .253 4.974 2.254"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.429 15.387c-.702 2.688 -.56 4.716 .56 5.395c1.783 1.08 5.387 -1.958 8.043 -6.804c.36 -.67 .683 -1.329 .968 -1.978"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18.52c1.928 2 3.817 2.95 4.978 2.253c1.85 -1.102 1.121 -5.972 -1.633 -10.873c-.384 -.677 -.777 -1.204 -1.18 -1.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.66 15c2.612 -.687 4.34 -1.85 4.34 -3.176c0 -2.11 -4.408 -3.824 -9.845 -3.824c-.747 0 -1.266 .029 -1.955 .087"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12c.285 -.66 .607 -1.308 .968 -1.978c2.647 -4.844 6.253 -7.89 8.046 -6.801c1.11 .679 1.262 2.706 .56 5.393"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.26 12.015h-.01c-.01 .13 -.12 .24 -.26 .24a0.263 .263 0 0 1 -.25 -.26c0 -.14 .11 -.25 .24 -.25h-.01c.13 -.01 .25 .11 .25 .24"
      }
    }]
  })(props);
}
;
export function TbBrandReddit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8c2.648 0 5.028 .826 6.675 2.14a2.5 2.5 0 0 1 2.326 4.36c0 3.59 -4.03 6.5 -9 6.5c-4.875 0 -8.845 -2.8 -9 -6.294l-1 -.206a2.5 2.5 0 0 1 2.326 -4.36c1.646 -1.313 4.026 -2.14 6.674 -2.14z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8l1 -5l6 1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "4",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "13",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "13",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 17c.667 .333 1.333 .5 2 .5s1.333 -.167 2 -.5"
      }
    }]
  })(props);
}
;
export function TbBrandSafari(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 16 10 10 16 8 14 14 8 16"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbBrandSass(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10.523c2.46 -.826 4.002 -.826 4.002 -2.155c0 -1.366 -1.347 -1.366 -2.735 -1.366c-1.91 0 -3.352 .49 -4.537 1.748c-.848 .902 -1.027 2.449 -.153 3.307c.973 .956 3.206 1.789 2.884 3.493c-.233 1.235 -1.469 1.823 -2.617 1.202c-.782 -.424 -.454 -1.746 .626 -2.512s2.822 -.992 4.1 -.24c.98 .575 1.046 1.724 .434 2.193"
      }
    }]
  })(props);
}
;
export function TbBrandSentry(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18a1.93 1.93 0 0 0 .306 1.076a2 2 0 0 0 1.584 .924c.646 .033 -.537 0 .11 0h3a4.992 4.992 0 0 0 -3.66 -4.81c.558 -.973 1.24 -2.149 2.04 -3.531a8.997 8.997 0 0 1 5.62 8.341h4c.663 0 2.337 .005 3 0a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-1.84 3.176c4.482 2.05 7.6 6.571 7.6 11.824"
      }
    }]
  })(props);
}
;
export function TbBrandShazam(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12l2 -2a2.828 2.828 0 0 1 4 0a2.828 2.828 0 0 1 0 4l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 12l-2 2a2.828 2.828 0 1 1 -4 -4l3 -3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbBrandSketch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.262 10.878l8 8.789c.4 .44 1.091 .44 1.491 0l8 -8.79c.313 -.344 .349 -.859 .087 -1.243l-3.537 -5.194a1 1 0 0 0 -.823 -.436h-8.926a1 1 0 0 0 -.823 .436l-3.54 5.192c-.263 .385 -.227 .901 .087 1.246z"
      }
    }]
  })(props);
}
;
export function TbBrandSkype(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a9 9 0 0 1 8.603 11.65a4.5 4.5 0 0 1 -5.953 5.953a9 9 0 0 1 -11.253 -11.253a4.5 4.5 0 0 1 5.953 -5.954a8.987 8.987 0 0 1 2.65 -.396z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14.5c.5 2 2.358 2.5 4 2.5c2.905 0 4 -1.187 4 -2.5c0 -1.503 -1.927 -2.5 -4 -2.5s-4 -.997 -4 -2.5c0 -1.313 1.095 -2.5 4 -2.5c1.642 0 3.5 .5 4 2.5"
      }
    }]
  })(props);
}
;
export function TbBrandSlack(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v-6a2 2 0 0 1 4 0v6m0 -2a2 2 0 1 1 2 2h-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12h6a2 2 0 0 1 0 4h-6m2 0a2 2 0 1 1 -2 2v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v6a2 2 0 0 1 -4 0v-6m0 2a2 2 0 1 1 -2 -2h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12h-6a2 2 0 0 1 0 -4h6m-2 0a2 2 0 1 1 2 -2v6"
      }
    }]
  })(props);
}
;
export function TbBrandSnapchat(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.882 7.842a4.882 4.882 0 0 0 -9.764 0c0 4.273 -.213 6.409 -4.118 8.118c2 .882 2 .882 3 3c3 0 4 2 6 2s3 -2 6 -2c1 -2.118 1 -2.118 3 -3c-3.906 -1.709 -4.118 -3.845 -4.118 -8.118zm-13.882 8.119c4 -2.118 4 -4.118 1 -7.118m17 7.118c-4 -2.118 -4 -4.118 -1 -7.118"
      }
    }]
  })(props);
}
;
export function TbBrandSoundcloud(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11h1c1.38 0 3 1.274 3 3c0 1.657 -1.5 3 -3 3l-6 0v-10c3 0 4.5 1.5 5 4z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "8",
        "x2": "9",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "17",
        "x2": "6",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "16",
        "x2": "3",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbBrandSpotify(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11.973c2.5 -1.473 5.5 -.973 7.5 .527"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15c1.5 -1 4 -1 5 .5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 9c2 -1 6 -2 10 .5"
      }
    }]
  })(props);
}
;
export function TbBrandStackoverflow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.322 12.582l7.956 .836"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.787 9.168l7.826 1.664"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.096 5.764l7.608 2.472"
      }
    }]
  })(props);
}
;
export function TbBrandSteam(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 5a4.5 4.5 0 1 1 -.653 8.953l-4.347 3.009l0 .038a3 3 0 0 1 -2.824 2.995l-.176 .005a3 3 0 0 1 -2.94 -2.402l-2.56 -1.098v-3.5l3.51 1.755a2.989 2.989 0 0 1 2.834 -.635l2.727 -3.818a4.5 4.5 0 0 1 4.429 -5.302z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "fill": "currentColor",
        "cx": "16.5",
        "cy": "9.5",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbBrandStripe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.453 8.056c0 -.623 .518 -.979 1.442 -.979c1.69 0 3.41 .343 4.605 .923l.5 -4c-.948 -.449 -2.82 -1 -5.5 -1c-1.895 0 -3.373 .087 -4.5 1c-1.172 .956 -2 2.33 -2 4c0 3.03 1.958 4.906 5 6c1.961 .69 3 .743 3 1.5c0 .735 -.851 1.5 -2 1.5c-1.423 0 -3.963 -.609 -5.5 -1.5l-.5 4c1.321 .734 3.474 1.5 6 1.5c2.004 0 3.957 -.468 5.084 -1.36c1.263 -.979 1.916 -2.268 1.916 -4.14c0 -3.096 -1.915 -4.547 -5.003 -5.637c-1.646 -.605 -2.544 -1.07 -2.544 -1.807z"
      }
    }]
  })(props);
}
;
export function TbBrandSublimeText(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 8l-14 4.5v-5.5l14 -4.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 17l-14 4.5v-5.5l14 -4.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 11.5l-14 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12.5l14 4.5"
      }
    }]
  })(props);
}
;
export function TbBrandSvelte(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 8l-5 3l.821 -.495c1.86 -1.15 4.412 -.49 5.574 1.352a3.91 3.91 0 0 1 -1.264 5.42l-5.053 3.126c-1.86 1.151 -4.312 .591 -5.474 -1.251a3.91 3.91 0 0 1 1.263 -5.42l.26 -.16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 17l5 -3l-.822 .496c-1.86 1.151 -4.411 .491 -5.574 -1.351a3.91 3.91 0 0 1 1.264 -5.42l5.054 -3.127c1.86 -1.15 4.311 -.59 5.474 1.252a3.91 3.91 0 0 1 -1.264 5.42l-.26 .16"
      }
    }]
  })(props);
}
;
export function TbBrandTabler(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 9l3 3l-3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "15",
        "x2": "16",
        "y2": "15"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "4"
      }
    }]
  })(props);
}
;
export function TbBrandTailwind(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.667 6c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 2 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968zm-4 6.5c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 1.975 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968z"
      }
    }]
  })(props);
}
;
export function TbBrandTelegram(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4"
      }
    }]
  })(props);
}
;
export function TbBrandTidal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7l-2.5 2.5l2.5 2.5l2.5 -2.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14l-2.5 2.5l2.5 2.5l2.5 -2.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 7l-2.5 2.5l2.5 2.5l2.5 -2.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7l-2.5 2.5l2.5 2.5l2.5 -2.5z"
      }
    }]
  })(props);
}
;
export function TbBrandTiktok(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12a4 4 0 1 0 4 4v-12a5 5 0 0 0 5 5"
      }
    }]
  })(props);
}
;
export function TbBrandTinder(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.918 8.174c2.56 4.982 .501 11.656 -5.38 12.626c-7.702 1.687 -12.84 -7.716 -7.054 -13.229c.309 -.305 1.161 -1.095 1.516 -1.349c0 .528 .27 3.475 1 3.167c3 0 4 -4.222 3.587 -7.389c2.7 1.411 4.987 3.376 6.331 6.174z"
      }
    }]
  })(props);
}
;
export function TbBrandTripadvisor(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6.5",
        "cy": "13.5",
        "r": "1.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17.5",
        "cy": "13.5",
        "r": "1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.5 9a4.5 4.5 0 1 0 3.5 1.671l1 -1.671h-4.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 9a4.5 4.5 0 1 1 -3.5 1.671l-1 -1.671h4.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 15.5l1.5 2l1.5 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 6.75c2 -.667 4 -.667 6 0"
      }
    }]
  })(props);
}
;
export function TbBrandTumblr(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 21h4v-4h-4v-6h4v-4h-4v-4h-4v1a3 3 0 0 1 -3 3h-1v4h4v6a4 4 0 0 0 4 4"
      }
    }]
  })(props);
}
;
export function TbBrandTwitch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 5v11a1 1 0 0 0 1 1h2v4l4 -4h5.584c.266 0 .52 -.105 .707 -.293l2.415 -2.414c.187 -.188 .293 -.442 .293 -.708v-8.585a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "8",
        "x2": "16",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbBrandTwitter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.522 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c-.002 -.249 1.51 -2.772 1.818 -4.013z"
      }
    }]
  })(props);
}
;
export function TbBrandUber(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "9",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h6"
      }
    }]
  })(props);
}
;
export function TbBrandUbuntu(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.723 7.41a7.992 7.992 0 0 0 -3.74 -2.162m-3.971 0a7.993 7.993 0 0 0 -3.789 2.216m-1.881 3.215a8 8 0 0 0 -.342 2.32c0 .738 .1 1.453 .287 2.132m1.96 3.428a7.993 7.993 0 0 0 3.759 2.19m3.998 -.003a7.993 7.993 0 0 0 3.747 -2.186m1.962 -3.43a8.008 8.008 0 0 0 .287 -2.131c0 -.764 -.107 -1.503 -.307 -2.203"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "17",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbBrandUnsplash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z"
      }
    }]
  })(props);
}
;
export function TbBrandVercel(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19h18l-9 -15z"
      }
    }]
  })(props);
}
;
export function TbBrandVimeo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 8.5l1 1s1.5 -1.102 2 -.5c.509 .609 1.863 7.65 2.5 9c.556 1.184 1.978 2.89 4 1.5c2 -1.5 7.5 -5.5 8.5 -11.5c.444 -2.661 -1 -4 -2.5 -4c-2 0 -4.047 1.202 -4.5 4c2.05 -1.254 2.551 1.003 1.5 3c-1.052 2.005 -2 3 -2.5 3c-.49 0 -.924 -1.165 -1.5 -3.5c-.59 -2.42 -.5 -6.5 -3 -6.5s-5.5 4.5 -5.5 4.5z"
      }
    }]
  })(props);
}
;
export function TbBrandVisualStudio(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8l2 -1l10 13l4 -2v-12l-4 -2l-10 13l-2 -1z"
      }
    }]
  })(props);
}
;
export function TbBrandVk(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 19h-4a8 8 0 0 1 -8 -8v-5h4v5a4 4 0 0 0 4 4h0v-9h4v4.5l.03 -.004a4.531 4.531 0 0 0 3.97 -4.496h4l-.342 1.711a6.858 6.858 0 0 1 -3.658 4.789h0a5.34 5.34 0 0 1 3.566 4.111l.434 2.389h0h-4a4.531 4.531 0 0 0 -3.97 -4.496v4.5z"
      }
    }]
  })(props);
}
;
export function TbBrandVue(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 5l-6.5 10l-6.5 -10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5l-3 4.5l-3 -4.5h-7l10 16l10 -16z"
      }
    }]
  })(props);
}
;
export function TbBrandWhatsapp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1"
      }
    }]
  })(props);
}
;
export function TbBrandWindows(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.8 20l-12 -1.5c-1 -.1 -1.8 -.9 -1.8 -1.9v-9.2c0 -1 .8 -1.8 1.8 -1.9l12 -1.5c1.2 -.1 2.2 .8 2.2 1.9v12.1c0 1.2 -1.1 2.1 -2.2 1.9z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbBrandYahoo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "6",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "18",
        "x2": "14",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 6l5.5 7v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13l6 -5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12.5",
        "y1": "8",
        "x2": "17.5",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "11",
        "x2": "20",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "18",
        "x2": "20",
        "y2": "18.01"
      }
    }]
  })(props);
}
;
export function TbBrandYcombinator(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 7.002l4 5.998l4 -6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbBrandYoutube(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 9l5 3l-5 3z"
      }
    }]
  })(props);
}
;
export function TbBread(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 5a3 3 0 0 1 2 5.235v6.765a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6.764a3 3 0 0 1 1.824 -5.231l.176 -.005h10z"
      }
    }]
  })(props);
}
;
export function TbBriefcase(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "7",
        "width": "18",
        "height": "13",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 13a20 20 0 0 0 18 0"
      }
    }]
  })(props);
}
;
export function TbBrightness2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"
      }
    }]
  })(props);
}
;
export function TbBrightnessDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "5.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "7",
        "x2": "17",
        "y2": "7.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "12",
        "x2": "19",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "17",
        "x2": "17",
        "y2": "17.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "12",
        "y2": "19.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "17",
        "x2": "7",
        "y2": "17.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "5",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "7",
        "x2": "7",
        "y2": "7.01"
      }
    }]
  })(props);
}
;
export function TbBrightnessHalf(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9a3 3 0 0 0 0 6v-6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"
      }
    }]
  })(props);
}
;
export function TbBrightnessUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "7",
        "x2": "18.4",
        "y2": "5.6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "17",
        "x2": "18.4",
        "y2": "18.4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "17",
        "x2": "5.6",
        "y2": "18.4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "4",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "7",
        "x2": "5.6",
        "y2": "5.6"
      }
    }]
  })(props);
}
;
export function TbBrightness(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "16.65",
        "y2": "4.35"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14.3",
        "x2": "19.37",
        "y2": "6.93"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19.6",
        "x2": "20.85",
        "y2": "10.75"
      }
    }]
  })(props);
}
;
export function TbBrowserCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 14.5l1.5 1.5l3 -3"
      }
    }]
  })(props);
}
;
export function TbBrowserOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h11a1 1 0 0 1 1 1v11m-.288 3.702a0.997 .997 0 0 1 -.712 .298h-14a1 1 0 0 1 -1 -1v-14c0 -.276 .112 -.526 .293 -.707"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8h4m4 0h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBrowserPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v4"
      }
    }]
  })(props);
}
;
export function TbBrowserX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 16l-4 -4"
      }
    }]
  })(props);
}
;
export function TbBrowser(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "20",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "8"
      }
    }]
  })(props);
}
;
export function TbBrushOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17a4 4 0 1 1 4 4h-4v-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3a15.996 15.996 0 0 0 -9.309 4.704m-1.795 2.212a15.993 15.993 0 0 0 -1.696 3.284"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3a15.996 15.996 0 0 1 -4.697 9.302m-2.195 1.786a15.993 15.993 0 0 1 -3.308 1.712"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBrush(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21v-4a4 4 0 1 1 4 4h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3a16 16 0 0 0 -12.8 10.2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3a16 16 0 0 1 -10.2 12.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.6 9a9 9 0 0 1 4.4 4.4"
      }
    }]
  })(props);
}
;
export function TbBucketOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.184 17.173l-.184 .827c-.193 1.183 -1.034 2.024 -2 2h-6c-.966 .024 -1.807 -.817 -2 -2l-2 -9h4m4 0h6l-1.089 4.9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 9c0 -.596 .104 -1.167 .295 -1.697m1.705 -2.303a5 5 0 0 1 8 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBucket(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 9l-2 9a2 2.5 0 0 1 -2 2h-6a2 2.5 0 0 1 -2 -2l-2 -9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 9a5 5 0 0 1 10 0"
      }
    }]
  })(props);
}
;
export function TbBugOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.884 5.873a3 3 0 0 1 5.116 2.127v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h3a6 6 0 0 1 1 3v1m-.298 3.705a5.002 5.002 0 0 1 -9.702 -1.705v-3a6 6 0 0 1 1 -3h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 13h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 19l3.35 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7l3.75 2.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 7l-3.75 2.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBug(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9v-1a3 3 0 0 1 6 0v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 9h8a6 6 0 0 1 1 3v3a5 5 0 0 1 -10 0v-3a6 6 0 0 1 1 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "13",
        "x2": "7",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "13",
        "x2": "21",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "19",
        "x2": "7.35",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "19",
        "x2": "16.65",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "7",
        "x2": "7.75",
        "y2": "9.4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "7",
        "x2": "16.25",
        "y2": "9.4"
      }
    }]
  })(props);
}
;
export function TbBuildingArch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21v-15a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21v-8a3 3 0 0 1 6 0v8"
      }
    }]
  })(props);
}
;
export function TbBuildingBank(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "5 6 12 3 19 6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "10",
        "x2": "4",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "10",
        "x2": "20",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "14",
        "x2": "8",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "12",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "14",
        "x2": "16",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbBuildingBridge2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 7h12a2 2 0 0 1 2 2v9a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a4 4 0 0 0 -8 0v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2"
      }
    }]
  })(props);
}
;
export function TbBuildingBridge(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "5",
        "x2": "6",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "5",
        "x2": "18",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "2",
        "y1": "15",
        "x2": "22",
        "y2": "15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 8a7.5 7.5 0 0 0 3 -2a6.5 6.5 0 0 0 12 0a7.5 7.5 0 0 0 3 2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "10",
        "x2": "12",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbBuildingCarousel(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "8",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "4",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "8",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "16",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "16",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 22l4 -10l4 10"
      }
    }]
  })(props);
}
;
export function TbBuildingCastle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 19v-2a3 3 0 0 0 -6 0v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14h4v3h3v-3h4v3h3v-3h4v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "11",
        "x2": "21",
        "y2": "11"
      }
    }]
  })(props);
}
;
export function TbBuildingChurch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21v-4a2 2 0 0 1 4 0v4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "5",
        "x2": "14",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21v-7m-2 2l8 -8l8 8m-2 -2v7"
      }
    }]
  })(props);
}
;
export function TbBuildingCommunity(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "7",
        "x2": "13",
        "y2": "7.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "7",
        "x2": "17",
        "y2": "7.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "11",
        "x2": "17",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "15",
        "x2": "17",
        "y2": "15.01"
      }
    }]
  })(props);
}
;
export function TbBuildingCottage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21v-11l2.5 -4.5l5.5 -2.5l5.5 2.5l2.5 4.5v11"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "9",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21v-5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v5"
      }
    }]
  })(props);
}
;
export function TbBuildingFactory2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-12l5 4v-4l5 4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 21v-8l-1.436 -9.574a0.5 .5 0 0 0 -.495 -.426h-1.145a0.5 .5 0 0 0 -.494 .418l-1.43 8.582"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17h1"
      }
    }]
  })(props);
}
;
export function TbBuildingFactory(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21c1.147 -4.02 1.983 -8.027 2 -12h6c.017 3.973 .853 7.98 2 12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 13h4.5c.025 2.612 .894 5.296 2 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "22",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbBuildingFortress(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 21h1a1 1 0 0 0 1 -1v-1h0a3 3 0 0 1 6 0m3 2h1a1 1 0 0 0 1 -1v-15l-3 -2l-3 2v6h-4v-6l-3 -2l-3 2v15a1 1 0 0 0 1 1h2m8 -2v1a1 1 0 0 0 1 1h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7h0v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 10h0v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 13h0v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 7h0v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 10h0v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13h0v.01"
      }
    }]
  })(props);
}
;
export function TbBuildingHospital(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "9",
        "x2": "14",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "7",
        "x2": "12",
        "y2": "11"
      }
    }]
  })(props);
}
;
export function TbBuildingLighthouse(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3l2 3l2 15h-8l2 -15z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "9",
        "x2": "16",
        "y2": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11l2 -2l-2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 11l-2 -2l2 -2"
      }
    }]
  })(props);
}
;
export function TbBuildingMonument(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 18l2 -13l2 -2l2 2l2 13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-3h14v3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbBuildingPavilon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21h7v-3a2 2 0 0 1 4 0v3h7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "21",
        "x2": "6",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "21",
        "x2": "18",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12h12a3 3 0 0 0 3 -3a9 8 0 0 1 -9 -6a9 8 0 0 1 -9 6a3 3 0 0 0 3 3"
      }
    }]
  })(props);
}
;
export function TbBuildingSkyscraper(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-14l8 -4v18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 21v-10l-6 -4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "9",
        "x2": "9",
        "y2": "9.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "9",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "9",
        "y2": "15.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "18",
        "x2": "9",
        "y2": "18.01"
      }
    }]
  })(props);
}
;
export function TbBuildingStore(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "21",
        "x2": "5",
        "y2": "10.85"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "21",
        "x2": "19",
        "y2": "10.85"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
      }
    }]
  })(props);
}
;
export function TbBuildingWarehouse(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21v-13l9 -4l9 4v13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 13h4v8h-10v-6h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 21v-9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v3"
      }
    }]
  })(props);
}
;
export function TbBuilding(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "8",
        "x2": "10",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "10",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "16",
        "x2": "10",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "8",
        "x2": "15",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "16",
        "x2": "15",
        "y2": "16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
      }
    }]
  })(props);
}
;
export function TbBulbOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.089 7.083a5 5 0 0 1 5.826 5.84m-1.378 2.611a5.012 5.012 0 0 1 -.537 .466a3.5 3.5 0 0 0 -1 3a2 2 0 1 1 -4 0a3.5 3.5 0 0 0 -1 -3a5 5 0 0 1 -.528 -7.544"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.7 17h4.6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbBulb(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9.7",
        "y1": "17",
        "x2": "14.3",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbBulldozer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "4",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "13",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 13v6h3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "19",
        "x2": "4",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "15",
        "x2": "13",
        "y2": "15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12v-5h2a3 3 0 0 1 3 3v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 15v-2a1 1 0 0 1 1 -1h7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "17",
        "x2": "15",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbBus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17h-2v-11a1 1 0 0 1 1 -1h14a5 7 0 0 1 5 7v5h-2m-4 0h-8"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 5 17.5 12 22 12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "2",
        "y1": "10",
        "x2": "17",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "5",
        "x2": "7",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbBusinessplan(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "16",
        "cy": "6",
        "rx": "5",
        "ry": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 15v1m0 -8v1"
      }
    }]
  })(props);
}
;
export function TbButterfly(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.995 18.176a3 3 0 1 1 -4.953 -2.449l-.025 .023a4.502 4.502 0 0 1 1.483 -8.75c1.414 0 2.675 .652 3.5 1.671a4.5 4.5 0 1 1 4.983 7.079a3 3 0 1 1 -4.983 2.25z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3l3 2l3 -2"
      }
    }]
  })(props);
}
;
export function TbCSharp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 9a3 3 0 0 0 -3 -3h-.5a3.5 3.5 0 0 0 -3.5 3.5v5a3.5 3.5 0 0 0 3.5 3.5h.5a3 3 0 0 0 3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7l-1 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 7l-1 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10h7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 14h-7.5"
      }
    }]
  })(props);
}
;
export function TbCakeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 17v-5a3 3 0 0 0 -3 -3h-5m-4 0h-3a3 3 0 0 0 -3 3v8h17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2.996 14.803c.312 .135 .654 .204 1.004 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1m4 0a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1.004 -.197"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.172 6.188c.07 -.158 .163 -.31 .278 -.451l1.55 -1.737l1.465 1.638a2 2 0 0 1 -.65 3.19"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCake(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20h18v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2.996 14.803c.312 .135 .654 .204 1.004 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1.004 -.197"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
      }
    }]
  })(props);
}
;
export function TbCalculatorOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.823 19.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-14c0 -.295 .064 -.575 .178 -.827m2.822 -1.173h11a2 2 0 0 1 2 2v11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10h-1a1 1 0 0 1 -1 -1v-1m3 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCalculator(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "3",
        "width": "16",
        "height": "18",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "7",
        "width": "8",
        "height": "3",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "14",
        "x2": "8",
        "y2": "14.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "12",
        "y2": "14.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "14",
        "x2": "16",
        "y2": "14.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "17",
        "x2": "8",
        "y2": "17.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "17.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "17",
        "x2": "16",
        "y2": "17.01"
      }
    }]
  })(props);
}
;
export function TbCalendarEvent(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "5",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "3",
        "x2": "16",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "3",
        "x2": "8",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "11",
        "x2": "20",
        "y2": "11"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "15",
        "width": "2",
        "height": "2"
      }
    }]
  })(props);
}
;
export function TbCalendarMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "5",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "3",
        "x2": "16",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "3",
        "x2": "8",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "11",
        "x2": "20",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "16",
        "x2": "14",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbCalendarOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.823 19.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.175 -1.823m3.825 -.177h9a2 2 0 0 1 2 2v9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "3",
        "x2": "16",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "3",
        "x2": "8",
        "y2": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 11h7m4 0h5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "15",
        "x2": "12",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbCalendarPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "5",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "3",
        "x2": "16",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "3",
        "x2": "8",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "11",
        "x2": "20",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "16",
        "x2": "14",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "12",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbCalendarStats(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 14v4h4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "18",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11h16"
      }
    }]
  })(props);
}
;
export function TbCalendarTime(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "18",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 16.496v1.504l1 1"
      }
    }]
  })(props);
}
;
export function TbCalendar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "5",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "3",
        "x2": "16",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "3",
        "x2": "8",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "11",
        "x2": "20",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "15",
        "x2": "12",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbCameraMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "13",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h3m9 6v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "6",
        "x2": "21",
        "y2": "6"
      }
    }]
  })(props);
}
;
export function TbCameraOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.29 4.296a1 1 0 0 1 .71 -.296h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v8m-1.179 2.824c-.25 .113 -.528 .176 -.821 .176h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1c.292 0 .568 -.062 .818 -.175"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.436 10.44a3 3 0 1 0 4.126 4.122"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbCameraPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "13",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7h2a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h2m9 7v7a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "6",
        "x2": "21",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "3",
        "x2": "18",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbCameraRotate(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.245 15.904a3 3 0 0 0 3.755 -2.904m-2.25 -2.905a3 3 0 0 0 -3.75 2.905"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 13h2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13h-2v-2"
      }
    }]
  })(props);
}
;
export function TbCameraSelfie(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "11",
        "x2": "15.01",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "11",
        "x2": "9.01",
        "y2": "11"
      }
    }]
  })(props);
}
;
export function TbCamera(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "13",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbCandle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21h6v-9a1 1 0 0 0 -1 -1h-4a1 1 0 0 0 -1 1v9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
      }
    }]
  })(props);
}
;
export function TbCandyOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.174 7.17l.119 -.12a2 2 0 0 1 2.828 0l2.829 2.83a2 2 0 0 1 0 2.828l-.124 .124m-1.996 1.996l-2.123 2.123a2 2 0 0 1 -2.828 0l-2.829 -2.831a2 2 0 0 1 0 -2.828l2.113 -2.112"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.243 9.172l3.086 -.772a1.5 1.5 0 0 0 .697 -2.516l-2.216 -2.217a1.5 1.5 0 0 0 -2.44 .47l-1.248 2.913"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.172 16.243l-.772 3.086a1.5 1.5 0 0 1 -2.516 .697l-2.217 -2.216a1.5 1.5 0 0 1 .47 -2.44l2.913 -1.248"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCandy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.05 11.293l4.243 -4.243a2 2 0 0 1 2.828 0l2.829 2.83a2 2 0 0 1 0 2.828l-4.243 4.243a2 2 0 0 1 -2.828 0l-2.829 -2.831a2 2 0 0 1 0 -2.828z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.243 9.172l3.086 -.772a1.5 1.5 0 0 0 .697 -2.516l-2.216 -2.217a1.5 1.5 0 0 0 -2.44 .47l-1.248 2.913"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.172 16.243l-.772 3.086a1.5 1.5 0 0 1 -2.516 .697l-2.217 -2.216a1.5 1.5 0 0 1 .47 -2.44l2.913 -1.248"
      }
    }]
  })(props);
}
;
export function TbCaptureOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2c.554 0 1.055 -.225 1.417 -.589"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.87 9.887a3 3 0 0 0 4.255 4.23m.58 -3.416a3.012 3.012 0 0 0 -1.4 -1.403"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2c0 -.548 .22 -1.044 .577 -1.405"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCapture(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbCarCrane(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v-11h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17v-5h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v-6l18 -3v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12v-4l-4 -2"
      }
    }]
  })(props);
}
;
export function TbCarCrash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 6l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-5m0 -6h8m-6 0v-5m2 0h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 8v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.5 15.5l1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.5 8.5l1.5 -1.5"
      }
    }]
  })(props);
}
;
export function TbCarOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.584 15.588a2 2 0 0 0 2.828 2.83"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 17h-2v-6l2 -5h1m4 0h4l4 5h1a2 2 0 0 1 2 2v4m-6 0h-6m-6 -6h8m4 0h3m-6 -3v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"
      }
    }]
  })(props);
}
;
export function TbCaravan(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "17",
        "x2": "13",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17h-5a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2h10l4 4v8"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "8",
        "width": "6",
        "height": "4",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbCardboardsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.96 16.953c.026 -.147 .04 -.298 .04 -.453v-8.5a2 2 0 0 0 -2 -2h-9m-4 0h-1a2 2 0 0 0 -2 2v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06c.155 0 .307 -.014 .454 -.041"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.714 12.7a1 1 0 0 0 -1.417 -1.411l1.417 1.41z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCardboards(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 8v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06a2.5 2.5 0 0 0 2.5 -2.5v-8.5a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "12",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbCaretDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l-6 -6l-6 6h12",
        "transform": "rotate(180 12 12)"
      }
    }]
  })(props);
}
;
export function TbCaretLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l-6 -6l-6 6h12",
        "transform": "rotate(270 12 12)"
      }
    }]
  })(props);
}
;
export function TbCaretRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l-6 -6l-6 6h12",
        "transform": "rotate(90 12 12)"
      }
    }]
  })(props);
}
;
export function TbCaretUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l-6 -6l-6 6h12"
      }
    }]
  })(props);
}
;
export function TbCashBanknoteOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.88 9.878a3 3 0 1 0 4.242 4.243m.58 -3.425a3.012 3.012 0 0 0 -1.412 -1.405"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h9a2 2 0 0 1 2 2v8c0 .294 -.064 .574 -.178 .825m-2.822 1.175h-13a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "12",
        "x2": "18.01",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "6.01",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbCashBanknote(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "6",
        "width": "18",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "12",
        "x2": "18.01",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "6.01",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbCashOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h6a2 2 0 0 1 2 2v6m-2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.582 12.59a2 2 0 0 0 2.83 2.826"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 9v-2a2 2 0 0 0 -2 -2h-6m-4 0a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "9",
        "width": "14",
        "height": "10",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "14",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"
      }
    }]
  })(props);
}
;
export function TbCastOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 19a4 4 0 0 0 -4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 19a8 8 0 0 0 -8 -8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 19h3a3 3 0 0 0 .875 -.13m1.997 -2.002a3 3 0 0 0 .128 -.868v-8a3 3 0 0 0 -3 -3h-9m-3.865 .136a3 3 0 0 0 -1.935 1.864"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCast(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "19",
        "x2": "3.01",
        "y2": "19"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 19a4 4 0 0 0 -4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 19a8 8 0 0 0 -8 -8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 19h3a3 3 0 0 0 3 -3v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -2.8 2"
      }
    }]
  })(props);
}
;
export function TbCeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 4a7.99 7.99 0 0 0 -2.581 .426"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.867 5.864a8 8 0 0 0 5.133 14.136"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4a8.001 8.001 0 0 0 -7.29 4.7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12a8 8 0 0 0 8 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 4a8 8 0 1 0 0 16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4a8 8 0 1 0 0 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbCellSignal1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
      }
    }]
  })(props);
}
;
export function TbCellSignal2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 20v-5"
      }
    }]
  })(props);
}
;
export function TbCellSignal3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20v-9"
      }
    }]
  })(props);
}
;
export function TbCellSignal4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7v13"
      }
    }]
  })(props);
}
;
export function TbCellSignal5(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7v13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20v-9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 20v-5"
      }
    }]
  })(props);
}
;
export function TbCellSignalOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l7.265 -7.264m2 -2.001l5.272 -5.272a0.731 .731 0 0 1 1.249 .517v11.269"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCell(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4l-4 2v5l4 2l4 -2v-5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11l4 2l4 -2v-5l-4 -2l-4 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v5l4 2l4 -2v-5"
      }
    }]
  })(props);
}
;
export function TbCertificate2Off(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12a3 3 0 1 0 3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 18v4l2 -1l2 1v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 19h-2a2 2 0 0 1 -2 -2v-11m1.18 -2.825c.25 -.112 .529 -.175 .82 -.175h8a2 2 0 0 1 2 2v9m-.175 3.82a2 2 0 0 1 -1.825 1.18h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCertificate2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "15",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 7h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 18v4l2 -1l2 1v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 19h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2"
      }
    }]
  })(props);
}
;
export function TbCertificateOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.876 12.881a3 3 0 0 0 4.243 4.243m.588 -3.42a3.012 3.012 0 0 0 -1.437 -1.423"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 17.5v4.5l2 -1.5l2 1.5v-4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2m4 0h10a2 2 0 0 1 2 2v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9h3m4 0h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCertificate(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "15",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 17.5v4.5l2 -1.5l2 1.5v-4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "9",
        "x2": "18",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "9",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "15",
        "x2": "8",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbChargingPile(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "7",
        "x2": "17",
        "y2": "8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 11.5l-1.5 2.5h3l-1.5 2.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "20",
        "x2": "15",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "14",
        "y2": "8"
      }
    }]
  })(props);
}
;
export function TbChartArcs3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12a5 5 0 1 0 5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.29 18.957a9 9 0 1 0 5.71 -15.957"
      }
    }]
  })(props);
}
;
export function TbChartArcs(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.924 11.132a5 5 0 1 0 -4.056 5.792"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12a9 9 0 1 0 9 -9"
      }
    }]
  })(props);
}
;
export function TbChartAreaLine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "4 19 8 13 12 15 16 10 20 14 20 19 4 19"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "4 12 7 8 11 10 16 4 20 8"
      }
    }]
  })(props);
}
;
export function TbChartArea(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "19",
        "x2": "20",
        "y2": "19"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "4 15 8 9 12 11 16 6 20 10 20 15 4 15"
      }
    }]
  })(props);
}
;
export function TbChartArrowsVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 21v-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15l3 -3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10l3 -3l3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6l3 -3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21v-18"
      }
    }]
  })(props);
}
;
export function TbChartArrows(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "18",
        "x2": "17",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15l3 3l-3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "3",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 3l3 3l-3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "6",
        "x2": "21",
        "y2": "6"
      }
    }]
  })(props);
}
;
export function TbChartBar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "12",
        "width": "6",
        "height": "8",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "8",
        "width": "6",
        "height": "12",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "15",
        "y": "4",
        "width": "6",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "18",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbChartBubble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "16",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14.5",
        "cy": "7.5",
        "r": "4.5"
      }
    }]
  })(props);
}
;
export function TbChartCandle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "6",
        "width": "4",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "4",
        "x2": "6",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "11",
        "x2": "6",
        "y2": "20"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "14",
        "width": "4",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "12",
        "y2": "20"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "16",
        "y": "5",
        "width": "4",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "4",
        "x2": "18",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "11",
        "x2": "18",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbChartCircles(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9.5",
        "cy": "9.5",
        "r": "5.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14.5",
        "cy": "14.5",
        "r": "5.5"
      }
    }]
  })(props);
}
;
export function TbChartDonut2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v5m4 4h5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbChartDonut3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v5m4 4h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.929 14.582l-3.429 2.918"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbChartDonut4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.848 14.667l-3.348 2.833"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v5m4 4h5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.219 15.328l2.781 4.172"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }]
  })(props);
}
;
export function TbChartDonut(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-3.8a4.1 4.1 0 1 1 -5 -5v-4a0.9 .9 0 0 0 -1 -.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a9 9 0 0 0 -1 -1v-4.5"
      }
    }]
  })(props);
}
;
export function TbChartDots2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3v18h18"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "15",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "13",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3l-6 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.113 6.65l2.771 3.695"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12.5l-5 2"
      }
    }]
  })(props);
}
;
export function TbChartDots3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "7",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "15",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "6",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "18",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17l5 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 8.5l7.81 5.37"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7l8 -1"
      }
    }]
  })(props);
}
;
export function TbChartDots(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3v18h18"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "9",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "7",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "15",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10.16",
        "y1": "10.62",
        "x2": "12.5",
        "y2": "13.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.088 13.328l2.837 -4.586"
      }
    }]
  })(props);
}
;
export function TbChartInfographic(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3v4h4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "17",
        "x2": "9",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "14",
        "x2": "17",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "13",
        "x2": "13",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "12",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbChartLine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "19",
        "x2": "20",
        "y2": "19"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "4 15 8 9 12 11 16 6 20 10"
      }
    }]
  })(props);
}
;
export function TbChartPie2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v9h9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbChartPie3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-6.5 5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v9h9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbChartPie4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-6.5 5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v9h9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l5 7.5"
      }
    }]
  })(props);
}
;
export function TbChartPie(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-6.8a2 2 0 0 1 -2 -2v-7a0.9 .9 0 0 0 -1 -.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a1 1 0 0 1 -1 -1v-4.5"
      }
    }]
  })(props);
}
;
export function TbChartRadar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3l9.5 7l-3.5 11h-12l-3.5 -11z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7.5l5.5 4l-2.5 5.5h-6.5l-2 -5.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2.5 10l9.5 3l9.5 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v10l6 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21l6 -8"
      }
    }]
  })(props);
}
;
export function TbCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12l5 5l10 -10"
      }
    }]
  })(props);
}
;
export function TbCheckbox(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 11 12 14 20 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"
      }
    }]
  })(props);
}
;
export function TbChecklist(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.615 20h-2.615a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 19l2 2l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 8h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12h2"
      }
    }]
  })(props);
}
;
export function TbChecks(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12l5 5l10 -10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 12l5 5m5 -5l5 -5"
      }
    }]
  })(props);
}
;
export function TbCheckupList(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16l1 1l3 -3"
      }
    }]
  })(props);
}
;
export function TbCheese(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.519 20.008l16.481 -.008v-3.5a2 2 0 1 1 0 -4v-3.5h-16.722"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 9l-9.385 -4.992c-2.512 .12 -4.758 1.42 -6.327 3.425c-1.423 1.82 -2.288 4.221 -2.288 6.854c0 2.117 .56 4.085 1.519 5.721"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 13v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 16v.01"
      }
    }]
  })(props);
}
;
export function TbChevronDownLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8v8h8"
      }
    }]
  })(props);
}
;
export function TbChevronDownRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8v8h-8"
      }
    }]
  })(props);
}
;
export function TbChevronDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "6 9 12 15 18 9"
      }
    }]
  })(props);
}
;
export function TbChevronLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 6 9 12 15 18"
      }
    }]
  })(props);
}
;
export function TbChevronRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 6 15 12 9 18"
      }
    }]
  })(props);
}
;
export function TbChevronUpLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16v-8h8"
      }
    }]
  })(props);
}
;
export function TbChevronUpRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8h8v8"
      }
    }]
  })(props);
}
;
export function TbChevronUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "6 15 12 9 18 15"
      }
    }]
  })(props);
}
;
export function TbChevronsDownLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 5v8h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 9v8h8"
      }
    }]
  })(props);
}
;
export function TbChevronsDownRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 5v8h-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 9v8h-8"
      }
    }]
  })(props);
}
;
export function TbChevronsDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 7 12 12 17 7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 13 12 18 17 13"
      }
    }]
  })(props);
}
;
export function TbChevronsLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "11 7 6 12 11 17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 7 12 12 17 17"
      }
    }]
  })(props);
}
;
export function TbChevronsRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 7 12 12 7 17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "13 7 18 12 13 17"
      }
    }]
  })(props);
}
;
export function TbChevronsUpLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 15v-8h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 19v-8h8"
      }
    }]
  })(props);
}
;
export function TbChevronsUpRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 7h8v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 11h8v8"
      }
    }]
  })(props);
}
;
export function TbChevronsUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 11 12 6 17 11"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 17 12 12 17 17"
      }
    }]
  })(props);
}
;
export function TbChristmasTree(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3l4 4l-2 1l4 4l-3 1l4 4h-14l4 -4l-3 -1l4 -4l-2 -1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-3"
      }
    }]
  })(props);
}
;
export function TbCircle0(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircle1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v-8l-2 2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircle2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircle3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12a2 2 0 1 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14a2 2 0 1 0 2 -2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircle4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 16v-8l-4 6h5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircle5(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircle6(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10a2 2 0 1 0 -4 0v4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircle7(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 8h4l-2 8"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircle8(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "10",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircle9(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "10",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14a2 2 0 1 0 4 0v-4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircleCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12l2 2l4 -4"
      }
    }]
  })(props);
}
;
export function TbCircleDashed(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.56 20.31a9 9 0 0 0 3.44 .69"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
      }
    }]
  })(props);
}
;
export function TbCircleDot(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircleDotted(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.5",
        "y1": "4.21",
        "x2": "7.5",
        "y2": "4.22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.21",
        "y1": "7.5",
        "x2": "4.21",
        "y2": "7.51"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "3",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.21",
        "y1": "16.5",
        "x2": "4.21",
        "y2": "16.51"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.5",
        "y1": "19.79",
        "x2": "7.5",
        "y2": "19.8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "21.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.5",
        "y1": "19.79",
        "x2": "16.5",
        "y2": "19.8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19.79",
        "y1": "16.5",
        "x2": "19.79",
        "y2": "16.51"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "12",
        "x2": "21",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19.79",
        "y1": "7.5",
        "x2": "19.79",
        "y2": "7.51"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.5",
        "y1": "4.21",
        "x2": "16.5",
        "y2": "4.22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "3.01"
      }
    }]
  })(props);
}
;
export function TbCircleHalf2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14l7 -7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19l8.5 -8.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9l4.5 -4.5"
      }
    }]
  })(props);
}
;
export function TbCircleHalfVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h18"
      }
    }]
  })(props);
}
;
export function TbCircleHalf(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v18"
      }
    }]
  })(props);
}
;
export function TbCircleMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbCircleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCirclePlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbCircleRectangleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10h3v3m-3 1h-7v-4h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCircleRectangle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 10h10v4h-10z"
      }
    }]
  })(props);
}
;
export function TbCircleSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9.5",
        "cy": "9.5",
        "r": "6.5"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "10",
        "width": "11",
        "height": "11",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbCircleTriangle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20l7 -12h-14z"
      }
    }]
  })(props);
}
;
export function TbCircleX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbCircles(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6.5",
        "cy": "17",
        "r": "4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17.5",
        "cy": "17",
        "r": "4"
      }
    }]
  })(props);
}
;
export function TbClearAll(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 6h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18h12"
      }
    }]
  })(props);
}
;
export function TbClearFormatting(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 15l4 4m0 -4l-4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 6v-1h11v1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "19",
        "x2": "11",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "5",
        "x2": "9",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbClick(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "6",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.8",
        "y1": "7.8",
        "x2": "5.6",
        "y2": "5.6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.2",
        "y1": "7.8",
        "x2": "18.4",
        "y2": "5.6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.8",
        "y1": "16.2",
        "x2": "5.6",
        "y2": "18.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l9 3l-4 2l-2 4l-3 -9"
      }
    }]
  })(props);
}
;
export function TbClipboardCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14l2 2l4 -4"
      }
    }]
  })(props);
}
;
export function TbClipboardList(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "9.01",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "16",
        "x2": "9.01",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "16",
        "x2": "15",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbClipboardOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.575 5.597a1.994 1.994 0 0 0 -.575 1.403v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-8a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 1 1 0 4h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbClipboardPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v4"
      }
    }]
  })(props);
}
;
export function TbClipboardText(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16h6"
      }
    }]
  })(props);
}
;
export function TbClipboardX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbClipboard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbClock2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v5l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 12h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19v1"
      }
    }]
  })(props);
}
;
export function TbClockOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbClock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 7 12 12 15 15"
      }
    }]
  })(props);
}
;
export function TbCloudComputing(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.657 16c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 .996c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16v4a1 1 0 0 1 -1 1h-4"
      }
    }]
  })(props);
}
;
export function TbCloudDataConnection(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 9.897c0 -1.714 1.46 -3.104 3.26 -3.104c.275 -1.22 1.255 -2.215 2.572 -2.611c1.317 -.397 2.77 -.134 3.811 .69c1.042 .822 1.514 2.08 1.239 3.3h.693a2.42 2.42 0 0 1 2.425 2.414a2.42 2.42 0 0 1 -2.425 2.414h-8.315c-1.8 0 -3.26 -1.39 -3.26 -3.103z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13v3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 18h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h7"
      }
    }]
  })(props);
}
;
export function TbCloudDownload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "13",
        "x2": "12",
        "y2": "22"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 19 12 22 15 19"
      }
    }]
  })(props);
}
;
export function TbCloudFog(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "20",
        "x2": "19",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbCloudLockOpen(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 18a3.5 3.5 0 0 0 0 -7h-1c.397 -1.768 -.285 -3.593 -1.788 -4.787c-1.503 -1.193 -3.6 -1.575 -5.5 -1s-3.315 2.019 -3.712 3.787c-2.199 -.088 -4.155 1.326 -4.666 3.373c-.512 2.047 .564 4.154 2.566 5.027"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "15",
        "width": "8",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 15v-2a2 2 0 0 1 3.736 -.994"
      }
    }]
  })(props);
}
;
export function TbCloudLock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 18a3.5 3.5 0 0 0 0 -7h-1c.397 -1.768 -.285 -3.593 -1.788 -4.787c-1.503 -1.193 -3.6 -1.575 -5.5 -1s-3.315 2.019 -3.712 3.787c-2.199 -.088 -4.155 1.326 -4.666 3.373c-.512 2.047 .564 4.154 2.566 5.027"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "15",
        "width": "8",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 15v-2a2 2 0 1 1 4 0v2"
      }
    }]
  })(props);
}
;
export function TbCloudOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18h-11c-2.598 0 -4.705 -2.015 -4.705 -4.5s2.107 -4.5 4.705 -4.5c.112 -.5 .305 -.973 .568 -1.408m2.094 -1.948c.329 -.174 .68 -.319 1.05 -.43c1.9 -.576 3.997 -.194 5.5 1c1.503 1.192 2.185 3.017 1.788 4.786h1a3.5 3.5 0 0 1 2.212 6.212"
      }
    }]
  })(props);
}
;
export function TbCloudRain(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 13v2m0 3v2m4 -5v2m0 3v2"
      }
    }]
  })(props);
}
;
export function TbCloudSnow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 15v.01m0 3v.01m0 3v.01m4 -4v.01m0 3v.01"
      }
    }]
  })(props);
}
;
export function TbCloudStorm(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "13 14 11 18 14 18 12 22"
      }
    }]
  })(props);
}
;
export function TbCloudUpload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 15 12 12 15 15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbCloud(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.657 18c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 .996c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878"
      }
    }]
  })(props);
}
;
export function TbClubs(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a4 4 0 0 1 3.164 6.447a4 4 0 1 1 -1.164 6.198v1.355l1 4h-6l1 -4l.001 -1.355a4 4 0 1 1 -1.164 -6.199a4 4 0 0 1 3.163 -6.446z"
      }
    }]
  })(props);
}
;
export function TbCodeMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
      }
    }]
  })(props);
}
;
export function TbCodeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 8l-4 4l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 8l4 4l-2.5 2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 4l-1.201 4.805m-.802 3.207l-1.997 7.988"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCodePlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
      }
    }]
  })(props);
}
;
export function TbCode(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 8 3 12 7 16"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 8 21 12 17 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "4",
        "x2": "10",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbCoffeeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.73 -.565 1.783 -.923 2.994 -.99"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 3c-.194 .14 -.364 .305 -.506 .49"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10h3v3m-.257 3.743a6.003 6.003 0 0 1 -5.743 4.257h-2a6 6 0 0 1 -6 -6v-5h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.116 16.124a3 3 0 0 0 -3.118 -4.953"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCoffee(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.83 -.642 2.077 -1.017 3.5 -1c1.423 -.017 2.67 .358 3.5 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10h14v5a6 6 0 0 1 -6 6h-2a6 6 0 0 1 -6 -6v-5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.746 16.726a3 3 0 1 0 .252 -5.555"
      }
    }]
  })(props);
}
;
export function TbCoinOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.8 9a2 2 0 0 0 -1.8 -1h-1m-2.82 1.171a2 2 0 0 0 1.82 2.829h1m2.824 2.822a2 2 0 0 1 -1.824 1.178h-2a2 2 0 0 1 -1.8 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v2m0 8v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCoin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4h-2a2 2 0 0 1 -1.8 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v2m0 8v2"
      }
    }]
  })(props);
}
;
export function TbColorPickerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7l6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.001 7.999l3.699 -3.699a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-3.702 3.702m-1.998 1.998l-6 6h-4v-4l6.002 -6.002"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbColorPicker(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7l6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z"
      }
    }]
  })(props);
}
;
export function TbColorSwatchOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 13v4a4 4 0 0 0 6.832 2.825m1.168 -2.825v-12a2 2 0 0 0 -2 -2h-4a2 2 0 0 0 -2 2v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 7.35l-2 -2a2 2 0 0 0 -2.11 -.461m-2.13 1.874l-1.416 1.415a2 2 0 0 0 0 2.828l9 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.3 13h-2.3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbColorSwatch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 3h-4a2 2 0 0 0 -2 2v12a4 4 0 0 0 8 0v-12a2 2 0 0 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 7.35l-2 -2a2 2 0 0 0 -2.828 0l-2.828 2.828a2 2 0 0 0 0 2.828l9 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.3 13h-2.3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "17",
        "x2": "17",
        "y2": "17.01"
      }
    }]
  })(props);
}
;
export function TbColumnInsertLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "9",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "10",
        "x2": "7",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbColumnInsertRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "10",
        "x2": "17",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbColumnsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 10h5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 14h5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18h5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.5 6h5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.5 10h5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 14h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.5 18h3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbColumns(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "9.5",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "10",
        "x2": "9.5",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "14",
        "x2": "9.5",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "18",
        "x2": "9.5",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.5",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.5",
        "y1": "10",
        "x2": "20",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.5",
        "y1": "14",
        "x2": "20",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.5",
        "y1": "18",
        "x2": "20",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbComet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.5 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "11",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "4",
        "x2": "12.5",
        "y2": "7.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "9",
        "x2": "7.5",
        "y2": "12.5"
      }
    }]
  })(props);
}
;
export function TbCommand(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 9a2 2 0 1 1 2 -2v10a2 2 0 1 1 -2 -2h10a2 2 0 1 1 -2 2v-10a2 2 0 1 1 2 2h-10"
      }
    }]
  })(props);
}
;
export function TbCompassOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.999 9l3.001 -1l-1.002 3.005m-.998 2.995l-6 2l2 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCompass(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 16 10 10 16 8 14 14 8 16"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "5",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbComponentsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12l3 3l3 -3l-3 -3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 14.5l2.5 -2.5l-3 -3l-2.5 2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.499 8.501l2.501 -2.501l-3 -3l-2.5 2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18l3 3l3 -3l-3 -3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbComponents(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12l3 3l3 -3l-3 -3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12l3 3l3 -3l-3 -3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 6l3 3l3 -3l-3 -3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18l3 3l3 -3l-3 -3z"
      }
    }]
  })(props);
}
;
export function TbCone2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "7",
        "rx": "7",
        "ry": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 7v.5l-7 12.5l-7 -12.5v-.5"
      }
    }]
  })(props);
}
;
export function TbCone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "transform": "matrix(1 0 0 -1 0 34)",
        "cx": "12",
        "cy": "17",
        "rx": "7",
        "ry": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 17v-.5l-7 -12.5l-7 12.5v.5"
      }
    }]
  })(props);
}
;
export function TbConfetti(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 5h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 4l-.5 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 5h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 4v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 9l-1 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 13l2 -.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 18v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 16.518l-6.518 -6.518l-4.39 9.58a1.003 1.003 0 0 0 1.329 1.329l9.579 -4.39z"
      }
    }]
  })(props);
}
;
export function TbContainerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.297 4.289a0.997 .997 0 0 1 .703 -.289h6a1 1 0 0 1 1 1v7m0 4v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbContainer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8v.01"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "4",
        "width": "8",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v.01"
      }
    }]
  })(props);
}
;
export function TbContrast2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18h2a6 6 0 0 0 6 -6a6 6 0 0 1 6 -6h2"
      }
    }]
  })(props);
}
;
export function TbContrast(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17a5 5 0 0 0 0 -10v10"
      }
    }]
  })(props);
}
;
export function TbCookieOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.192 18.187a3 3 0 0 1 -.976 .652c-1.048 .263 -1.787 .483 -2.216 .661c-.475 .197 -1.092 .538 -1.852 1.024a3 3 0 0 1 -2.296 0c-.802 -.503 -1.419 -.844 -1.852 -1.024c-.471 -.195 -1.21 -.415 -2.216 -.66a3 3 0 0 1 -1.623 -1.624c-.265 -1.052 -.485 -1.79 -.661 -2.216c-.198 -.479 -.54 -1.096 -1.024 -1.852a3 3 0 0 1 0 -2.296c.48 -.744 .82 -1.361 1.024 -1.852c.171 -.413 .391 -1.152 .66 -2.216a3 3 0 0 1 .649 -.971m2.821 -1.174c.14 -.049 .263 -.095 .37 -.139c.458 -.19 1.075 -.531 1.852 -1.024a3 3 0 0 1 2.296 0l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296c-.497 .786 -.838 1.404 -1.024 1.852a6.579 6.579 0 0 0 -.135 .36"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCookie(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 14v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 8v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.148 3.476l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296c-.497 .786 -.838 1.404 -1.024 1.852c-.189 .456 -.409 1.194 -.66 2.216a3 3 0 0 1 -1.624 1.623c-1.048 .263 -1.787 .483 -2.216 .661c-.475 .197 -1.092 .538 -1.852 1.024a3 3 0 0 1 -2.296 0c-.802 -.503 -1.419 -.844 -1.852 -1.024c-.471 -.195 -1.21 -.415 -2.216 -.66a3 3 0 0 1 -1.623 -1.624c-.265 -1.052 -.485 -1.79 -.661 -2.216c-.198 -.479 -.54 -1.096 -1.024 -1.852a3 3 0 0 1 0 -2.296c.48 -.744 .82 -1.361 1.024 -1.852c.171 -.413 .391 -1.152 .66 -2.216a3 3 0 0 1 1.624 -1.623c1.032 -.256 1.77 -.476 2.216 -.661c.458 -.19 1.075 -.531 1.852 -1.024a3 3 0 0 1 2.296 0z"
      }
    }]
  })(props);
}
;
export function TbCopyOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.414 19.415a1.994 1.994 0 0 1 -1.414 .585h-8a2 2 0 0 1 -2 -2v-8c0 -.554 .225 -1.055 .589 -1.417m3.411 -.583h6a2 2 0 0 1 2 2v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8v-2a2 2 0 0 0 -2 -2h-6m-3.418 .59c-.36 .36 -.582 .86 -.582 1.41v8a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCopy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "8",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
      }
    }]
  })(props);
}
;
export function TbCopyleftOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.303 9.3a3.01 3.01 0 0 1 1.405 1.406m-.586 3.413a3.016 3.016 0 0 1 -4.122 .131"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCopyleft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 9.75a3.016 3.016 0 0 1 4.163 .173a2.993 2.993 0 0 1 0 4.154a3.016 3.016 0 0 1 -4.163 .173"
      }
    }]
  })(props);
}
;
export function TbCopyrightOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 9.75a3.016 3.016 0 0 0 -.711 -.466m-3.41 .596a2.993 2.993 0 0 0 -.042 4.197a3.016 3.016 0 0 0 4.163 .173"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCopyright(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 9.75a3.016 3.016 0 0 0 -4.163 .173a2.993 2.993 0 0 0 0 4.154a3.016 3.016 0 0 0 4.163 .173"
      }
    }]
  })(props);
}
;
export function TbCornerDownLeftDouble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5v6a3 3 0 0 1 -3 3h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 10l-4 4l4 4m-5 -8l-4 4l4 4"
      }
    }]
  })(props);
}
;
export function TbCornerDownLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6v6a3 3 0 0 1 -3 3h-10l4 -4m0 8l-4 -4"
      }
    }]
  })(props);
}
;
export function TbCornerDownRightDouble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 5v6a3 3 0 0 0 3 3h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10l4 4l-4 4m5 -8l4 4l-4 4"
      }
    }]
  })(props);
}
;
export function TbCornerDownRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4"
      }
    }]
  })(props);
}
;
export function TbCornerLeftDownDouble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4h-6a3 3 0 0 0 -3 3v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 10l-4 4l-4 -4m8 5l-4 4l-4 -4"
      }
    }]
  })(props);
}
;
export function TbCornerLeftDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6h-6a3 3 0 0 0 -3 3v10l-4 -4m8 0l-4 4"
      }
    }]
  })(props);
}
;
export function TbCornerLeftUpDouble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19h-6a3 3 0 0 1 -3 -3v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 13l-4 -4l-4 4m8 -5l-4 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbCornerLeftUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18h-6a3 3 0 0 1 -3 -3v-10l-4 4m8 0l-4 -4"
      }
    }]
  })(props);
}
;
export function TbCornerRightDownDouble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h6a3 3 0 0 1 3 3v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10l4 4l4 -4m-8 5l4 4l4 -4"
      }
    }]
  })(props);
}
;
export function TbCornerRightDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4"
      }
    }]
  })(props);
}
;
export function TbCornerRightUpDouble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19h6a3 3 0 0 0 3 -3v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13l4 -4l4 4m-8 -5l4 -4l4 4"
      }
    }]
  })(props);
}
;
export function TbCornerRightUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 18h6a3 3 0 0 0 3 -3v-10l-4 4m8 0l-4 -4"
      }
    }]
  })(props);
}
;
export function TbCornerUpLeftDouble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 18v-6a3 3 0 0 0 -3 -3h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 13l-4 -4l4 -4m-5 8l-4 -4l4 -4"
      }
    }]
  })(props);
}
;
export function TbCornerUpLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4"
      }
    }]
  })(props);
}
;
export function TbCornerUpRightDouble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18v-6a3 3 0 0 1 3 -3h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13l4 -4l-4 -4m5 8l4 -4l-4 -4"
      }
    }]
  })(props);
}
;
export function TbCornerUpRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4"
      }
    }]
  })(props);
}
;
export function TbCpu2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "5",
        "width": "14",
        "height": "14",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10v-2h2m6 6v2h-2m-4 0h-2v-2m8 -4v-2h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 14h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 21v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21v-2"
      }
    }]
  })(props);
}
;
export function TbCpuOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h9a1 1 0 0 1 1 1v9m-.292 3.706a0.997 .997 0 0 1 -.708 .294h-12a1 1 0 0 1 -1 -1v-12c0 -.272 .108 -.518 .284 -.698"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h2v2m0 4h-6v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 14h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 21v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCpu(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "5",
        "width": "14",
        "height": "14",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9h6v6h-6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 14h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 21v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21v-2"
      }
    }]
  })(props);
}
;
export function TbCraneOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21v-12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5v-2l-1.001 1.001"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.005 5.995l-3.005 3.005h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3l10 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 9v4a2 2 0 0 1 2 2m-2 2a2 2 0 0 1 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCrane(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21v-18l-6 6h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3l10 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 9v4a2 2 0 1 1 -2 2"
      }
    }]
  })(props);
}
;
export function TbCreativeCommonsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.638 5.634a9 9 0 1 0 12.723 12.733m1.686 -2.332a9 9 0 0 0 -12.093 -12.077"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 10.5a2.187 2.187 0 0 0 -2.914 .116a1.928 1.928 0 0 0 0 2.768a2.188 2.188 0 0 0 2.914 .116"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 10.5a2.194 2.194 0 0 0 -2.309 -.302"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCreativeCommons(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
      }
    }]
  })(props);
}
;
export function TbCreditCardOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h9a3 3 0 0 1 3 3v8a3 3 0 0 1 -.128 .87"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.87 18.872a3 3 0 0 1 -.87 .128h-12a3 3 0 0 1 -3 -3v-8c0 -1.352 .894 -2.495 2.124 -2.87"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "11",
        "x2": "11",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "11",
        "x2": "21",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "15",
        "x2": "7.01",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "15",
        "x2": "13",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbCreditCard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "15",
        "x2": "7.01",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "15",
        "x2": "13",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbCricket(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.105 18.79l-1.006 .992a4.159 4.159 0 0 1 -6.038 -5.715l.157 -.166l8.282 -8.401l1.5 1.5l3.45 -3.391a2.08 2.08 0 0 1 3.057 2.815l-.116 .126l-3.391 3.45l1.5 1.5l-3.668 3.617"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 7.5l6 6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "18",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbCrop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 5v10a1 1 0 0 0 1 1h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 8h10a1 1 0 0 1 1 1v10"
      }
    }]
  })(props);
}
;
export function TbCrossOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12h3v-4h-5v-5h-4v3m-2 2h-3v4h5v9h4v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCross(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21h4v-9h5v-4h-5v-5h-4v5h-5v4h5z"
      }
    }]
  })(props);
}
;
export function TbCrosshair(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbCrownOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18h-13l-1.865 -9.327a0.25 .25 0 0 1 .4 -.244l4.465 3.571l1.6 -2.4m1.596 -2.394l.804 -1.206l4 6l4.464 -3.571a0.25 .25 0 0 1 .401 .244l-1.363 6.818"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbCrown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z"
      }
    }]
  })(props);
}
;
export function TbCrutchesOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.178 4.174a2 2 0 0 1 1.822 -1.174h4a2 2 0 1 1 0 4h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 21h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-4.092a3 3 0 0 1 .504 -1.664l.992 -1.488a3 3 0 0 0 .097 -.155m.407 -3.601v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-4.092a3 3 0 0 0 -.504 -1.664l-.992 -1.488a3 3 0 0 1 -.504 -1.664v-2.092"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCrutches(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "3",
        "width": "8",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 21h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-4.092a3 3 0 0 1 .504 -1.664l.992 -1.488a3 3 0 0 0 .504 -1.664v-5.092"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-4.092a3 3 0 0 0 -.504 -1.664l-.992 -1.488a3 3 0 0 1 -.504 -1.664v-5.092"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11h4"
      }
    }]
  })(props);
}
;
export function TbCupOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8h-3v3h6m4 0h4v-3h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.5 11l-.323 2.154m-.525 3.497l-.652 4.349h-8l-1.5 -10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8v-1c0 -.296 .064 -.577 .18 -.83m2.82 -1.17h7a2 2 0 0 1 2 2v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCup(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 11h14v-3h-14z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.5 11l-1.5 10h-8l-1.5 -10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5v-2"
      }
    }]
  })(props);
}
;
export function TbCurling(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "9",
        "width": "16",
        "height": "10",
        "rx": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 14h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 5h6a2 2 0 0 1 2 2v2"
      }
    }]
  })(props);
}
;
export function TbCurlyLoop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 8c-4 0 -7 2 -7 5a3 3 0 0 0 6 0c0 -3 -2.5 -5 -8 -5s-8 2 -8 5a3 3 0 0 0 6 0c0 -3 -3 -5 -7 -5"
      }
    }]
  })(props);
}
;
export function TbCurrencyBahraini(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10v1a4 4 0 0 0 4 4h2a2 2 0 0 0 2 -2v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 19.01v-.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15.01v-.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 15h2.004a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
      }
    }]
  })(props);
}
;
export function TbCurrencyBaht(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 6h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 4v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 18v2"
      }
    }]
  })(props);
}
;
export function TbCurrencyBitcoin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6h8a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "6",
        "x2": "8",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "14",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "3",
        "x2": "9",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "3",
        "x2": "13",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "18",
        "x2": "9",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "18",
        "x2": "13",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbCurrencyCent(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.007 7.54a5.965 5.965 0 0 0 -4.008 -1.54a5.996 5.996 0 0 0 -5.992 6c0 3.314 2.682 6 5.992 6a5.965 5.965 0 0 0 4.004 -1.536"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v-2"
      }
    }]
  })(props);
}
;
export function TbCurrencyDinar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 20.01v-.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 13l2.386 -.9a1 1 0 0 0 -.095 -1.902l-1.514 -.404a1 1 0 0 1 -.102 -1.9l2.325 -.894"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14v1a3 3 0 0 0 3 3h4.161a3 3 0 0 0 2.983 -3.32l-1.144 -10.68"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 17l1 1h2.004a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
      }
    }]
  })(props);
}
;
export function TbCurrencyDirham(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.5 19h-3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.599 16.479a1.5 1.5 0 1 0 -1.099 2.521"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 4v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 13h1.888a1.5 1.5 0 0 0 1.296 -2.256l-2.184 -3.744"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 13.01v-.01"
      }
    }]
  })(props);
}
;
export function TbCurrencyDogecoin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 18h6a6 6 0 1 0 0 -12h-6"
      }
    }]
  })(props);
}
;
export function TbCurrencyDollarAustralian(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18l3.279 -11.476a0.75 .75 0 0 1 1.442 0l3.279 11.476"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 20v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 14h5"
      }
    }]
  })(props);
}
;
export function TbCurrencyDollarCanadian(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 18h-1a6 6 0 1 1 0 -12h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 20v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6v-2"
      }
    }]
  })(props);
}
;
export function TbCurrencyDollarSingapore(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h-4a3 3 0 1 0 0 6h1a3 3 0 0 1 0 6h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 20v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6v-2"
      }
    }]
  })(props);
}
;
export function TbCurrencyDollar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v3m0 12v3"
      }
    }]
  })(props);
}
;
export function TbCurrencyEthereum(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12l6 -9l6 9l-6 9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12l6 -3l6 3l-6 2z"
      }
    }]
  })(props);
}
;
export function TbCurrencyEuro(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.2 7a6 7 0 1 0 0 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 10h-8m0 4h8"
      }
    }]
  })(props);
}
;
export function TbCurrencyForint(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 4h-4a3 3 0 0 0 -3 3v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11h-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4v13a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 9h-5"
      }
    }]
  })(props);
}
;
export function TbCurrencyFrank(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 5h-6a2 2 0 0 0 -2 2v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 15h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 11h7"
      }
    }]
  })(props);
}
;
export function TbCurrencyKroneCzech(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12c3.5 0 6 -3 6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12c3.5 0 6 3 6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 6l-2 2l-2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 12h-2a3 3 0 0 0 0 6h2"
      }
    }]
  })(props);
}
;
export function TbCurrencyKroneDanish(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12c3.5 0 6 -3 6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12c3.5 0 6 3 6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 10a4 4 0 0 0 -4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 18.01v-.01"
      }
    }]
  })(props);
}
;
export function TbCurrencyKroneSwedish(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12c3.5 0 6 -3 6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12c3.5 0 6 3 6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 10a4 4 0 0 0 -4 4"
      }
    }]
  })(props);
}
;
export function TbCurrencyLeu(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 18h-7a3 3 0 0 1 -3 -3v-10"
      }
    }]
  })(props);
}
;
export function TbCurrencyLira(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5v15a7 7 0 0 0 7 -7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15l8 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 7l-8 4"
      }
    }]
  })(props);
}
;
export function TbCurrencyLitecoin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19h-8.194a2 2 0 0 1 -1.98 -2.283l1.674 -11.717"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 9l-9 4"
      }
    }]
  })(props);
}
;
export function TbCurrencyNaira(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18v-10.948a1.05 1.05 0 0 1 1.968 -.51l6.064 10.916a1.05 1.05 0 0 0 1.968 -.51v-10.948"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 10h14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 14h14"
      }
    }]
  })(props);
}
;
export function TbCurrencyPound(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 18.5a6 6 0 0 1 -5 0a6 6 0 0 0 -5 .5a3 3 0 0 0 2 -2.5v-7.5a4 4 0 0 1 7.45 -2m-2.55 6h-7"
      }
    }]
  })(props);
}
;
export function TbCurrencyReal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18v-12h3a3 3 0 1 1 0 6h-3c5.5 0 5 4 6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 20v-2"
      }
    }]
  })(props);
}
;
export function TbCurrencyRenminbi(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 9v8a2 2 0 1 0 4 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 9h-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5h-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9v4c0 2.5 -.667 4 -2 6"
      }
    }]
  })(props);
}
;
export function TbCurrencyRipple(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "7",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12h3l2 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 14.5l-2 -2.5"
      }
    }]
  })(props);
}
;
export function TbCurrencyRiyal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 9v2a2 2 0 1 1 -4 0v-1v1a2 2 0 1 1 -4 0v-1v4a2 2 0 1 1 -4 0v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 12.01v-.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 10v1a5 5 0 0 1 -5 5"
      }
    }]
  })(props);
}
;
export function TbCurrencyRubel(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 19v-14h6a3 3 0 0 1 0 6h-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15h-8"
      }
    }]
  })(props);
}
;
export function TbCurrencyRupee(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "9",
        "x2": "18",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbCurrencyShekel(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 18v-12h4a4 4 0 0 1 4 4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6v12h-4a4 4 0 0 1 -4 -4v-4"
      }
    }]
  })(props);
}
;
export function TbCurrencyTaka(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16.5",
        "cy": "15.5",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11h6"
      }
    }]
  })(props);
}
;
export function TbCurrencyTugrik(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 6h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 17l8 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 10l-8 3"
      }
    }]
  })(props);
}
;
export function TbCurrencyWon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6l3.245 11.358a0.85 .85 0 0 0 1.624 .035l3.131 -9.393l3.131 9.393a0.85 .85 0 0 0 1.624 -.035l3.245 -11.358"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10h-18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 14h-18"
      }
    }]
  })(props);
}
;
export function TbCurrencyYen(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19v-7l-5 -7m10 0l-5 7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "17",
        "x2": "16",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "13",
        "x2": "16",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbCurrencyZloty(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18h-7l7 -7h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 18v-13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 14.5l6 -3.5"
      }
    }]
  })(props);
}
;
export function TbCurrency(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20l-3 -3"
      }
    }]
  })(props);
}
;
export function TbCurrentLocationOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.685 10.661c-.3 -.6 -.795 -1.086 -1.402 -1.374m-3.397 .584a3 3 0 1 0 4.24 4.245"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.357 6.33a8 8 0 1 0 11.301 11.326m1.642 -2.378a8 8 0 0 0 -10.597 -10.569"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCurrentLocation(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "2",
        "x2": "12",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "22",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "2",
        "y1": "12",
        "x2": "4",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbCursorOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4a3 3 0 0 1 3 3v1m0 9a3 3 0 0 1 -3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4a3 3 0 0 0 -3 3v1m0 4v5a3 3 0 0 0 3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbCursorText(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3"
      }
    }]
  })(props);
}
;
export function TbCut(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "17",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9.15",
        "y1": "14.85",
        "x2": "18",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "4",
        "x2": "14.85",
        "y2": "14.85"
      }
    }]
  })(props);
}
;
export function TbDashboard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "13",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13.45",
        "y1": "11.55",
        "x2": "15.5",
        "y2": "9.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.4 20a9 9 0 1 1 11.2 0z"
      }
    }]
  })(props);
}
;
export function TbDatabaseExport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "6",
        "rx": "8",
        "ry": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v6c0 1.657 3.582 3 8 3a19.84 19.84 0 0 0 3.302 -.267m4.698 -2.733v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v6c0 1.599 3.335 2.905 7.538 2.995m8.462 -6.995v-2m-6 7h7m-3 -3l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbDatabaseImport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "6",
        "rx": "8",
        "ry": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v8m5.009 .783c.924 .14 1.933 .217 2.991 .217c4.418 0 8 -1.343 8 -3v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.252 20.987c.246 .009 .496 .013 .748 .013c4.418 0 8 -1.343 8 -3v-6m-18 7h7m-3 -3l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbDatabaseOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.983 8.978c3.955 -.182 7.017 -1.446 7.017 -2.978c0 -1.657 -3.582 -3 -8 -3c-1.661 0 -3.204 .19 -4.483 .515m-2.783 1.228c-.471 .382 -.734 .808 -.734 1.257c0 1.22 1.944 2.271 4.734 2.74"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v6c0 1.657 3.582 3 8 3c.986 0 1.93 -.067 2.802 -.19m3.187 -.82c1.251 -.53 2.011 -1.228 2.011 -1.99v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v6c0 1.657 3.582 3 8 3c3.217 0 5.991 -.712 7.261 -1.74m.739 -3.26v-4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbDatabase(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "6",
        "rx": "8",
        "ry": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v6a8 3 0 0 0 16 0v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v6a8 3 0 0 0 16 0v-6"
      }
    }]
  })(props);
}
;
export function TbDentalOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.277 15.281c.463 -1.75 .723 -3.844 .723 -6.281c0 -3.74 -1.908 -4.994 -4 -5c-1.423 -.004 -2.92 .911 -4 1.5c-1.074 -.586 -2.583 -1.5 -4 -1.5m-2.843 1.153c-.707 .784 -1.157 2.017 -1.157 3.847c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 .004 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 1.994 .993 2.567 .237c.305 -.402 .59 -.853 .852 -1.353"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5.5l3 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDental(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5.5c-1.074 -.586 -2.583 -1.5 -4 -1.5c-2.1 -.001 -4 1.247 -4 5c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 .004 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 1.994 .993 2.567 .237c1.615 -2.127 2.671 -5.637 2.671 -10.537c0 -3.74 -1.908 -4.994 -4 -5c-1.423 -.004 -2.92 .911 -4 1.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5.5l3 1.5"
      }
    }]
  })(props);
}
;
export function TbDetails(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v16"
      }
    }]
  })(props);
}
;
export function TbDeviceAnalytics(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "12",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "20",
        "x2": "17",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "16",
        "x2": "9",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "16",
        "x2": "15",
        "y2": "20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12l3 -3l2 2l3 -3"
      }
    }]
  })(props);
}
;
export function TbDeviceAudioTape(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17l4 -3h10l4 3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7.5",
        "cy": "9.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16.5",
        "cy": "9.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbDeviceCctv(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 7v7a7 7 0 0 1 -14 0v-7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "12.01",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbDeviceComputerCameraOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.15 6.153a7 7 0 0 0 9.696 9.696m2 -2a7 7 0 0 0 -9.699 -9.695"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.13 9.122a3 3 0 0 0 3.743 3.749m2 -2a3 3 0 0 0 -3.737 -3.736"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbDeviceComputerCamera(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "10",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
      }
    }]
  })(props);
}
;
export function TbDeviceDesktopAnalytics(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "12",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 16v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v-1"
      }
    }]
  })(props);
}
;
export function TbDeviceDesktopOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h12a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1m-4 0h-12a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "20",
        "x2": "17",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "16",
        "x2": "9",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "16",
        "x2": "15",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbDeviceDesktop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "12",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "20",
        "x2": "17",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "16",
        "x2": "9",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "16",
        "x2": "15",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbDeviceFloppy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "14 4 14 8 8 8 8 4"
      }
    }]
  })(props);
}
;
export function TbDeviceGamepad2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5h3.5a5 5 0 0 1 0 10h-5.5l-4.015 4.227a2.3 2.3 0 0 1 -3.923 -2.035l1.634 -8.173a5 5 0 0 1 4.904 -4.019h3.4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15l4.07 4.284a2.3 2.3 0 0 0 3.925 -2.023l-1.6 -8.232"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 9v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 10h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10h2"
      }
    }]
  })(props);
}
;
export function TbDeviceGamepad(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "6",
        "width": "20",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12h4m-2 -2v4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "11",
        "x2": "15",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "13",
        "x2": "18",
        "y2": "13.01"
      }
    }]
  })(props);
}
;
export function TbDeviceHeartMonitor(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 9h6l1 -2l2 4l1 -2h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 14h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v.01"
      }
    }]
  })(props);
}
;
export function TbDeviceLaptopOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h8a1 1 0 0 1 1 1v8m-3 1h-10a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDeviceLaptop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "19",
        "x2": "21",
        "y2": "19"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "6",
        "width": "14",
        "height": "10",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbDeviceMobileMessage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 3h10v8h-3l-4 2v-2h-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 16v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 18v.01"
      }
    }]
  })(props);
}
;
export function TbDeviceMobileOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.174 3.178c.252 -.114 .531 -.178 .826 -.178h8a2 2 0 0 1 2 2v9m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 4h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDeviceMobileRotated(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "6",
        "width": "18",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 11v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12h-.01"
      }
    }]
  })(props);
}
;
export function TbDeviceMobileVibration(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "12",
        "height": "18",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "10",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "17",
        "x2": "9",
        "y2": "17.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 6l-2 3l2 3l-2 3l2 3"
      }
    }]
  })(props);
}
;
export function TbDeviceMobile(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "3",
        "width": "12",
        "height": "18",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "4",
        "x2": "13",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "17.01"
      }
    }]
  })(props);
}
;
export function TbDeviceNintendoOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.713 4.718a3.995 3.995 0 0 0 -1.713 3.282v8a4 4 0 0 0 4 4h3v-10m0 -4v-2h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10v-6h3a4 4 0 0 1 4 4v8c0 .308 -.035 .608 -.1 .896m-1.62 2.39a3.982 3.982 0 0 1 -2.28 .714h-3v-6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6.5",
        "cy": "8.5",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDeviceNintendo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 20v-16h-3a4 4 0 0 0 -4 4v8a4 4 0 0 0 4 4h3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 20v-16h3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-3z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17.5",
        "cy": "15.5",
        "r": "1",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6.5",
        "cy": "8.5",
        "r": "1",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbDeviceSpeakerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.114 11.133a3.001 3.001 0 1 0 3.754 3.751"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDeviceSpeaker(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "3",
        "width": "14",
        "height": "18",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "7",
        "x2": "12",
        "y2": "7.01"
      }
    }]
  })(props);
}
;
export function TbDeviceTabletOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h11a1 1 0 0 1 1 1v11m0 4v1a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-15"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "17",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDeviceTablet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "3",
        "width": "14",
        "height": "18",
        "rx": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "17",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbDeviceTvOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h8a2 2 0 0 1 2 2v8m-1.178 2.824c-.25 .113 -.529 .176 -.822 .176h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3l-4 4l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDeviceTvOld(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "7",
        "width": "18",
        "height": "13",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3l-4 4l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 7v13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 12v.01"
      }
    }]
  })(props);
}
;
export function TbDeviceTv(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "7",
        "width": "18",
        "height": "13",
        "rx": "2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 3 12 7 8 3"
      }
    }]
  })(props);
}
;
export function TbDeviceWatchOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h5a3 3 0 0 1 3 3v5m-.882 3.125a2.99 2.99 0 0 1 -2.118 .875h-6a3 3 0 0 1 -3 -3v-6c0 -.828 .336 -1.578 .878 -2.121"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18v3h6v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5v-2h6v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDeviceWatchStats2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "6",
        "width": "12",
        "height": "12",
        "rx": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18v3h6v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 6v-3h6v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10a2 2 0 1 0 2 2"
      }
    }]
  })(props);
}
;
export function TbDeviceWatchStats(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "6",
        "width": "12",
        "height": "12",
        "rx": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18v3h6v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 6v-3h6v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 14v-3"
      }
    }]
  })(props);
}
;
export function TbDeviceWatch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "6",
        "width": "12",
        "height": "12",
        "rx": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18v3h6v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 6v-3h6v3"
      }
    }]
  })(props);
}
;
export function TbDevices2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 15h-6a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h6"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "13",
        "y": "4",
        "width": "8",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "19",
        "x2": "10",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "8",
        "x2": "17",
        "y2": "8.01"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "16",
        "r": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "9",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbDevicesOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v8m-1 3h-6a1 1 0 0 1 -1 -1v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 8v-3a1 1 0 0 0 -1 -1h-9m-4 0a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 9h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDevicesPcOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9v10h-6v-14h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h9v7h-2m-4 0h-4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 19h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 13v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDevicesPc(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 5h6v14h-6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9h10v7h-10z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 19h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 16v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 13v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 16v.01"
      }
    }]
  })(props);
}
;
export function TbDevices(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "13",
        "y": "8",
        "width": "8",
        "height": "12",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "9",
        "x2": "18",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbDialpadOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7h-4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6v-3h4v4h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13v-3h4v4h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 14h-4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 17h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDialpad(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 10h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 17h4v4h-4z"
      }
    }]
  })(props);
}
;
export function TbDiamondOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h9l3 5l-3.308 3.697m-1.883 2.104l-3.309 3.699a0.7 .7 0 0 1 -1 0l-8.5 -9.5l2.62 -4.368"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12l-2 -2.2l.6 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDiamond(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 5h12l3 5l-8.5 9.5a0.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12l-2 -2.2l.6 -1"
      }
    }]
  })(props);
}
;
export function TbDiamonds(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.831 20.413l-5.375 -6.91c-.608 -.783 -.608 -2.223 0 -3.005l5.375 -6.911a1.457 1.457 0 0 1 2.338 0l5.375 6.91c.608 .783 .608 2.223 0 3.005l-5.375 6.911a1.457 1.457 0 0 1 -2.338 0z"
      }
    }]
  })(props);
}
;
export function TbDice1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbDice2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9.5",
        "cy": "9.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14.5",
        "cy": "14.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbDice3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "8.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "15.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbDice4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "8.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "8.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "15.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "15.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbDice5(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "8.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "8.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "15.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "15.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbDice6(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "7.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "7.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "12",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "12",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "16.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "16.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbDice(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "8.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "8.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "15.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "15.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbDimensions(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 5h11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7l2 -2l-2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 3l-2 2l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 10v11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 19l2 2l2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12l-2 -2l-2 2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "10",
        "width": "11",
        "height": "11",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbDirectionHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 9l-3 3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 9l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbDirection(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10l3 -3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14l3 3l3 -3"
      }
    }]
  })(props);
}
;
export function TbDirectionsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8v1h1m4 0h6l2 -2l-2 -2h-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 14v3h-8l-2 -2l2 -2h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDirections(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 5v4h11l2 -2l-2 -2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 13v4h-8l-2 -2l2 -2z"
      }
    }]
  })(props);
}
;
export function TbDisabled2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 11a5 5 0 1 0 3.95 7.95"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 20l-4 -5h-4l3 -5l-4 -3l-4 1"
      }
    }]
  })(props);
}
;
export function TbDisabledOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7a2 2 0 1 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11v4h4l4 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11.5a5 5 0 1 0 6 7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDisabled(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "11 7 11 15 15 15 19 20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "11",
        "x2": "16",
        "y2": "11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11.5a5 5 0 1 0 6 7.5"
      }
    }]
  })(props);
}
;
export function TbDiscOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.044 16.04a9 9 0 0 0 -12.082 -12.085m-2.333 1.688a9 9 0 0 0 6.371 15.357c2.491 0 4.73 -.997 6.36 -2.631"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.298 11.288a1 1 0 1 0 1.402 1.427"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12c0 -1.38 .559 -2.629 1.462 -3.534m2.607 -1.38c.302 -.056 .613 -.086 .931 -.086"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17a4.985 4.985 0 0 0 3.551 -1.48m1.362 -2.587c.057 -.302 .087 -.614 .087 -.933"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDisc(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12a5 5 0 0 1 5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17a5 5 0 0 0 5 -5"
      }
    }]
  })(props);
}
;
export function TbDiscount2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "15",
        "y2": "9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9.5",
        "cy": "9.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14.5",
        "cy": "14.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
      }
    }]
  })(props);
}
;
export function TbDiscount(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "15",
        "y2": "9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9.5",
        "cy": "9.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14.5",
        "cy": "14.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbDivide(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "fill": "currentColor",
        "cx": "12",
        "cy": "6",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "fill": "currentColor",
        "cx": "12",
        "cy": "18",
        "r": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbDna2Off(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3v1c-.007 2.46 -.91 4.554 -2.705 6.281m-2.295 1.719c-3.328 1.99 -4.997 4.662 -5.008 8.014v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21.014v-1c-.004 -1.44 -.315 -2.755 -.932 -3.944m-4.068 -4.07c-1.903 -1.138 -3.263 -2.485 -4.082 -4.068"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDna2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3v1c-.01 3.352 -1.68 6.023 -5.008 8.014c-3.328 1.99 3.336 -2.005 .008 -.014c-3.328 1.99 -4.997 4.662 -5.008 8.014v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21.014v-1c-.01 -3.352 -1.68 -6.023 -5.008 -8.014c-3.328 -1.99 3.336 2.005 .008 .014c-3.328 -1.991 -4.997 -4.662 -5.008 -8.014v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 4h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16h8"
      }
    }]
  })(props);
}
;
export function TbDnaOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12a3.898 3.898 0 0 0 -1.172 -2.828a4.027 4.027 0 0 0 -2.828 -1.172m-2.828 1.172a4 4 0 1 0 5.656 5.656"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.172 20.485a4 4 0 1 0 -5.657 -5.657"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.828 3.515a4 4 0 1 0 5.657 5.657"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDna(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "rotate(-45 12 12)",
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.172 20.485a4 4 0 1 0 -5.657 -5.657"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.828 3.515a4 4 0 1 0 5.657 5.657"
      }
    }]
  })(props);
}
;
export function TbDogBowl(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 15l5.586 -5.585a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-3.587 3.586"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13l-3.586 -3.585a2 2 0 1 0 -3.414 -1.415a2 2 0 1 0 1.413 3.414l3.587 3.586"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20h18c-.175 -1.671 -.046 -3.345 -2 -5h-14c-1.333 1 -2 2.667 -2 5z"
      }
    }]
  })(props);
}
;
export function TbDoorEnter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-16a2 2 0 0 1 2 -2h6m4 10.5v7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 7h-7m3 -3l-3 3l3 3"
      }
    }]
  })(props);
}
;
export function TbDoorExit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-16a2 2 0 0 1 2 -2h7.5m2.5 10.5v7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 7h7m-3 -3l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbDoorOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21v-15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.18 3.175c.25 -.112 .528 -.175 .82 -.175h8a2 2 0 0 1 2 2v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDoor(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21v-16a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v16"
      }
    }]
  })(props);
}
;
export function TbDotsCircleHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "8",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "16",
        "y2": "12.01"
      }
    }]
  })(props);
}
;
export function TbDotsDiagonal2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "7",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbDotsDiagonal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "17",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "7",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbDotsVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "19",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbDots(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "12",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbDownloadOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 1.83 -1.19"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11l5 5l2.005 -2.005m1.994 -1.994l1.001 -1.001"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v4m0 4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDownload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 11 12 16 17 11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbDragDrop2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "8",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "4",
        "x2": "16",
        "y2": "4.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "4",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "4",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "4",
        "y2": "16.01"
      }
    }]
  })(props);
}
;
export function TbDragDrop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 11v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 13l9 3l-4 2l-2 4l-3 -9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "3",
        "y2": "3.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "3",
        "x2": "7",
        "y2": "3.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "3",
        "x2": "11",
        "y2": "3.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "3",
        "x2": "15",
        "y2": "3.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "7",
        "x2": "3",
        "y2": "7.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "11",
        "x2": "3",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "15",
        "x2": "3",
        "y2": "15.01"
      }
    }]
  })(props);
}
;
export function TbDroneOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 14h-4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10l-3.5 -3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.957 5.95a3.503 3.503 0 0 0 -2.917 -2.91m-3.02 .989a3.5 3.5 0 0 0 1.98 5.936"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10l3.5 -3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 9.965a3.5 3.5 0 1 0 -3.966 -3.965"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "14",
        "x2": "17.5",
        "y2": "17.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.035 18a3.5 3.5 0 0 0 5.936 1.98m.987 -3.026a3.503 3.503 0 0 0 -2.918 -2.913"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "14",
        "x2": "6.5",
        "y2": "17.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 14.035a3.5 3.5 0 1 0 3.966 3.965"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbDrone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10h4v4h-4z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "10",
        "x2": "6.5",
        "y2": "6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.96 6a3.5 3.5 0 1 0 -3.96 3.96"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10l3.5 -3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 9.96a3.5 3.5 0 1 0 -3.96 -3.96"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "14",
        "x2": "17.5",
        "y2": "17.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.04 18a3.5 3.5 0 1 0 3.96 -3.96"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "14",
        "x2": "6.5",
        "y2": "17.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 14.04a3.5 3.5 0 1 0 3.96 3.96"
      }
    }]
  })(props);
}
;
export function TbDropCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.07 15.34c1.115 .88 2.74 .88 3.855 0c1.115 -.88 1.398 -2.388 .671 -3.575l-2.596 -3.765l-2.602 3.765c-.726 1.187 -.443 2.694 .672 3.575z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbDropletFilled2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 14h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.305 17.695l3.695 -3.695"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.26 19.74l5.74 -5.74l-5.74 5.74z"
      }
    }]
  })(props);
}
;
export function TbDropletFilled(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l3.544 -3.544"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17.3l5.558 -5.558"
      }
    }]
  })(props);
}
;
export function TbDropletHalf2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 14h12"
      }
    }]
  })(props);
}
;
export function TbDropletHalf(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v17"
      }
    }]
  })(props);
}
;
export function TbDropletOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.454 8.458l-1.653 2.545a6 6 0 0 0 10.32 6.123"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 14a5.971 5.971 0 0 0 -.803 -3l-5.197 -8l-1.968 3.03"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbDroplet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
      }
    }]
  })(props);
}
;
export function TbEarOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10c0 -1.146 .277 -2.245 .78 -3.219m1.792 -2.208a7 7 0 0 1 10.428 9.027a10 10 0 0 1 -.633 .762m-2.045 1.96a8 8 0 0 0 -1.322 2.278a4.5 4.5 0 0 1 -6.8 1.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.42 7.414a3 3 0 0 1 4.131 4.13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbEar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10a7 7 0 1 1 13 3.6a10 10 0 0 1 -2 2a8 8 0 0 0 -2 3a4.5 4.5 0 0 1 -6.8 1.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10a3 3 0 1 1 5 2.2"
      }
    }]
  })(props);
}
;
export function TbEditCircleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.507 10.498l-1.507 1.502v3h3l1.493 -1.498m2.002 -2.01l4.89 -4.907a2.1 2.1 0 0 0 -2.97 -2.97l-4.913 4.896"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.476 7.471a7.002 7.002 0 0 0 2.524 13.529a7.004 7.004 0 0 0 6.53 -4.474"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbEditCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15l8.385 -8.415a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 7.07a7.002 7.002 0 0 0 1 13.93a7.002 7.002 0 0 0 6.929 -5.999"
      }
    }]
  })(props);
}
;
export function TbEditOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.507 10.498l-1.507 1.502v3h3l1.493 -1.498m2.002 -2.01l4.89 -4.907a2.1 2.1 0 0 0 -2.97 -2.97l-4.913 4.896"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbEdit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5l3 3"
      }
    }]
  })(props);
}
;
export function TbEggOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.41 7.41a12.574 12.574 0 0 0 -1.896 7.229c0 3.513 2.904 6.361 6.486 6.361a6.504 6.504 0 0 0 5.692 -3.31m.8 -3.192a12.574 12.574 0 0 0 -3.249 -8.871a4.025 4.025 0 0 0 -3.243 -1.627a4.026 4.026 0 0 0 -2.832 1.155"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbEgg(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.514 14.639c0 3.513 2.904 6.361 6.486 6.361s6.486 -2.848 6.486 -6.361a12.574 12.574 0 0 0 -3.243 -9.012a4.025 4.025 0 0 0 -3.243 -1.627a4.025 4.025 0 0 0 -3.243 1.627a12.574 12.574 0 0 0 -3.243 9.012"
      }
    }]
  })(props);
}
;
export function TbElevator(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "4",
        "width": "14",
        "height": "16",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10l2 -2l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14l2 2l2 -2"
      }
    }]
  })(props);
}
;
export function TbEmergencyBed(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8l2.1 2.8a3 3 0 0 0 2.4 1.2h11.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v2l-2.5 2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.5 16.5l-2.5 -2.5"
      }
    }]
  })(props);
}
;
export function TbEmphasis(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5h-8v10h8m-1 -5h-7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "20",
        "x2": "6",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "20",
        "x2": "10",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "20",
        "x2": "14",
        "y2": "20.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "20",
        "x2": "18",
        "y2": "20.01"
      }
    }]
  })(props);
}
;
export function TbEngineOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 13h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16h-1v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6h2l.99 -.99m3.01 -1.01h1.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbEngine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 13h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10h2l2 -2h3.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2v-2h-3v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6z"
      }
    }]
  })(props);
}
;
export function TbEqualNot(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 9h14m-14 6h14m0 -10l-14 14"
      }
    }]
  })(props);
}
;
export function TbEqual(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 9h14m-14 6h14"
      }
    }]
  })(props);
}
;
export function TbEraserOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l4.995 -4.993m2.009 -2.01l2.997 -2.996a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41c-1.417 1.431 -2.406 2.432 -2.97 3m-2.02 2.043l-4.211 4.256"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 13.3l-6.3 -6.3"
      }
    }]
  })(props);
}
;
export function TbEraser(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 13.3l-6.3 -6.3"
      }
    }]
  })(props);
}
;
export function TbError404Off(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7v4a1 1 0 0 0 1 1h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2m0 -4v-2a1 1 0 0 0 -1 -1h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 7v4a1 1 0 0 0 1 1h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 7v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbError404(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7v4a1 1 0 0 0 1 1h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 8v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 7v4a1 1 0 0 0 1 1h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 7v10"
      }
    }]
  })(props);
}
;
export function TbExchangeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 8v5c0 .594 -.104 1.164 -.294 1.692m-1.692 2.298a4.978 4.978 0 0 1 -3.014 1.01h-3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 21l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 16v-5c0 -1.632 .782 -3.082 1.992 -3.995m3.008 -1.005h3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.501 7.499l1.499 -1.499"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbExchange(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"
      }
    }]
  })(props);
}
;
export function TbExclamationMarkOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15v-3m0 -4v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbExclamationMark(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15v-10"
      }
    }]
  })(props);
}
;
export function TbExposure(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.6",
        "y1": "19.4",
        "x2": "19.4",
        "y2": "4.6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 9h4m-2 -2v4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "16",
        "x2": "17",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbExternalLinkOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14l1.996 -1.996m2.007 -2.007l5.997 -5.997"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4h5v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbExternalLink(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h-5a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "14",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 4 20 4 20 9"
      }
    }]
  })(props);
}
;
export function TbEyeCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19c-4 0 -7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7c-.42 .736 -.858 1.414 -1.311 2.033"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 19l2 2l4 -4"
      }
    }]
  })(props);
}
;
export function TbEyeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.584 10.587a2 2 0 0 0 2.828 2.83"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341"
      }
    }]
  })(props);
}
;
export function TbEyeTable(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.003 18.003h-.011"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.003 18.002h-.011"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.003 18.002h-.011"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 3h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 3v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 7h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11v-4"
      }
    }]
  })(props);
}
;
export function TbEye(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7"
      }
    }]
  })(props);
}
;
export function TbEyeglass2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h-2l-3 10v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2l3 10v2.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "16",
        "x2": "14",
        "y2": "16"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17.5",
        "cy": "16.5",
        "r": "3.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6.5",
        "cy": "16.5",
        "r": "3.5"
      }
    }]
  })(props);
}
;
export function TbEyeglassOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.536 5.546l-2.536 8.454"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2l3 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.426 19.423a3.5 3.5 0 0 1 -5.426 -2.923v-2.5m4 0h3v2.5c0 .157 -.01 .312 -.03 .463"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbEyeglass(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h-2l-3 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2l3 10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "16",
        "x2": "14",
        "y2": "16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
      }
    }]
  })(props);
}
;
export function TbFaceIdError(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15.05a3.5 3.5 0 0 1 5 0"
      }
    }]
  })(props);
}
;
export function TbFaceId(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "9.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "10",
        "x2": "15.01",
        "y2": "10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
      }
    }]
  })(props);
}
;
export function TbFaceMaskOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.002 14.5h-.222c-1.535 0 -2.778 -1.12 -2.778 -2.5s1.243 -2.5 2.778 -2.5h.222"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.002 14.5h.222c1.534 0 2.778 -1.12 2.778 -2.5s-1.244 -2.5 -2.778 -2.5h-.222"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10h1m4 0h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 15v-6.49a2 2 0 0 0 -1.45 -1.923l-5 -1.429a2 2 0 0 0 -1.1 0l-1.788 .511m-3.118 .891l-.094 .027a2 2 0 0 0 -1.45 1.922v6.982a2 2 0 0 0 1.45 1.923l5 1.429a2 2 0 0 0 1.1 0l4.899 -1.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFaceMask(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.002 14.5h-.222c-1.535 0 -2.778 -1.12 -2.778 -2.5s1.243 -2.5 2.778 -2.5h.222"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.002 14.5h.222c1.534 0 2.778 -1.12 2.778 -2.5s-1.244 -2.5 -2.778 -2.5h-.222"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.55 18.843l5 -1.429a2 2 0 0 0 1.45 -1.923v-6.981a2 2 0 0 0 -1.45 -1.923l-5 -1.429a2 2 0 0 0 -1.1 0l-5 1.429a2 2 0 0 0 -1.45 1.922v6.982a2 2 0 0 0 1.45 1.923l5 1.429a2 2 0 0 0 1.1 0z"
      }
    }]
  })(props);
}
;
export function TbFall(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 21l1 -5l-1 -4l-3 -4h4l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 16l-1 -4l3 -4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 12h2.5l4 2"
      }
    }]
  })(props);
}
;
export function TbFeatherOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20l8 -8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 5v5h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 11v4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 13v5h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 13l3.502 -3.502m2.023 -2.023l2.475 -2.475"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 18l3.499 -3.499m2.008 -2.008l2.493 -2.493"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFeather(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20l10 -10m0 -5v5h5m-9 -1v5h5m-9 -1v5h5m-5 -5l4 -4l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1m-3 13l4 -4l4 -4"
      }
    }]
  })(props);
}
;
export function TbFenceOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12h-8v4h12m4 0v-4h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 16v4h4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12v-2m0 -4l-2 -2m-2 2v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 16v4h4v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 12v-6l-2 -2l-2 2v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFence(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v4h16v-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6"
      }
    }]
  })(props);
}
;
export function TbFidgetSpinner(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 17a3 3 0 1 1 -1.543 -2.623l2.087 -3.754a3 3 0 0 1 1.456 -5.623a3 3 0 0 1 1.457 5.623l2.087 3.754a3 3 0 1 1 -1.538 2.8l-.006 -.177h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8v.01"
      }
    }]
  })(props);
}
;
export function TbFile3D(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13.5l4 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11.846l4 1.654v4.5l4 -1.846v-4.308l-4 -1.846z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12v4.2l4 1.8"
      }
    }]
  })(props);
}
;
export function TbFileAlert(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12.01",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "11",
        "x2": "12",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbFileAnalytics(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "17",
        "x2": "9",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "17",
        "x2": "15",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbFileArrowLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 15h-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 17.5l-2.5 -2.5l2.5 -2.5"
      }
    }]
  })(props);
}
;
export function TbFileArrowRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 17.5l2.5 -2.5l-2.5 -2.5"
      }
    }]
  })(props);
}
;
export function TbFileBarcode(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13h1v3h-1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 13h1v3h-1z"
      }
    }]
  })(props);
}
;
export function TbFileCertificate(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "14",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 17l-1.5 5l3 -1.5l3 1.5l-1.5 -5"
      }
    }]
  })(props);
}
;
export function TbFileChart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10v4h4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "4"
      }
    }]
  })(props);
}
;
export function TbFileCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15l2 2l4 -4"
      }
    }]
  })(props);
}
;
export function TbFileCode2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12h-1v5h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 12h1v5h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }]
  })(props);
}
;
export function TbFileCode(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13l-1 2l1 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 13l1 2l-1 2"
      }
    }]
  })(props);
}
;
export function TbFileDatabase(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "12.75",
        "rx": "4",
        "ry": "1.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12.5v3.75c0 .966 1.79 1.75 4 1.75s4 -.784 4 -1.75v-3.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }]
  })(props);
}
;
export function TbFileDescription(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 13h6"
      }
    }]
  })(props);
}
;
export function TbFileDiff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "10",
        "x2": "12",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "14",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "17",
        "x2": "14",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbFileDigit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "12",
        "width": "3",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12v5"
      }
    }]
  })(props);
}
;
export function TbFileDislike(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "14",
        "width": "3",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15a1 1 0 0 1 1 -1h3.756a1 1 0 0 1 .958 .713l1.2 3c.09 .303 .133 .63 -.056 .884c-.188 .254 -.542 .403 -.858 .403h-2v2.467a1.1 1.1 0 0 1 -2.015 .61l-1.985 -3.077v-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.5"
      }
    }]
  })(props);
}
;
export function TbFileDollar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v1m0 -8v1"
      }
    }]
  })(props);
}
;
export function TbFileDots(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 14v.01"
      }
    }]
  })(props);
}
;
export function TbFileDownload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 14.5l2.5 2.5l2.5 -2.5"
      }
    }]
  })(props);
}
;
export function TbFileEuro(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.004 11.172a3 3 0 1 0 -.001 5.656"
      }
    }]
  })(props);
}
;
export function TbFileExport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbFileHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
      }
    }]
  })(props);
}
;
export function TbFileImport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 13v-8a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5.5m-9.5 -2h7m-3 -3l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbFileInfo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 14h1v4h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11h.01"
      }
    }]
  })(props);
}
;
export function TbFileInvoice(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "7",
        "x2": "10",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "13",
        "x2": "15",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "17",
        "x2": "15",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbFileLike(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "16",
        "width": "3",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20a1 1 0 0 0 1 1h3.756a1 1 0 0 0 .958 -.713l1.2 -3c.09 -.303 .133 -.63 -.056 -.884c-.188 -.254 -.542 -.403 -.858 -.403h-2v-2.467a1.1 1.1 0 0 0 -2.015 -.61l-1.985 3.077v4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12.1v-7.1a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.3"
      }
    }]
  })(props);
}
;
export function TbFileMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "14",
        "x2": "15",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbFileMusic(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "16",
        "r": "1"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 16 12 11 14 12"
      }
    }]
  })(props);
}
;
export function TbFileOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h7l5 5v7m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
      }
    }]
  })(props);
}
;
export function TbFilePencil(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 18l5 -5a1.414 1.414 0 0 0 -2 -2l-5 5v2h2z"
      }
    }]
  })(props);
}
;
export function TbFilePhone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1"
      }
    }]
  })(props);
}
;
export function TbFilePlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "11",
        "x2": "12",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "14",
        "x2": "15",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbFilePower(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11l-2 3h4l-2 3"
      }
    }]
  })(props);
}
;
export function TbFileReport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13v4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v2m0 3v4"
      }
    }]
  })(props);
}
;
export function TbFileRss(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17a3 3 0 0 0 -3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 17a6 6 0 0 0 -6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17h.01"
      }
    }]
  })(props);
}
;
export function TbFileScissors(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "17",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "17",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17l6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 17l-6 -6"
      }
    }]
  })(props);
}
;
export function TbFileSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v4.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16.5",
        "cy": "17.5",
        "r": "2.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18.5",
        "y1": "19.5",
        "x2": "21",
        "y2": "22"
      }
    }]
  })(props);
}
;
export function TbFileSettings(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10.5v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.031 12.25l-1.299 .75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.268 15l-1.3 .75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 15.803l-1.285 -.773"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.285 12.97l-1.285 -.773"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }]
  })(props);
}
;
export function TbFileShredder(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "16",
        "x2": "6",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "16",
        "x2": "10",
        "y2": "22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "16",
        "x2": "14",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "16",
        "x2": "18",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbFileSignal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.525 11.525a3.5 3.5 0 0 0 0 4.95m4.95 0a3.5 3.5 0 0 0 0 -4.95"
      }
    }]
  })(props);
}
;
export function TbFileSpreadsheet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11h8v7h-8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 15h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11v7"
      }
    }]
  })(props);
}
;
export function TbFileStar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.8 16.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
      }
    }]
  })(props);
}
;
export function TbFileSymlink(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21v-4a3 3 0 0 1 3 -3h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17l3 -3l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-9.5"
      }
    }]
  })(props);
}
;
export function TbFileText(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "9",
        "x2": "10",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "13",
        "x2": "15",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "17",
        "x2": "15",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbFileTime(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12.496v1.504l1 1"
      }
    }]
  })(props);
}
;
export function TbFileTypography(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12v-1h6v1"
      }
    }]
  })(props);
}
;
export function TbFileUnknown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14a1.5 1.5 0 1 0 -1.14 -2.474"
      }
    }]
  })(props);
}
;
export function TbFileUpload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 13.5l2.5 -2.5l2.5 2.5"
      }
    }]
  })(props);
}
;
export function TbFileVector(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9.5",
        "cy": "16.5",
        "r": "1.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14.5",
        "cy": "12.5",
        "r": "1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15a2.5 2.5 0 0 1 2.5 -2.5h1"
      }
    }]
  })(props);
}
;
export function TbFileX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbFileZip(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20.735a2 2 0 0 1 -1 -1.735v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 17a2 2 0 0 1 2 2v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a2 2 0 0 1 2 -2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "5",
        "x2": "10",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "7",
        "x2": "12",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "9",
        "x2": "10",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "11",
        "x2": "12",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "13",
        "x2": "10",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "15",
        "x2": "12",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbFile(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
      }
    }]
  })(props);
}
;
export function TbFilesOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h-6a2 2 0 0 1 -2 -2v-6m0 -4a2 2 0 0 1 2 -2h4l5 5v7c0 .294 -.063 .572 -.177 .823"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbFiles(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 17h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h4l5 5v7a2 2 0 0 1 -2 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
      }
    }]
  })(props);
}
;
export function TbFilterOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h9.5a1 1 0 0 1 .5 1.5l-4.049 4.454m-.951 3.046v5l-4 -3v-4l-5 -5.5a1 1 0 0 1 .18 -1.316"
      }
    }]
  })(props);
}
;
export function TbFilter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"
      }
    }]
  })(props);
}
;
export function TbFingerprintOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11c0 -.848 .264 -1.634 .713 -2.28m2.4 -1.621a4 4 0 0 1 4.887 3.901l-.001 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v1a14 14 0 0 0 2.5 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 15a18 18 0 0 0 1.8 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 1.854 -5.143m2.176 -1.825a8 8 0 0 1 7.97 .018"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFingerprint(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11v2a14 14 0 0 0 2.5 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 15a18 18 0 0 0 1.8 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95"
      }
    }]
  })(props);
}
;
export function TbFiretruck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v-11h3"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "3 17 3 12 12 12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "9",
        "x2": "21",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "6",
        "y2": "8"
      }
    }]
  })(props);
}
;
export function TbFirstAidKit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "8",
        "width": "16",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v4"
      }
    }]
  })(props);
}
;
export function TbFishOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.69 7.44a6.973 6.973 0 0 0 -1.63 3.635"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 9.504c5.307 5.948 10.293 8.57 14.597 7.1m2.583 -1.449c.988 -.788 1.93 -1.836 2.82 -3.153c-3.005 -4.443 -6.596 -5.812 -10.564 -4.548m-2.764 1.266c-2.145 1.266 -4.378 3.215 -6.672 5.786"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 11v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.153 11.169c-.287 .777 -.171 1.554 .347 2.331"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFish(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.69 7.44a6.973 6.973 0 0 0 -1.69 4.56c0 1.747 .64 3.345 1.699 4.571"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 9.504c7.715 8.647 14.75 10.265 20 2.498c-5.25 -7.761 -12.285 -6.142 -20 2.504"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 11v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 10.5c-.667 1 -.667 2 0 3"
      }
    }]
  })(props);
}
;
export function TbFlag2Off(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 14h9m4 0h1v-9h-10m-4 0v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFlag2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 14h14v-9h-14v16"
      }
    }]
  })(props);
}
;
export function TbFlag3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16"
      }
    }]
  })(props);
}
;
export function TbFlagOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.641 3.645a4.994 4.994 0 0 1 4.359 1.355a5 5 0 0 0 7 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 14a5 5 0 0 1 7 0a4.984 4.984 0 0 0 3.437 1.429m3.019 -.966c.19 -.14 .371 -.294 .544 -.463"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFlag(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "5",
        "x2": "5",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "5",
        "x2": "19",
        "y2": "14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 14a5 5 0 0 1 7 0a5 5 0 0 0 7 0"
      }
    }]
  })(props);
}
;
export function TbFlameOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.973 8.974c-.335 .378 -.67 .716 -.973 1.026c-1.226 1.26 -2 3.24 -2 5a6 6 0 0 0 11.472 2.466m.383 -3.597c-.32 -1.409 -1.122 -3.045 -1.855 -3.869c-.281 .472 -.543 .87 -.79 1.202m-2.358 -2.35c-.068 -2.157 -1.182 -4.184 -1.852 -4.852c0 .968 -.18 1.801 -.465 2.527"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFlame(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12c2 -2.96 0 -7 -1 -8c0 3.038 -1.773 4.741 -3 6c-1.226 1.26 -2 3.24 -2 5a6 6 0 1 0 12 0c0 -1.532 -1.056 -3.94 -2 -5c-1.786 3 -2.791 3 -4 2z"
      }
    }]
  })(props);
}
;
export function TbFlare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h4m5 -9v4m5 5h4m-9 5v4m-4.5 -13.5l1 1m8 -1l-1 1m0 7l1 1m-8 -1l-1 1"
      }
    }]
  })(props);
}
;
export function TbFlask2Off(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.1 15h8.9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.742 17.741a6 6 0 0 1 -2.424 3.259h-6.635a6.002 6.002 0 0 1 1.317 -10.66v-.326m0 -4.014v-3h4v7m.613 .598a6.004 6.004 0 0 1 2.801 2.817"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFlask2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.1 15h11.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v7.342a6.002 6.002 0 0 1 1.318 10.658h-6.635a6.002 6.002 0 0 1 1.317 -10.66v-7.34h4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3h6"
      }
    }]
  })(props);
}
;
export function TbFlaskOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3v3m-.268 3.736l-3.732 10.264a0.7 .7 0 0 0 .5 1h11a0.7 .7 0 0 0 .5 -1l-1.143 -3.142m-2.288 -6.294l-.569 -1.564v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFlask(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "3",
        "x2": "15",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "9",
        "x2": "14",
        "y2": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3v6l-4 11a0.7 .7 0 0 0 .5 1h11a0.7 .7 0 0 0 .5 -1l-4 -11v-6"
      }
    }]
  })(props);
}
;
export function TbFlipHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 16 17 16 7 21 7 16"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 8 17 8 7 3 7 8"
      }
    }]
  })(props);
}
;
export function TbFlipVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 7 16 17 21 17 16 7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 7 8 17 3 17 8 7"
      }
    }]
  })(props);
}
;
export function TbFloatCenter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "width": "6",
        "height": "6",
        "x": "9",
        "y": "5",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "7",
        "x2": "5",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "11",
        "x2": "5",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "7",
        "x2": "20",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "11",
        "x2": "20",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "15",
        "x2": "20",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "19",
        "x2": "20",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbFloatLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "width": "6",
        "height": "6",
        "x": "4",
        "y": "5",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "7",
        "x2": "20",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "11",
        "x2": "20",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "15",
        "x2": "20",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "19",
        "x2": "20",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbFloatNone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "width": "6",
        "height": "6",
        "x": "4",
        "y": "5",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "15",
        "x2": "20",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "19",
        "x2": "20",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbFloatRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "width": "6",
        "height": "6",
        "x": "14",
        "y": "5",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "7",
        "x2": "10",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "11",
        "x2": "10",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "15",
        "x2": "20",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "19",
        "x2": "20",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbFlowerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.875 9.882a3 3 0 0 0 4.247 4.238m.581 -3.423a3.012 3.012 0 0 0 -1.418 -1.409"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5a3 3 0 0 1 6 0c0 .562 -.259 1.442 -.776 2.64l-.724 1.36l1.76 -1.893c.499 -.6 .922 -1.002 1.27 -1.205a2.968 2.968 0 0 1 4.07 1.099a3.011 3.011 0 0 1 -1.09 4.098c-.374 .217 -.99 .396 -1.846 .535l-1.779 .244m.292 .282l1.223 .166c.995 .145 1.698 .337 2.11 .576a3.011 3.011 0 0 1 1.226 3.832m-2.277 1.733a2.968 2.968 0 0 1 -1.929 -.369c-.348 -.202 -.771 -.604 -1.27 -1.205l-1.76 -1.893l.724 1.36c.516 1.199 .776 2.079 .776 2.64a3 3 0 0 1 -6 0c0 -.562 .259 -1.442 .776 -2.64l.724 -1.36l-1.76 1.893c-.499 .601 -.922 1.003 -1.27 1.205a2.968 2.968 0 0 1 -4.07 -1.098a3.011 3.011 0 0 1 1.09 -4.098c.374 -.218 .99 -.396 1.846 -.536l2.664 -.366l-2.4 -.325c-.995 -.145 -1.698 -.337 -2.11 -.576a3.011 3.011 0 0 1 -1.09 -4.099a2.968 2.968 0 0 1 2.134 -1.467"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFlower(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 2a3 3 0 0 1 3 3c0 .562 -.259 1.442 -.776 2.64l-.724 1.36l1.76 -1.893c.499 -.6 .922 -1.002 1.27 -1.205a2.968 2.968 0 0 1 4.07 1.099a3.011 3.011 0 0 1 -1.09 4.098c-.374 .217 -.99 .396 -1.846 .535l-2.664 .366l2.4 .326c.995 .145 1.698 .337 2.11 .576a3.011 3.011 0 0 1 1.09 4.098a2.968 2.968 0 0 1 -4.07 1.098c-.348 -.202 -.771 -.604 -1.27 -1.205l-1.76 -1.893l.724 1.36c.516 1.199 .776 2.079 .776 2.64a3 3 0 0 1 -6 0c0 -.562 .259 -1.442 .776 -2.64l.724 -1.36l-1.76 1.893c-.499 .601 -.922 1.003 -1.27 1.205a2.968 2.968 0 0 1 -4.07 -1.098a3.011 3.011 0 0 1 1.09 -4.098c.374 -.218 .99 -.396 1.846 -.536l2.664 -.366l-2.4 -.325c-.995 -.145 -1.698 -.337 -2.11 -.576a3.011 3.011 0 0 1 -1.09 -4.099a2.968 2.968 0 0 1 4.07 -1.099c.348 .203 .771 .604 1.27 1.205l1.76 1.894c-1 -2.292 -1.5 -3.625 -1.5 -4a3 3 0 0 1 3 -3z"
      }
    }]
  })(props);
}
;
export function TbFocus2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "5",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbFocusCentered(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
      }
    }]
  })(props);
}
;
export function TbFocus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbFoldDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11v8l3 -3m-6 0l3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "7",
        "x2": "10",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "7",
        "x2": "15",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "7",
        "x2": "20",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "7",
        "x2": "5",
        "y2": "7"
      }
    }]
  })(props);
}
;
export function TbFoldUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13v-8l-3 3m6 0l-3 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "17",
        "x2": "10",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "17",
        "x2": "15",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "17",
        "x2": "20",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "17",
        "x2": "5",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbFold(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v6l3 -3m-6 0l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-6l3 3m-6 0l3 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "5",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "10",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbFolderMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "13",
        "x2": "15",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbFolderOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 19h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 1.172 -1.821m3.828 -.179h1l3 3h7a2 2 0 0 1 2 2v8"
      }
    }]
  })(props);
}
;
export function TbFolderPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "10",
        "x2": "12",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "13",
        "x2": "15",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbFolderX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbFolder(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
      }
    }]
  })(props);
}
;
export function TbFoldersOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h-8a2 2 0 0 1 -2 -2v-8m1.177 -2.823c.251 -.114 .53 -.177 .823 -.177h3l2 2h5a2 2 0 0 1 2 2v7c0 .55 -.223 1.05 -.583 1.411"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFolders(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
      }
    }]
  })(props);
}
;
export function TbForbid2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "15",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbForbid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "9",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbForklift(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "17",
        "x2": "12",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17v-6h13v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 11v-4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 11v-6h4l3 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 15h-3v-10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "13",
        "x2": "19",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbForms(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 12h.01"
      }
    }]
  })(props);
}
;
export function TbFountainOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16v-5a2 2 0 1 0 -4 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 16v-1m0 -4a2 2 0 1 1 4 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v-4m0 -4v-2a3 3 0 0 1 6 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.451 3.43a3 3 0 0 1 4.549 2.57"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 16h1v1m-.871 3.114a2.99 2.99 0 0 1 -2.129 .886h-12a3 3 0 0 1 -3 -3v-2h13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFountain(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16v-5a2 2 0 1 0 -4 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 16v-5a2 2 0 1 1 4 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v-10a3 3 0 0 1 6 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6a3 3 0 0 1 6 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 16h18v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2z"
      }
    }]
  })(props);
}
;
export function TbFrameOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7h3m4 0h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17h13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7v13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4v9m0 4v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFrame(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "7",
        "x2": "20",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "17",
        "x2": "20",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "4",
        "x2": "7",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "4",
        "x2": "17",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbFreeRights(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6l1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 16.5l1.5 1.5"
      }
    }]
  })(props);
}
;
export function TbFriendsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 22v-4h-2l1.254 -3.763m1.036 -2.942a0.997 .997 0 0 1 .71 -.295h2a1 1 0 0 1 1 1l1.503 4.508m-1.503 2.492v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbFriends(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 22v-4h-2l2 -6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1l2 6h-2v4"
      }
    }]
  })(props);
}
;
export function TbGasStationOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11a2 2 0 0 1 2 2m3 3v-7l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20v-14c0 -.548 .22 -1.044 .577 -1.405m3.423 -.595h4a2 2 0 0 1 2 2v4m0 4v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 7v1a1 1 0 0 0 1 1h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 11h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbGasStation(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "20",
        "x2": "15",
        "y2": "20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 7v1a1 1 0 0 0 1 1h1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "11",
        "x2": "14",
        "y2": "11"
      }
    }]
  })(props);
}
;
export function TbGaugeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.038 16.052a9 9 0 0 0 -12.067 -12.102m-2.333 1.686a9 9 0 1 0 12.73 12.726"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.283 11.303a1 1 0 0 0 1.419 1.41"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10l2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12c0 -1.386 .564 -2.64 1.475 -3.546m2.619 -1.372c.294 -.054 .597 -.082 .906 -.082"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbGauge(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13.41",
        "y1": "10.59",
        "x2": "16",
        "y2": "8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12a5 5 0 0 1 5 -5"
      }
    }]
  })(props);
}
;
export function TbGavel(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 10l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 10l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.793 15.793l-3.586 -3.586a1 1 0 0 1 0 -1.414l2.293 -2.293l.5 .5l3 -3l-.5 -.5l2.293 -2.293a1 1 0 0 1 1.414 0l3.586 3.586a1 1 0 0 1 0 1.414l-2.293 2.293l-.5 -.5l-3 3l.5 .5l-2.293 2.293a1 1 0 0 1 -1.414 0z"
      }
    }]
  })(props);
}
;
export function TbGenderAgender(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12h11"
      }
    }]
  })(props);
}
;
export function TbGenderAndrogyne(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 11l6 -6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "15",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 9v-4h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 10.5l-3 -3"
      }
    }]
  })(props);
}
;
export function TbGenderBigender(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "11",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 3l-5 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 16v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 19h6"
      }
    }]
  })(props);
}
;
export function TbGenderDemiboy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "14",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5l-5.4 5.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5h-5"
      }
    }]
  })(props);
}
;
export function TbGenderDemigirl(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "9",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18h3"
      }
    }]
  })(props);
}
;
export function TbGenderEpicene(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "rotate(-45 12 12)",
        "cx": "12",
        "cy": "12",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.536 15.535l5.464 -5.535"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14l5.464 -5.535"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12h.01"
      }
    }]
  })(props);
}
;
export function TbGenderFemale(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "9",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18h6"
      }
    }]
  })(props);
}
;
export function TbGenderFemme(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "9",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18h10"
      }
    }]
  })(props);
}
;
export function TbGenderGenderfluid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "g",
      "attr": {
        "transform": "rotate(30 -2.778 22.523)"
      },
      "child": [{
        "tag": "circle",
        "attr": {
          "cx": "4.759",
          "cy": "6.021",
          "r": "4"
        }
      }, {
        "tag": "path",
        "attr": {
          "d": "M8.758 6.02v-6"
        }
      }, {
        "tag": "path",
        "attr": {
          "d": "M.758 12.02v-6"
        }
      }]
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9l-6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.5 8.5l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 21l-6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 20l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7v-4h4"
      }
    }]
  })(props);
}
;
export function TbGenderGenderless(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "matrix(1 0 0 -1 0 30)",
        "cx": "12",
        "cy": "15",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 15h10"
      }
    }]
  })(props);
}
;
export function TbGenderGenderqueer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "matrix(1 0 0 -1 0 32)",
        "cx": "12",
        "cy": "16",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11v-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.5 4.5l-5 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 4.5l5 3"
      }
    }]
  })(props);
}
;
export function TbGenderHermaphrodite(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18h6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "matrix(1 0 0 -1 0 20)",
        "cx": "12",
        "cy": "10",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3a3 3 0 0 1 -6 0"
      }
    }]
  })(props);
}
;
export function TbGenderIntergender(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 11.5l6.5 6.5v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 13.5l6.5 6.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "matrix(1 0 0 -1 0 18)",
        "cx": "9",
        "cy": "9",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 20l2 -2"
      }
    }]
  })(props);
}
;
export function TbGenderMale(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "14",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5l-5.4 5.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5h-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5v5"
      }
    }]
  })(props);
}
;
export function TbGenderNeutrois(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "matrix(1 0 0 -1 0 30)",
        "cx": "12",
        "cy": "15",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10v-7"
      }
    }]
  })(props);
}
;
export function TbGenderThird(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "rotate(90 16 12)",
        "cx": "16",
        "cy": "12",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 12h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12l-5 -4v8z"
      }
    }]
  })(props);
}
;
export function TbGenderTransgender(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 9l6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 7v-4h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9l-6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7v-4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.5 8.5l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 19h5"
      }
    }]
  })(props);
}
;
export function TbGenderTrasvesti(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 20a5 5 0 1 1 0 -10a5 5 0 0 1 0 10z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6l5.4 5.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8l4 -4"
      }
    }]
  })(props);
}
;
export function TbGeometry(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 21l4 -12m2 0l1.48 4.439m.949 2.847l1.571 4.714"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12c1.526 2.955 4.588 5 8 5c3.41 0 6.473 -2.048 8 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v-2"
      }
    }]
  })(props);
}
;
export function TbGhost(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 11a7 7 0 0 1 14 0v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "10",
        "x2": "10.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "10",
        "x2": "14.01",
        "y2": "10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14a3.5 3.5 0 0 0 4 0"
      }
    }]
  })(props);
}
;
export function TbGift(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "8",
        "width": "18",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"
      }
    }]
  })(props);
}
;
export function TbGitBranch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "8",
        "x2": "7",
        "y2": "16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18h6a2 2 0 0 0 2 -2v-5"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "14 14 17 11 20 14"
      }
    }]
  })(props);
}
;
export function TbGitCommit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbGitCompare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 6h5a2 2 0 0 1 2 2v8"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "14 9 11 6 14 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 18h-5a2 2 0 0 1 -2 -2v-8"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "10 15 13 18 10 21"
      }
    }]
  })(props);
}
;
export function TbGitFork(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 8v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbGitMerge(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "8",
        "x2": "7",
        "y2": "16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 8a4 4 0 0 0 4 4h4"
      }
    }]
  })(props);
}
;
export function TbGitPullRequestClosed(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 11v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbGitPullRequestDraft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 11h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6h.01"
      }
    }]
  })(props);
}
;
export function TbGitPullRequest(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "8",
        "x2": "6",
        "y2": "16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 6h5a2 2 0 0 1 2 2v8"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "14 9 11 6 14 3"
      }
    }]
  })(props);
}
;
export function TbGizmo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 19l-8 -5.5l-8 5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v9.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "4",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "4",
        "cy": "19",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "20",
        "cy": "19",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbGlassFull(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "21",
        "x2": "16",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10a5 5 0 0 1 6 0a5 5 0 0 0 6 0"
      }
    }]
  })(props);
}
;
export function TbGlassOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "21",
        "x2": "16",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h10l1 7a4.511 4.511 0 0 1 -1.053 2.94m-2.386 1.625a7.48 7.48 0 0 1 -2.561 .435c-3.314 0 -6 -1.988 -6 -5l.5 -3.495"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbGlass(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "21",
        "x2": "16",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
      }
    }]
  })(props);
}
;
export function TbGlobeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.36 8.339a4 4 0 0 0 5.281 5.31m1.995 -1.98a4 4 0 0 0 -5.262 -5.325"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.75 16a8.015 8.015 0 0 0 9.799 .553m2.016 -1.998a8.015 8.015 0 0 0 -2.565 -11.555"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 22h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbGlobe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "10",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.75 16a8.015 8.015 0 1 0 9.25 -13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12",
        "y2": "22"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "22",
        "x2": "16",
        "y2": "22"
      }
    }]
  })(props);
}
;
export function TbGolfOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v-6m0 -4v-5l7 4l-5.07 2.897"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbGolf(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v-15l7 4l-7 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33"
      }
    }]
  })(props);
}
;
export function TbGps(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17l-1 -4l-4 -1l9 -4z"
      }
    }]
  })(props);
}
;
export function TbGrain(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "4.5",
        "cy": "9.5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9.5",
        "cy": "4.5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9.5",
        "cy": "14.5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "4.5",
        "cy": "19.5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14.5",
        "cy": "9.5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19.5",
        "cy": "4.5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14.5",
        "cy": "19.5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19.5",
        "cy": "14.5",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbGridDots(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "19",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "19",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbGridPattern(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 8v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 8v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14h8"
      }
    }]
  })(props);
}
;
export function TbGrillOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8h-3a6 6 0 0 0 6 6h2c.316 0 .626 -.024 .928 -.071m2.792 -1.22a5.99 5.99 0 0 0 2.276 -4.484l.004 -.225h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.814 18.844a2 2 0 1 1 -2.64 -2.666"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14l-3 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 18h-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbGrill(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 8h-14a6 6 0 0 0 6 6h2a6 6 0 0 0 5.996 -5.775l.004 -.225z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 20a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 14l1 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14l-3 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 18h-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5v-1"
      }
    }]
  })(props);
}
;
export function TbGripHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "9",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "15",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "9",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "15",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "9",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "15",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbGripVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "19",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "19",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbGrowth(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 15a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m-4 3.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m0 -7.5v6"
      }
    }]
  })(props);
}
;
export function TbH1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 18v-8l-2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 6h2"
      }
    }]
  })(props);
}
;
export function TbH2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 6h2"
      }
    }]
  })(props);
}
;
export function TbH3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 14a2 2 0 1 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 16a2 2 0 1 0 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 6h2"
      }
    }]
  })(props);
}
;
export function TbH4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 18v-8l-4 6h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 6h2"
      }
    }]
  })(props);
}
;
export function TbH5(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 18h2a2 2 0 1 0 0 -4h-2v-4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 6h2"
      }
    }]
  })(props);
}
;
export function TbH6(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "rotate(180 19 16)",
        "cx": "19",
        "cy": "16",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12a2 2 0 1 0 -4 0v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 6h2"
      }
    }]
  })(props);
}
;
export function TbHammerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.698 10.72l-6.668 6.698a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l6.696 -6.676"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.713 14.702l1.994 -1.995a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-1.999 1.999"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbHammer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.414 10l-7.383 7.418a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l7.407 -7.385"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.121 15.293l2.586 -2.586a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-2.586 2.586a1 1 0 0 0 0 1.414l7.586 7.586a1 1 0 0 0 1.414 0z"
      }
    }]
  })(props);
}
;
export function TbHandClick(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 3l-1 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3l1 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6h1"
      }
    }]
  })(props);
}
;
export function TbHandFingerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.06 4.077a1.5 1.5 0 0 1 2.94 .423v2.5m0 4v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.063 8.065a1.5 1.5 0 0 1 1.937 1.435v.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.06 10.082a1.5 1.5 0 0 1 2.94 .418v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5m-.88 3.129a5.996 5.996 0 0 1 -5.12 2.871h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbHandFinger(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }]
  })(props);
}
;
export function TbHandGrab(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11v-3.5a1.5 1.5 0 0 1 3 0v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 9.5v-3a1.5 1.5 0 0 1 3 0v3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 7.5a1.5 1.5 0 0 1 3 0v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 9.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }]
  })(props);
}
;
export function TbHandLittleFinger(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12v-5.5a1.5 1.5 0 0 1 3 0v9.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
      }
    }]
  })(props);
}
;
export function TbHandMiddleFinger(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11.5v-8a1.5 1.5 0 1 1 3 0v8.5"
      }
    }]
  })(props);
}
;
export function TbHandMove(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2.541 5.594a13.487 13.487 0 0 1 2.46 -1.427"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3.458c1.32 .354 2.558 .902 3.685 1.612"
      }
    }]
  })(props);
}
;
export function TbHandOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13.5v-5.5m.44 -3.562a1.5 1.5 0 0 1 2.56 1.062v1.5m0 4.008v.992m0 -6.5v-2a1.5 1.5 0 1 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2c-2.114 -.292 -3.956 -1.397 -5 -3l-2.7 -5.25a1.7 1.7 0 0 1 2.75 -2l.9 1.75"
      }
    }]
  })(props);
}
;
export function TbHandRingFinger(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 12v-6.5a1.5 1.5 0 0 1 3 0v6.5"
      }
    }]
  })(props);
}
;
export function TbHandRock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12v-6.5a1.5 1.5 0 0 1 3 0v10.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
      }
    }]
  })(props);
}
;
export function TbHandStop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }]
  })(props);
}
;
export function TbHandThreeFingers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
      }
    }]
  })(props);
}
;
export function TbHandTwoFingers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
      }
    }]
  })(props);
}
;
export function TbHanger2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9l-7.971 4.428a2 2 0 0 0 -1.029 1.749v.823a2 2 0 0 0 2 2h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18h1a2 2 0 0 0 2 -2v-.823a2 2 0 0 0 -1.029 -1.749l-7.971 -4.428c-1.457 -.81 -1.993 -2.333 -1.996 -4a2 2 0 1 1 4 0"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "16",
        "width": "12",
        "height": "5",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbHangerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.004 6a2 2 0 1 0 -4 0m6.506 6.506l3.461 1.922a2 2 0 0 1 1.029 1.749v.823m-2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l6.673 -3.707"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbHanger(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.004 6a2 2 0 1 0 -4 0c.003 1.667 .67 3 2.004 4h-.008l7.971 4.428a2 2 0 0 1 1.029 1.749v.823a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l7.971 -4.428"
      }
    }]
  })(props);
}
;
export function TbHash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "9",
        "x2": "19",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "15",
        "x2": "19",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "4",
        "x2": "7",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "4",
        "x2": "13",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbHaze(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.6 5.6l.7 .7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.4 5.6l-.7 .7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12a4 4 0 1 1 8 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 16h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20h18"
      }
    }]
  })(props);
}
;
export function TbHeadingOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12h5m4 0h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 5v8m0 4v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 19h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbHeading(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 5v14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 5v14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 19h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5h4"
      }
    }]
  })(props);
}
;
export function TbHeadphonesOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "13",
        "width": "5",
        "height": "7",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13h1a2 2 0 0 1 2 2v1m-.589 3.417c-.361 .36 -.86 .583 -1.411 .583h-1a2 2 0 0 1 -2 -2v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15v-3c0 -2.21 .896 -4.21 2.344 -5.658m2.369 -1.638a8 8 0 0 1 11.287 7.296v3"
      }
    }]
  })(props);
}
;
export function TbHeadphones(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "13",
        "rx": "2",
        "width": "5",
        "height": "7"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "15",
        "y": "13",
        "rx": "2",
        "width": "5",
        "height": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15v-3a8 8 0 0 1 16 0v3"
      }
    }]
  })(props);
}
;
export function TbHeadset(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "13",
        "rx": "2",
        "width": "4",
        "height": "6"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "16",
        "y": "13",
        "rx": "2",
        "width": "4",
        "height": "6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15v-3a8 8 0 0 1 16 0v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19a6 3 0 0 1 -6 3"
      }
    }]
  })(props);
}
;
export function TbHeartBroken(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6l-2 4l4 3l-2 4v3"
      }
    }]
  })(props);
}
;
export function TbHeartHandshake(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6l-3.293 3.293a1 1 0 0 0 0 1.414l.543 .543c.69 .69 1.81 .69 2.5 0l1 -1a3.182 3.182 0 0 1 4.5 0l2.25 2.25"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 15.5l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 13l2 2"
      }
    }]
  })(props);
}
;
export function TbHeartMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17h6"
      }
    }]
  })(props);
}
;
export function TbHeartOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.5 12.572l-1.5 1.428m-2 2l-4 4l-7.5 -7.428m0 0a5 5 0 0 1 -1.288 -5.068a4.976 4.976 0 0 1 1.788 -2.504m3 -1c1.56 .003 3.05 .727 4 2.006a5 5 0 1 1 7.5 6.572"
      }
    }]
  })(props);
}
;
export function TbHeartPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.003 5.996"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 16h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13v6"
      }
    }]
  })(props);
}
;
export function TbHeartRateMonitor(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "12",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 16v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 10h2l2 3l2 -6l1 3h3"
      }
    }]
  })(props);
}
;
export function TbHeart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.5 12.572l-7.5 7.428l-7.5 -7.428m0 0a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
      }
    }]
  })(props);
}
;
export function TbHeartbeat(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.5 13.572l-7.5 7.428l-2.896 -2.868m-6.117 -8.104a5 5 0 0 1 9.013 -3.022a5 5 0 1 1 7.5 6.572"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 13h2l2 3l2 -6l1 3h3"
      }
    }]
  })(props);
}
;
export function TbHelicopterLanding(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "8",
        "x2": "9",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "8",
        "x2": "15",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbHelicopter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10l1 2h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9a2 2 0 0 0 -2 2v3c0 1.1 .9 2 2 2h7a2 2 0 0 0 2 -2c0 -3.31 -3.13 -5 -7 -5h-2z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "9",
        "x2": "13",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 9.1v3.9h5.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "19",
        "x2": "15",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "19",
        "x2": "11",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbHelmetOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.633 4.654a9 9 0 0 1 11.718 11.7m-1.503 2.486a9.008 9.008 0 0 1 -1.192 1.16h-11.312a9 9 0 0 1 -.185 -13.847"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 9h-7m-2.768 1.246c.507 2 1.596 3.418 3.268 4.254c.524 .262 1.07 .49 1.64 .683"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbHelmet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4a9 9 0 0 1 5.656 16h-11.312a9 9 0 0 1 5.656 -16z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 9h-8.8a1 1 0 0 0 -.968 1.246c.507 2 1.596 3.418 3.268 4.254c2 1 4.333 1.5 7 1.5"
      }
    }]
  })(props);
}
;
export function TbHelp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "17.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"
      }
    }]
  })(props);
}
;
export function TbHexagonOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.693 4.69l2.336 -1.39a2.056 2.056 0 0 1 2 0l6 3.573h-.029a2 2 0 0 1 1 1.747v6.536c0 .246 -.045 .485 -.13 .707m-2.16 1.847l-4.739 3.027a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l1.154 -.687"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbHexagon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573z"
      }
    }]
  })(props);
}
;
export function TbHexagons(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18v-5l4 -2l4 2v5l-4 2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11v-5l4 -2l4 2v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13l4 -2l4 2v5l-4 2l-4 -2"
      }
    }]
  })(props);
}
;
export function TbHierarchy2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h4v4h-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 17l5 -4l5 4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "7",
        "x2": "12",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbHierarchy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 17.5l5.5 -4.5l5.5 4.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "7",
        "x2": "12",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbHighlightOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.998 9.002l-5.998 5.998v4h4l6 -6m1.997 -1.997l2.503 -2.503a2.828 2.828 0 1 0 -4 -4l-2.497 2.497"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 5.5l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 13.5l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 15h2v2m-2 2h-6l3.004 -3.004"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbHighlight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 5.5l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 13.5l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 15v4h-8l4 -4z"
      }
    }]
  })(props);
}
;
export function TbHistory(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 8 12 12 14 14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5"
      }
    }]
  })(props);
}
;
export function TbHome2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "5 12 3 12 12 3 21 12 19 12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "12",
        "width": "4",
        "height": "4"
      }
    }]
  })(props);
}
;
export function TbHomeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12h-2l4.497 -4.497m1.999 -1.999l2.504 -2.504l9 9h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21v-6a2 2 0 0 1 2 -2h2m2 2v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbHome(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "5 12 3 12 12 3 21 12 19 12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"
      }
    }]
  })(props);
}
;
export function TbHotelService(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.5 10a1.5 1.5 0 0 1 -1.5 -1.5a5.5 5.5 0 0 1 11 0v10.5a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2c0 -1.38 .71 -2.444 1.88 -3.175l4.424 -2.765c1.055 -.66 1.696 -1.316 1.696 -2.56a2.5 2.5 0 1 0 -5 0a1.5 1.5 0 0 1 -1.5 1.5z"
      }
    }]
  })(props);
}
;
export function TbHourglassEmpty(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
      }
    }]
  })(props);
}
;
export function TbHourglassHigh(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 7h11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
      }
    }]
  })(props);
}
;
export function TbHourglassLow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 17h11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
      }
    }]
  })(props);
}
;
export function TbHourglassOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-2a6 6 0 0 1 6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6a6 6 0 0 0 6 6m3.13 -.88a5.996 5.996 0 0 0 2.87 -5.12v-2a1 1 0 0 0 -1 -1h-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbHourglass(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 7h11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 17h11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
      }
    }]
  })(props);
}
;
export function TbIceCream2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.657 11.004a6 6 0 1 0 -11.315 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.342 11l5.658 11l5.657 -10.996z"
      }
    }]
  })(props);
}
;
export function TbIceCreamOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21.5v-4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8v9h8v-1m0 -4v-5a4 4 0 0 0 -7.277 -2.294"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10.5l1.74 -.76m2.79 -1.222l3.47 -1.518"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14.5l4.488 -1.964"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbIceCream(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21.5v-4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 17h8v-10a4 4 0 1 0 -8 0v10z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10.5l8 -3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14.5l8 -3.5"
      }
    }]
  })(props);
}
;
export function TbIceSkating(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.905 5h3.418a1 1 0 0 1 .928 .629l1.143 2.856a3 3 0 0 0 2.207 1.83l4.717 .926a2.084 2.084 0 0 1 1.682 2.045v.714a1 1 0 0 1 -1 1h-13.895a1 1 0 0 1 -.995 -1.1l.8 -8a1 1 0 0 1 .995 -.9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19h17a1 1 0 0 0 1 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 15v4"
      }
    }]
  })(props);
}
;
export function TbIcons(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6.5",
        "cy": "6.5",
        "r": "3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2.5 21h8l-4 -7z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3l7 7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10l7 -7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 14h7v7h-7z"
      }
    }]
  })(props);
}
;
export function TbIdBadge2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12h3v4h-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h-6a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1h-6"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "3",
        "width": "4",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 16h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 12h4"
      }
    }]
  })(props);
}
;
export function TbIdBadge(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "3",
        "width": "14",
        "height": "18",
        "rx": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "13",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18h6"
      }
    }]
  })(props);
}
;
export function TbIdOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h10a3 3 0 0 1 3 3v10m-1.437 2.561c-.455 .279 -.99 .439 -1.563 .439h-12a3 3 0 0 1 -3 -3v-10c0 -1.083 .573 -2.031 1.433 -2.559"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.175 8.178a2 2 0 1 0 2.646 2.65"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 8h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbId(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "16",
        "rx": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "10",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "8",
        "x2": "17",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "12",
        "x2": "17",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "16",
        "x2": "17",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbInboxOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h10a2 2 0 0 1 2 2v10m-.593 3.422a1.994 1.994 0 0 1 -1.407 .578h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.056 .59 -1.418"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13h3l3 3h4l.987 -.987m2.013 -2.013h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbInbox(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13h3l3 3h4l3 -3h3"
      }
    }]
  })(props);
}
;
export function TbIndentDecrease(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "6",
        "x2": "13",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "11",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "18",
        "x2": "13",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8l-4 4l4 4"
      }
    }]
  })(props);
}
;
export function TbIndentIncrease(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "6",
        "x2": "9",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "13",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "18",
        "x2": "9",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8l4 4l-4 4"
      }
    }]
  })(props);
}
;
export function TbInfinity(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.828 9.172a4 4 0 1 0 0 5.656a10 10 0 0 0 2.172 -2.828a10 10 0 0 1 2.172 -2.828a4 4 0 1 1 0 5.656a10 10 0 0 1 -2.172 -2.828a10 10 0 0 0 -2.172 -2.828"
      }
    }]
  })(props);
}
;
export function TbInfoCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12.01",
        "y2": "8"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "11 12 12 12 12 16 13 16"
      }
    }]
  })(props);
}
;
export function TbInfoSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12.01",
        "y2": "8"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "11 12 12 12 12 16 13 16"
      }
    }]
  })(props);
}
;
export function TbItalic(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "5",
        "x2": "17",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "19",
        "x2": "13",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "5",
        "x2": "10",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbJewishStar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 2l3 5h6l-3 5l3 5h-6l-3 5l-3 -5h-6l3 -5l-3 -5h6z"
      }
    }]
  })(props);
}
;
export function TbJumpRope(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 14v-6a3 3 0 1 1 6 0v8a3 3 0 0 0 6 0v-6"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "16",
        "y": "3",
        "width": "4",
        "height": "7",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "14",
        "width": "4",
        "height": "7",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbKarate(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "4",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9l4.5 1l3 2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 21v-8l3 -5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4.5l4 2l4 1l4 3.5l-2 3.5"
      }
    }]
  })(props);
}
;
export function TbKayak(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.414 6.414a2 2 0 0 0 0 -2.828l-1.414 -1.414l-2.828 2.828l1.414 1.414a2 2 0 0 0 2.828 0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.586 17.586a2 2 0 0 0 0 2.828l1.414 1.414l2.828 -2.828l-1.414 -1.414a2 2 0 0 0 -2.828 0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 6.5l11 11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 2.5c-9.983 2.601 -17.627 7.952 -20 19.5c9.983 -2.601 17.627 -7.952 20 -19.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 12.5l5 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 6.5l5 5"
      }
    }]
  })(props);
}
;
export function TbKering(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 15v-3.5a2.5 2.5 0 1 1 5 0v3.5m0 -2h-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9l3 6l3 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 20l6 -16"
      }
    }]
  })(props);
}
;
export function TbKeyOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "15",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.85 12.15l.65 -.65m2 -2l5.5 -5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 5l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 8l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbKey(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "15",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10.85",
        "y1": "12.15",
        "x2": "19",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "5",
        "x2": "20",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "8",
        "x2": "17",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbKeyboardHide(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "3",
        "width": "20",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "7",
        "x2": "6",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "7",
        "x2": "10",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "7",
        "x2": "14",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "7",
        "x2": "18",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "11",
        "x2": "6",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "11",
        "x2": "18",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "11",
        "x2": "14",
        "y2": "11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21l2 -2l2 2"
      }
    }]
  })(props);
}
;
export function TbKeyboardOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18h-14a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2m4 0h10a2 2 0 0 1 2 2v8c0 .554 -.226 1.056 -.59 1.418"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "10",
        "x2": "6",
        "y2": "10.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "10",
        "x2": "10",
        "y2": "10.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "10",
        "x2": "14",
        "y2": "10.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "10",
        "x2": "18",
        "y2": "10.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "14",
        "x2": "6",
        "y2": "14.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "14",
        "x2": "18",
        "y2": "14.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "14",
        "x2": "14",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbKeyboardShow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "3",
        "width": "20",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "7",
        "x2": "6",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "7",
        "x2": "10",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "7",
        "x2": "14",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "7",
        "x2": "18",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "11",
        "x2": "6",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "11",
        "x2": "18",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "11",
        "x2": "14",
        "y2": "11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 19l2 2l2 -2"
      }
    }]
  })(props);
}
;
export function TbKeyboard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "6",
        "width": "20",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "10",
        "x2": "6",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "10",
        "x2": "10",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "10",
        "x2": "14",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "10",
        "x2": "18",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "14",
        "x2": "6",
        "y2": "14.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "14",
        "x2": "18",
        "y2": "14.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "14",
        "x2": "14",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbLadderOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 3v1m0 4v13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3v9m0 4v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10h2m4 0h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 18h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLadder(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 3v18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3v18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 6h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 18h8"
      }
    }]
  })(props);
}
;
export function TbLamp2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21l-7 -8l8.5 -5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 14c-2.148 -2.148 -2.148 -5.852 0 -8c2.088 -2.088 5.842 -1.972 8 0l-8 8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.742 7.574l-1.156 -1.156a2 2 0 0 1 2.828 -2.829l1.144 1.144"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.5 11.995l.208 .274a2.527 2.527 0 0 0 3.556 0c.939 -.933 .98 -2.42 .122 -3.4l-.366 -.369"
      }
    }]
  })(props);
}
;
export function TbLampOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 20h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20v-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.325 7.35l-2.325 4.65h7m4 0h3l-4 -8h-6l-.338 .676"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLamp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 20h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20v-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12h14l-4 -8h-6z"
      }
    }]
  })(props);
}
;
export function TbLanguageHiragana(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 5h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 4c0 4.846 0 7 .5 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 8.5c0 2.286 -2 4.5 -3.5 4.5s-2.5 -1.135 -2.5 -2c0 -2 1 -3 3 -3s5 .57 5 2.857c0 1.524 -.667 2.571 -2 3.143"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20l4 -9l4 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.1 18h-6.2"
      }
    }]
  })(props);
}
;
export function TbLanguageKatakana(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5h6.586a1 1 0 0 1 .707 1.707l-1.293 1.293"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8c0 1.5 .5 3 -2 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20l4 -9l4 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.1 18h-6.2"
      }
    }]
  })(props);
}
;
export function TbLanguageOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 5h1m4 0h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3v2m-.508 3.517c-.814 2.655 -2.52 4.483 -4.492 4.483"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 9c-.003 2.144 2.952 3.908 6.7 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20l2.463 -5.541m1.228 -2.764l.309 -.695l.8 1.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18h-5.1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLanguage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 5h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3v2c0 4.418 -2.239 8 -5 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 9c-.003 2.144 2.952 3.908 6.7 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20l4 -9l4 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.1 18h-6.2"
      }
    }]
  })(props);
}
;
export function TbLassoOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -1.804 .878 -3.449 2.319 -4.69m2.49 -1.506a11.066 11.066 0 0 1 4.191 -.804c4.97 0 9 3.134 9 7c0 1.799 -.873 3.44 -2.307 4.68m-2.503 1.517a11.066 11.066 0 0 1 -4.19 .803c-1.913 0 -3.686 -.464 -5.144 -1.255"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "15",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 17c0 1.42 .316 2.805 1 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLasso(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -3.866 4.03 -7 9 -7s9 3.134 9 7s-4.03 7 -9 7c-1.913 0 -3.686 -.464 -5.144 -1.255"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "15",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 17c0 1.42 .316 2.805 1 4"
      }
    }]
  })(props);
}
;
export function TbLayersDifference(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "10 8 8 8 8 10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 14 8 16 10 16"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "14 8 16 8 16 10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 14 16 16 14 16"
      }
    }]
  })(props);
}
;
export function TbLayersIntersect2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "4",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "8",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15l6 -6"
      }
    }]
  })(props);
}
;
export function TbLayersIntersect(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "4",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "8",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayersLinked(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 8.268a2 2 0 0 1 1 1.732v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.003 15.734a2 2 0 0 1 -1.003 -1.734v-8a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-3"
      }
    }]
  })(props);
}
;
export function TbLayersOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.59 4.581c.362 -.359 .86 -.581 1.41 -.581h8a2 2 0 0 1 2 2v8c0 .556 -.227 1.06 -.594 1.422m-3.406 .578h-6a2 2 0 0 1 -2 -2v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLayersSubtract(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "4",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"
      }
    }]
  })(props);
}
;
export function TbLayersUnion(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
      }
    }]
  })(props);
}
;
export function TbLayout2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "6",
        "height": "5",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "13",
        "width": "6",
        "height": "7",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "4",
        "width": "6",
        "height": "7",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "15",
        "width": "6",
        "height": "5",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutAlignBottom(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "20",
        "y2": "20"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "4",
        "width": "6",
        "height": "12",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutAlignCenter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "20"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "9",
        "width": "12",
        "height": "6",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutAlignLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "20"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "9",
        "width": "12",
        "height": "6",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutAlignMiddle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "9",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "6",
        "width": "6",
        "height": "12",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutAlignRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "20"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "9",
        "width": "12",
        "height": "6",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutAlignTop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "8",
        "width": "6",
        "height": "12",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutBoardSplit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v16"
      }
    }]
  })(props);
}
;
export function TbLayoutBoard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 9h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v16"
      }
    }]
  })(props);
}
;
export function TbLayoutBottombar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "15",
        "x2": "20",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbLayoutCards(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "6",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "4",
        "width": "6",
        "height": "10",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutColumns(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLayoutDashboard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4h6v8h-6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16h6v4h-6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 12h6v8h-6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 4h6v4h-6z"
      }
    }]
  })(props);
}
;
export function TbLayoutDistributeHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "20",
        "y2": "20"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "9",
        "width": "12",
        "height": "6",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutDistributeVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "4",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "4",
        "x2": "20",
        "y2": "20"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "6",
        "width": "6",
        "height": "12",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutGridAdd(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "4",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "14",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17h6m-3 -3v6"
      }
    }]
  })(props);
}
;
export function TbLayoutGrid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "4",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "14",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "14",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbLayoutKanban(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "4",
        "x2": "10",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "4",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "8",
        "width": "6",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "8",
        "width": "6",
        "height": "6",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutList(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "6",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "14",
        "width": "16",
        "height": "6",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLayoutNavbar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "9",
        "x2": "20",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbLayoutOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4a2 2 0 0 1 2 2m-1.162 2.816a1.993 1.993 0 0 1 -.838 .184h-2a2 2 0 0 1 -2 -2v-1c0 -.549 .221 -1.046 .58 -1.407"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "13",
        "width": "6",
        "height": "7",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v10m-.595 3.423a1.994 1.994 0 0 1 -1.405 .577h-2a2 2 0 0 1 -2 -2v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLayoutRows(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbLayoutSidebarLeftCollapse(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10l-2 2l2 2"
      }
    }]
  })(props);
}
;
export function TbLayoutSidebarLeftExpand(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10l2 2l-2 2"
      }
    }]
  })(props);
}
;
export function TbLayoutSidebarRightCollapse(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10l2 2l-2 2"
      }
    }]
  })(props);
}
;
export function TbLayoutSidebarRightExpand(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10l-2 2l2 2"
      }
    }]
  })(props);
}
;
export function TbLayoutSidebarRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "4",
        "x2": "15",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLayoutSidebar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "4",
        "x2": "9",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLayout(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "6",
        "height": "5",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "13",
        "width": "6",
        "height": "7",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "4",
        "width": "6",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLeafOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21c.474 -4.264 2.294 -7.63 6.313 -9.673"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.622 6.62c-1.877 1.625 -2.629 3.877 -2.636 6.38c0 1 0 3 2 5h3.014c2.73 0 5.086 -.633 6.913 -2.081m1.901 -2.098c1.227 -1.871 1.992 -4.437 2.186 -7.821v-2h-4.014c-2.863 0 -5.117 .405 -6.86 1.118"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLeaf(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21c.5 -4.5 2.5 -8 7 -10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18c6.218 0 10.5 -3.288 11 -12v-2h-4.014c-9 0 -11.986 4 -12 9c0 1 0 3 2 5h3z"
      }
    }]
  })(props);
}
;
export function TbLego(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9.5",
        "y1": "11",
        "x2": "9.51",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.5",
        "y1": "11",
        "x2": "14.51",
        "y2": "11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 5h1v-2h8v2h1a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3v1h-10v-1a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3"
      }
    }]
  })(props);
}
;
export function TbLemon2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4a2 2 0 0 1 1.185 3.611c1.55 2.94 .873 6.917 -1.892 9.682c-2.765 2.765 -6.743 3.442 -9.682 1.892a2 2 0 1 1 -2.796 -2.796c-1.55 -2.94 -.873 -6.917 1.892 -9.682c2.765 -2.765 6.743 -3.442 9.682 -1.892a1.999 1.999 0 0 1 1.611 -.815z"
      }
    }]
  })(props);
}
;
export function TbLemon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.536 3.393c3.905 3.906 3.905 10.237 0 14.143c-3.906 3.905 -10.237 3.905 -14.143 0l14.143 -14.143"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.868 15.06a6.5 6.5 0 0 0 9.193 -9.192"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.464 10.464l4.597 4.597"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.464 10.464v6.364"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.464 10.464h6.364"
      }
    }]
  })(props);
}
;
export function TbLetterA(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "13",
        "x2": "17",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbLetterB(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20v-16h6a4 4 0 0 1 0 8a4 4 0 0 1 0 8h-6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "12",
        "x2": "13",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbLetterC(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5"
      }
    }]
  })(props);
}
;
export function TbLetterCaseLower(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6.5",
        "cy": "15.5",
        "r": "3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12v7"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17.5",
        "cy": "15.5",
        "r": "3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12v7"
      }
    }]
  })(props);
}
;
export function TbLetterCaseToggle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6.5",
        "cy": "15.5",
        "r": "3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 13h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12v7"
      }
    }]
  })(props);
}
;
export function TbLetterCaseUpper(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 13h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 13h7"
      }
    }]
  })(props);
}
;
export function TbLetterCase(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17.5",
        "cy": "15.5",
        "r": "3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 13h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12v7"
      }
    }]
  })(props);
}
;
export function TbLetterD(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1 -5 5h-6v-16"
      }
    }]
  })(props);
}
;
export function TbLetterE(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4h-10v16h10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbLetterF(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4h-10v16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbLetterG(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-2h-4"
      }
    }]
  })(props);
}
;
export function TbLetterH(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "4",
        "x2": "17",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "12",
        "x2": "17",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "4",
        "x2": "7",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLetterI(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLetterJ(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4"
      }
    }]
  })(props);
}
;
export function TbLetterK(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "4",
        "x2": "7",
        "y2": "20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12h2l8 -8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "17",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLetterL(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 4v16h10"
      }
    }]
  })(props);
}
;
export function TbLetterM(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20v-16l6 14l6 -14v16"
      }
    }]
  })(props);
}
;
export function TbLetterN(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20v-16l10 16v-16"
      }
    }]
  })(props);
}
;
export function TbLetterO(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6"
      }
    }]
  })(props);
}
;
export function TbLetterP(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"
      }
    }]
  })(props);
}
;
export function TbLetterQ(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "15",
        "x2": "18",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLetterR(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "13",
        "x2": "17",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLetterS(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 8a4 4 0 0 0 -4 -4h-2a4 4 0 0 0 0 8h2a4 4 0 0 1 0 8h-2a4 4 0 0 1 -4 -4"
      }
    }]
  })(props);
}
;
export function TbLetterSpacing(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 4l3 8l3 -8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 18h14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 20l2 -2l-2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16l-2 2l2 2"
      }
    }]
  })(props);
}
;
export function TbLetterT(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "4",
        "x2": "18",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLetterU(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11"
      }
    }]
  })(props);
}
;
export function TbLetterV(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4l6 16l6 -16"
      }
    }]
  })(props);
}
;
export function TbLetterW(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4l4 16l4 -14l4 14l4 -16"
      }
    }]
  })(props);
}
;
export function TbLetterX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "4",
        "x2": "17",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "4",
        "x2": "7",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLetterY(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 4l5 9l5 -9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "13",
        "x2": "12",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbLetterZ(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 4h10l-10 16h10"
      }
    }]
  })(props);
}
;
export function TbLicenseOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 1 0 4 0v-2m0 -4v-8a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -.864 .126m-2.014 2.025a3 3 0 0 0 -.122 .849v11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 11h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLicense(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "7",
        "x2": "13",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "11",
        "x2": "13",
        "y2": "11"
      }
    }]
  })(props);
}
;
export function TbLifebuoyOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.171 9.172a4 4 0 0 0 5.65 5.663m1.179 -2.835a4 4 0 0 0 -4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.64 5.632a9 9 0 1 0 12.73 12.725m1.667 -2.301a9 9 0 0 0 -12.077 -12.1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 15l3.35 3.35"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15l-3.35 3.35"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.65 5.65l3.35 3.35"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.35 5.65l-3.35 3.35"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLifebuoy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "15",
        "x2": "18.35",
        "y2": "18.35"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "5.65",
        "y2": "18.35"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5.65",
        "y1": "5.65",
        "x2": "9",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18.35",
        "y1": "5.65",
        "x2": "15",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbLineDashed(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 12h2"
      }
    }]
  })(props);
}
;
export function TbLineDotted(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v.01"
      }
    }]
  })(props);
}
;
export function TbLineHeight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "3 8 6 5 9 8"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "3 16 6 19 9 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "5",
        "x2": "6",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "18",
        "x2": "20",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbLine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.5",
        "y1": "16.5",
        "x2": "16.5",
        "y2": "7.5"
      }
    }]
  })(props);
}
;
export function TbLink(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"
      }
    }]
  })(props);
}
;
export function TbListCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.5 5.5l1.5 1.5l2.5 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.5 11.5l1.5 1.5l2.5 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.5 17.5l1.5 1.5l2.5 -2.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "18",
        "x2": "20",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbListDetails(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 5h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 15h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 19h5"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "14",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbListNumbers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 6h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 12h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10v-6l-2 2"
      }
    }]
  })(props);
}
;
export function TbListSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "15",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 18.5l2.5 2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18h4"
      }
    }]
  })(props);
}
;
export function TbList(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "18",
        "x2": "20",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "6",
        "x2": "5",
        "y2": "6.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "5",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "18",
        "x2": "5",
        "y2": "18.01"
      }
    }]
  })(props);
}
;
export function TbLivePhoto(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15.9",
        "y1": "20.11",
        "x2": "15.9",
        "y2": "20.12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19.04",
        "y1": "17.61",
        "x2": "19.04",
        "y2": "17.62"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20.77",
        "y1": "14",
        "x2": "20.77",
        "y2": "14.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20.77",
        "y1": "10",
        "x2": "20.77",
        "y2": "10.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19.04",
        "y1": "6.39",
        "x2": "19.04",
        "y2": "6.4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15.9",
        "y1": "3.89",
        "x2": "15.9",
        "y2": "3.9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "3.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8.1",
        "y1": "3.89",
        "x2": "8.1",
        "y2": "3.9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.96",
        "y1": "6.39",
        "x2": "4.96",
        "y2": "6.4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3.23",
        "y1": "10",
        "x2": "3.23",
        "y2": "10.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3.23",
        "y1": "14",
        "x2": "3.23",
        "y2": "14.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.96",
        "y1": "17.61",
        "x2": "4.96",
        "y2": "17.62"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8.1",
        "y1": "20.11",
        "x2": "8.1",
        "y2": "20.12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "21.01"
      }
    }]
  })(props);
}
;
export function TbLiveView(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "11",
        "x2": "12",
        "y2": "11.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
      }
    }]
  })(props);
}
;
export function TbLoaderQuarter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "6",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "3",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.75",
        "y1": "7.75",
        "x2": "5.6",
        "y2": "5.6"
      }
    }]
  })(props);
}
;
export function TbLoader(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "6",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.25",
        "y1": "7.75",
        "x2": "18.4",
        "y2": "5.6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.25",
        "y1": "16.25",
        "x2": "18.4",
        "y2": "18.4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.75",
        "y1": "16.25",
        "x2": "5.6",
        "y2": "18.4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "12",
        "x2": "3",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.75",
        "y1": "7.75",
        "x2": "5.6",
        "y2": "5.6"
      }
    }]
  })(props);
}
;
export function TbLocationOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.72 6.712l10.28 -3.712l-3.724 10.313m-1.056 2.925l-1.72 4.762a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l4.775 -1.724"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLocation(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5"
      }
    }]
  })(props);
}
;
export function TbLockAccess(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "11",
        "width": "8",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11v-2a2 2 0 1 1 4 0v2"
      }
    }]
  })(props);
}
;
export function TbLockOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 19a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4m4 0h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "16",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11v-3m.712 -3.278a4 4 0 0 1 7.288 2.278v4"
      }
    }]
  })(props);
}
;
export function TbLockOpenOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11h2a2 2 0 0 1 2 2v2m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "16",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11v-3m.347 -3.631a4 4 0 0 1 7.653 1.631"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLockOpen(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "11",
        "width": "14",
        "height": "10",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "16",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11v-5a4 4 0 0 1 8 0"
      }
    }]
  })(props);
}
;
export function TbLockSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "11",
        "width": "8",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11v-2a2 2 0 1 1 4 0v2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbLock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "11",
        "width": "14",
        "height": "10",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "16",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11v-4a4 4 0 0 1 8 0v4"
      }
    }]
  })(props);
}
;
export function TbLogin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12h-13l3 -3m0 6l-3 -3"
      }
    }]
  })(props);
}
;
export function TbLogout(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12h14l-3 -3m0 6l3 -3"
      }
    }]
  })(props);
}
;
export function TbLollipopOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.462 7.493a7 7 0 0 0 9.06 9.039m2.416 -1.57a7 7 0 1 0 -9.884 -9.915"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10a3.5 3.5 0 0 0 -7 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.71 12.715a3.5 3.5 0 0 1 -5.71 -2.715"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17c.838 0 1.607 -.294 2.209 -.785m1.291 -2.715a3.5 3.5 0 0 0 -3.5 -3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3a3.5 3.5 0 0 0 -3.5 3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21l6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLollipop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10a3.5 3.5 0 0 0 -7 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10a3.5 3.5 0 0 1 -7 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17a3.5 3.5 0 0 0 0 -7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3a3.5 3.5 0 0 0 0 7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21l6 -6"
      }
    }]
  })(props);
}
;
export function TbLuggageOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h6a2 2 0 0 1 2 2v6m0 4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-10c0 -.546 .218 -1.04 .573 -1.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10h4m4 0h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 16h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 20v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 20v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbLuggage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "6",
        "width": "12",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 6v-1a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 16h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 20v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 20v1"
      }
    }]
  })(props);
}
;
export function TbLungs(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.081 20c1.612 0 2.919 -1.335 2.919 -2.98v-9.763c0 -.694 -.552 -1.257 -1.232 -1.257c-.205 0 -.405 .052 -.584 .15l-.13 .083c-1.46 1.059 -2.432 2.647 -3.404 5.824c-.42 1.37 -.636 2.962 -.648 4.775c-.012 1.675 1.261 3.054 2.877 3.161l.203 .007z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.92 20c-1.613 0 -2.92 -1.335 -2.92 -2.98v-9.763c0 -.694 .552 -1.257 1.233 -1.257c.204 0 .405 .052 .584 .15l.13 .083c1.46 1.059 2.432 2.647 3.405 5.824c.42 1.37 .636 2.962 .648 4.775c.012 1.675 -1.261 3.054 -2.878 3.161l-.202 .007z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12a3 3 0 0 0 3 -3a3 3 0 0 0 3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v5"
      }
    }]
  })(props);
}
;
export function TbMacro(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15a6 6 0 1 0 12 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15a6 6 0 0 0 -6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21a6 6 0 0 0 -6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11a5 5 0 0 1 -5 -5v-3l3 2l2 -2l2 2l3 -2v3a5 5 0 0 1 -5 5z"
      }
    }]
  })(props);
}
;
export function TbMagnetOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3a2 2 0 0 1 2 2m0 4v4a3 3 0 0 0 5.552 1.578m.448 -3.578v-6a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a7.99 7.99 0 0 1 -.424 2.577m-1.463 2.584a8 8 0 0 1 -14.113 -5.161v-8.001c0 -.297 .065 -.58 .181 -.833"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 8h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMagnet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a2 2 0 0 0 6 0v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a8 8 0 0 1 -16 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "9",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "8",
        "x2": "19",
        "y2": "8"
      }
    }]
  })(props);
}
;
export function TbMailFast(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.02 8.801l-.6 6a2 2 0 0 0 1.99 2.199h7.98a2 2 0 0 0 1.99 -1.801l.6 -6a2 2 0 0 0 -1.99 -2.199h-7.98a2 2 0 0 0 -1.99 1.801z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.8 7.5l2.982 3.28a3 3 0 0 0 4.238 .202l3.28 -2.982"
      }
    }]
  })(props);
}
;
export function TbMailForward(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6l9 6l9 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 18h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbMailOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7l9 6l.598 -.399m2.402 -1.601l6 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMailOpened(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "3 9 12 15 21 9 12 3 3 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "19",
        "x2": "9",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "13",
        "x2": "21",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbMail(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "3 7 12 13 21 7"
      }
    }]
  })(props);
}
;
export function TbMailboxOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21v-6.5a3.5 3.5 0 0 0 -7 0v6.5h18m0 -4v-2a4 4 0 0 0 -4 -4h-2m-4 0h-4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8v-5h4l2 2l-2 2h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMailbox(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21v-6.5a3.5 3.5 0 0 0 -7 0v6.5h18v-6a4 4 0 0 0 -4 -4h-10.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11v-8h4l2 2l-2 2h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15h1"
      }
    }]
  })(props);
}
;
export function TbMan(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
      }
    }]
  })(props);
}
;
export function TbManualGearbox(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "6",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "8",
        "x2": "5",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 8v2a2 2 0 0 1 -2 2h-12"
      }
    }]
  })(props);
}
;
export function TbMap2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "6",
        "x2": "18",
        "y2": "6.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 13l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "10.5 4.75 9 4 3 7 3 20 9 17 15 20 21 17 21 15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "4",
        "x2": "9",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "15",
        "x2": "15",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbMapOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.32 4.34l.68 -.34l6 3l6 -3v13m-2.67 1.335l-3.33 1.665l-6 -3l-6 3v-13l2.665 -1.333"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4v1m0 4v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 7v4m0 4v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMapPinOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.44 9.435a3 3 0 0 0 4.126 4.124m1.434 -2.559a3 3 0 0 0 -3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.048 4.042a8 8 0 0 1 10.912 10.908m-1.8 2.206l-3.745 3.744a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 0 1 -.48 -10.79"
      }
    }]
  })(props);
}
;
export function TbMapPin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "11",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
      }
    }]
  })(props);
}
;
export function TbMapPins(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.828 9.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "7",
        "x2": "8",
        "y2": "7.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.828 17.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "15",
        "x2": "16",
        "y2": "15.01"
      }
    }]
  })(props);
}
;
export function TbMapSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4v13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 7v5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16.5",
        "cy": "17.5",
        "r": "2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 19.5l2.5 2.5"
      }
    }]
  })(props);
}
;
export function TbMap(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "3 7 9 4 15 7 21 4 21 17 15 20 9 17 3 20 3 7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "4",
        "x2": "9",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "7",
        "x2": "15",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbMarkdown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 15v-6l2 2l2 -2v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 13l2 2l2 -2m-2 2v-6"
      }
    }]
  })(props);
}
;
export function TbMarquee2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2"
      }
    }]
  })(props);
}
;
export function TbMarqueeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6c0 -.556 .227 -1.059 .593 -1.421"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4h1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 4h1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4a2 2 0 0 1 2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 9v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 13.5v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.402 19.426a1.993 1.993 0 0 1 -1.402 .574"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 20h-1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 20h-1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20a2 2 0 0 1 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15v-1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 10.5v-1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMarquee(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6a2 2 0 0 1 2 -2m3 0h1.5m3 0h1.5m3 0a2 2 0 0 1 2 2m0 3v1.5m0 3v1.5m0 3a2 2 0 0 1 -2 2m-3 0h-1.5m-3 0h-1.5m-3 0a2 2 0 0 1 -2 -2m0 -3v-1.5m0 -3v-1.5m0 -3"
      }
    }]
  })(props);
}
;
export function TbMars(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "14",
        "r": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "5",
        "x2": "13.6",
        "y2": "10.4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "5",
        "x2": "14",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "5",
        "x2": "19",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbMaskOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.42 19.41a2 2 0 0 1 -1.42 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.055 .588 -1.417m3.412 -.583h10a2 2 0 0 1 2 2v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.885 9.872a3 3 0 1 0 4.245 4.24m.582 -3.396a3.012 3.012 0 0 0 -1.438 -1.433"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMask(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbMassage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "4",
        "cy": "17",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 22l4 -2v-3h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 20h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14l3 -2l1 -4c3 1 3 4 3 6"
      }
    }]
  })(props);
}
;
export function TbMathAvg(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21l18 -18"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "8"
      }
    }]
  })(props);
}
;
export function TbMathFunctionOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10h1c.882 0 .986 .777 1.694 2.692"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 17c.864 0 1.727 -.663 2.495 -1.512m1.717 -2.302c.993 -1.45 2.39 -3.186 3.788 -3.186"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19c0 1.5 .5 2 2 2s2 -4 3 -9c.237 -1.186 .446 -2.317 .647 -3.35m.727 -3.248c.423 -1.492 .91 -2.402 1.626 -2.402c1.5 0 2 .5 2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMathFunction(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 17c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19c0 1.5 .5 2 2 2s2 -4 3 -9s1.5 -9 3 -9s2 .5 2 2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "11",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbMathMax(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20c0 -8.75 4 -14 7 -14.5m4 0c3 .5 7 5.75 7 14.5"
      }
    }]
  })(props);
}
;
export function TbMathMin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "matrix(1 0 0 -1 0 38)",
        "cx": "12",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 4c0 8.75 4 14 7 14.5m4 0c3 -.5 7 -5.75 7 -14.5"
      }
    }]
  })(props);
}
;
export function TbMathSymbols(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.5",
        "y1": "4.5",
        "x2": "19.5",
        "y2": "7.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19.5",
        "y1": "4.5",
        "x2": "16.5",
        "y2": "7.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "4",
        "x2": "6",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "16",
        "x2": "18.01",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "20",
        "x2": "18.01",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "18",
        "x2": "8",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbMath(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 13l4 4m0 -4l-4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 5h-7l-4 14l-3 -6h-2"
      }
    }]
  })(props);
}
;
export function TbMaximizeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2c0 -.551 .223 -1.05 .584 -1.412"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2c.545 0 1.04 -.218 1.4 -.572"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMaximize(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
      }
    }]
  })(props);
}
;
export function TbMeat(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.62 8.382l1.966 -1.967a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-1.82 1.821"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "transform": "rotate(45 8.025 16.475)",
        "cx": "8.025",
        "cy": "16.475",
        "rx": "7",
        "ry": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 16l1 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.975 21.425c3.905 -3.906 4.855 -9.288 2.121 -12.021c-2.733 -2.734 -8.115 -1.784 -12.02 2.121"
      }
    }]
  })(props);
}
;
export function TbMedal2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3h6l3 7l-6 2l-6 -2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-3 -9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11l-3 -8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
      }
    }]
  })(props);
}
;
export function TbMedal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v3m-4 -3v6m8 -6v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
      }
    }]
  })(props);
}
;
export function TbMedicalCrossOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.928 17.733l-.574 -.331l-3.354 -1.938v4.536a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-4.536l-3.928 2.268a1 1 0 0 1 -1.366 -.366l-1 -1.732a1 1 0 0 1 .366 -1.366l3.927 -2.268l-3.927 -2.268a1 1 0 0 1 -.366 -1.366l1 -1.732a1 1 0 0 1 1.366 -.366l.333 .192m3.595 -.46v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4.535l3.928 -2.267a1 1 0 0 1 1.366 .366l1 1.732a1 1 0 0 1 -.366 1.366l-3.927 2.268l3.927 2.269a1 1 0 0 1 .366 1.366l-.24 .416"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMedicalCross(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 3a1 1 0 0 1 1 1v4.535l3.928 -2.267a1 1 0 0 1 1.366 .366l1 1.732a1 1 0 0 1 -.366 1.366l-3.927 2.268l3.927 2.269a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 0 1 -1.366 .366l-3.928 -2.269v4.536a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-4.536l-3.928 2.268a1 1 0 0 1 -1.366 -.366l-1 -1.732a1 1 0 0 1 .366 -1.366l3.927 -2.268l-3.927 -2.268a1 1 0 0 1 -.366 -1.366l1 -1.732a1 1 0 0 1 1.366 -.366l3.928 2.267v-4.535a1 1 0 0 1 1 -1h2z"
      }
    }]
  })(props);
}
;
export function TbMedicineSyrup(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 21h8a1 1 0 0 0 1 -1v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10a1 1 0 0 0 1 1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 7v-3a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3"
      }
    }]
  })(props);
}
;
export function TbMenu2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "18",
        "x2": "20",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbMenu(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "20",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "20",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbMessage2Code(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 9l-2 2l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 9l2 2l-2 2"
      }
    }]
  })(props);
}
;
export function TbMessage2Share(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 11v3a3 3 0 0 1 -3 3h-2l-3 3l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 9l5 -5"
      }
    }]
  })(props);
}
;
export function TbMessage2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "9",
        "x2": "16",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "13",
        "x2": "14",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbMessageCircle2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
      }
    }]
  })(props);
}
;
export function TbMessageCircleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.585 4.581c3.225 -1.181 7.032 -.616 9.66 1.626c2.983 2.543 3.602 6.525 1.634 9.662m-1.908 2.108c-2.786 2.19 -6.89 2.665 -10.271 1.023l-4.7 1l1.3 -3.9c-2.237 -3.308 -1.489 -7.54 1.714 -10.084"
      }
    }]
  })(props);
}
;
export function TbMessageCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "8",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "12",
        "x2": "16",
        "y2": "12.01"
      }
    }]
  })(props);
}
;
export function TbMessageCode(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 9l-2 2l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 9l2 2l-2 2"
      }
    }]
  })(props);
}
;
export function TbMessageDots(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "11",
        "x2": "12",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "11",
        "x2": "8",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "11",
        "x2": "16",
        "y2": "11.01"
      }
    }]
  })(props);
}
;
export function TbMessageLanguage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14v-4a2 2 0 1 1 4 0v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 12h-4"
      }
    }]
  })(props);
}
;
export function TbMessageOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h-9l-4 4v-13c0 -1.086 .577 -2.036 1.44 -2.563m3.561 -.437h8a3 3 0 0 1 3 3v6c0 .575 -.162 1.112 -.442 1.568"
      }
    }]
  })(props);
}
;
export function TbMessagePlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "11",
        "x2": "14",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbMessageReport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "12",
        "y2": "14.01"
      }
    }]
  })(props);
}
;
export function TbMessageShare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 11v3a3 3 0 0 1 -3 3h-9l-4 4v-13a3 3 0 0 1 3 -3h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 9l5 -5"
      }
    }]
  })(props);
}
;
export function TbMessage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "9",
        "x2": "16",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "13",
        "x2": "14",
        "y2": "13"
      }
    }]
  })(props);
}
;
export function TbMessagesOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11a1 1 0 0 1 -1 -1m0 -3.968v-2.032a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10l-3 -3h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
      }
    }]
  })(props);
}
;
export function TbMessages(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
      }
    }]
  })(props);
}
;
export function TbMicrophone2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.002 12.9a5 5 0 1 0 -3.902 -3.9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.002 12.9l-3.902 -3.899l-7.513 8.584a2 2 0 1 0 2.827 2.83l8.588 -7.515z"
      }
    }]
  })(props);
}
;
export function TbMicrophoneOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5a3 3 0 0 1 6 0v5a3 3 0 0 1 -.13 .874m-2 2a3 3 0 0 1 -3.87 -2.872v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 10a7 7 0 0 0 10.846 5.85m2.002 -2a6.967 6.967 0 0 0 1.152 -3.85"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "21",
        "x2": "16",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbMicrophone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "2",
        "width": "6",
        "height": "11",
        "rx": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 10a7 7 0 0 0 14 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "21",
        "x2": "16",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbMicroscope(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21h14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 18h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 11l3 3l6 -6l-3 -3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 12.5l-1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21a6 6 0 0 0 3.715 -10.712"
      }
    }]
  })(props);
}
;
export function TbMilitaryAward(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "13",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10l-1 -2h-5l2.48 5.788a2 2 0 0 0 1.84 1.212h1.18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10l1 -2h5l-2.48 5.788a2 2 0 0 1 -1.84 1.212h-1.18"
      }
    }]
  })(props);
}
;
export function TbMilitaryRank(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 7v13h-10v-13l5 -3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13l2 -1l2 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 17l2 -1l2 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 9l2 -1l2 1"
      }
    }]
  })(props);
}
;
export function TbMilk(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 6h8v-2a1 1 0 0 0 -1 -1h-6a1 1 0 0 0 -1 1v2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 6l1.094 1.759a6 6 0 0 1 .906 3.17v8.071a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8.071a6 6 0 0 1 .906 -3.17l1.094 -1.759"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "16",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10h4"
      }
    }]
  })(props);
}
;
export function TbMinimize(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 19v-2a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5v2a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 15h2a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 9h2a2 2 0 0 0 2 -2v-2"
      }
    }]
  })(props);
}
;
export function TbMinusVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v14"
      }
    }]
  })(props);
}
;
export function TbMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbMist(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5h3m4 0h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10h11m4 0h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 15h5m4 0h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20h9m4 0h3"
      }
    }]
  })(props);
}
;
export function TbMoodBoy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4.5a9 9 0 0 1 3.864 5.89a2.5 2.5 0 0 1 -.29 4.36a9 9 0 0 1 -17.137 0a2.5 2.5 0 0 1 -.29 -4.36a9 9 0 0 1 3.746 -5.81"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 16a3.5 3.5 0 0 0 5 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.5 2c1.5 1 2.5 3.5 2.5 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 2c1.5 2 2 3.5 2 5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "9.01",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "12",
        "x2": "15.01",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbMoodConfuzed(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "9.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "10",
        "x2": "15.01",
        "y2": "10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 16a10 10 0 0 1 6 -1.5"
      }
    }]
  })(props);
}
;
export function TbMoodCrazyHappy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "8.5",
        "x2": "10",
        "y2": "11.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11.5l3 -3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "8.5",
        "x2": "17",
        "y2": "11.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 11.5l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
      }
    }]
  })(props);
}
;
export function TbMoodCry(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "9.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "10",
        "x2": "15.01",
        "y2": "10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15.25a3.5 3.5 0 0 1 5 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.566 17.606a2 2 0 1 0 2.897 .03l-1.463 -1.636l-1.434 1.606z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.865 13.517a8.937 8.937 0 0 0 .135 -1.517a9 9 0 1 0 -9 9c.69 0 1.36 -.076 2 -.222"
      }
    }]
  })(props);
}
;
export function TbMoodEmpty(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "9.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "10",
        "x2": "15.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbMoodHappy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "9",
        "x2": "9.01",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "15.01",
        "y2": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13a4 4 0 1 0 8 0m0 0h-8"
      }
    }]
  })(props);
}
;
export function TbMoodKid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "9.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "10",
        "x2": "15.01",
        "y2": "10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a2 2 0 0 0 0 4"
      }
    }]
  })(props);
}
;
export function TbMoodNervous(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16l2 -2l2 2l2 -2l2 2"
      }
    }]
  })(props);
}
;
export function TbMoodNeutral(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "9.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "10",
        "x2": "15.01",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbMoodOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.634 5.638a9 9 0 0 0 12.732 12.724m1.679 -2.322a9 9 0 0 0 -12.08 -12.086"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMoodSad(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "9.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "10",
        "x2": "15.01",
        "y2": "10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15.25a3.5 3.5 0 0 1 5 0"
      }
    }]
  })(props);
}
;
export function TbMoodSmile(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "9.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "10",
        "x2": "15.01",
        "y2": "10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
      }
    }]
  })(props);
}
;
export function TbMoodSuprised(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "9",
        "x2": "9.01",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "15.01",
        "y2": "9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "15",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbMoodTongue(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "9.01",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "10",
        "x2": "15.01",
        "y2": "10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14v2a2 2 0 0 0 4 0v-2m1.5 0h-7"
      }
    }]
  })(props);
}
;
export function TbMoon2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.418 4.157a8 8 0 0 0 0 15.686"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbMoonOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.962 3.949a8.97 8.97 0 0 1 4.038 -.957v.008h.393a7.478 7.478 0 0 0 -2.07 3.308m-.141 3.84c.186 .823 .514 1.626 .989 2.373a7.49 7.49 0 0 0 4.586 3.268m3.893 -.11c.223 -.067 .444 -.144 .663 -.233a9.088 9.088 0 0 1 -.274 .597m-1.695 2.337a9 9 0 0 1 -12.71 -12.749"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMoonStars(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 11h2m-1 -1v2"
      }
    }]
  })(props);
}
;
export function TbMoon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
      }
    }]
  })(props);
}
;
export function TbMoped(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 16v1a2 2 0 0 0 4 0v-5h-3a3 3 0 0 0 -3 3v1h10a6 6 0 0 1 5 -4v-5a2 2 0 0 0 -2 -2h-1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "9",
        "x2": "9",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbMotorbike(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "16",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "16",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 14h5l4 -4h-10.5m1.5 4l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 6h2l1.5 3l2 4"
      }
    }]
  })(props);
}
;
export function TbMountain(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 20h18l-6.921 -14.612a2.3 2.3 0 0 0 -4.158 0l-6.921 14.612z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 11l2 2.5l2.5 -2.5l2 3l2.5 -2"
      }
    }]
  })(props);
}
;
export function TbMouse2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "3",
        "width": "12",
        "height": "18",
        "rx": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10h12"
      }
    }]
  })(props);
}
;
export function TbMouseOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.733 3.704a3.982 3.982 0 0 1 2.267 -.704h4a4 4 0 0 1 4 4v7m-.1 3.895a4.002 4.002 0 0 1 -3.9 3.105h-4a4 4 0 0 1 -4 -4v-10c0 -.3 .033 -.593 .096 -.874"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMouse(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "3",
        "width": "12",
        "height": "18",
        "rx": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "7",
        "x2": "12",
        "y2": "11"
      }
    }]
  })(props);
}
;
export function TbMovieOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h10a2 2 0 0 1 2 2v10m-.592 3.42c-.362 .359 -.859 .58 -1.408 .58h-12a2 2 0 0 1 -2 -2v-12c0 -.539 .213 -1.028 .56 -1.388"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4v8m0 4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h8m4 0h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMovie(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "4",
        "x2": "16",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "8",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "8",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "8",
        "x2": "20",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "16",
        "x2": "20",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbMugOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h5.917a1.08 1.08 0 0 1 1.083 1.077v5.923m-.167 3.88a4.33 4.33 0 0 1 -4.166 3.12h-4.334c-2.393 0 -4.333 -1.929 -4.333 -4.308v-8.615a1.08 1.08 0 0 1 1.083 -1.077h.917"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8h2.5c1.38 0 2.5 1.045 2.5 2.333v2.334c0 1.148 -.89 2.103 -2.06 2.297"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMug(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.083 5h10.834a1.08 1.08 0 0 1 1.083 1.077v8.615c0 2.38 -1.94 4.308 -4.333 4.308h-4.334c-2.393 0 -4.333 -1.929 -4.333 -4.308v-8.615a1.08 1.08 0 0 1 1.083 -1.077"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8h2.5c1.38 0 2.5 1.045 2.5 2.333v2.334c0 1.288 -1.12 2.333 -2.5 2.333h-2.5"
      }
    }]
  })(props);
}
;
export function TbMultiplier05X(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16h2a2 2 0 1 0 0 -4h-2v-4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 16l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 16l-4 -4"
      }
    }]
  })(props);
}
;
export function TbMultiplier15X(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16v-8l-2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 16l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 16l-4 -4"
      }
    }]
  })(props);
}
;
export function TbMultiplier1X(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16v-8l-2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 16l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 16l-4 -4"
      }
    }]
  })(props);
}
;
export function TbMultiplier2X(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 16l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 16l-4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
      }
    }]
  })(props);
}
;
export function TbMushroom(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 11.1c0 -4.474 -3.582 -8.1 -8 -8.1s-8 3.626 -8 8.1a0.9 .9 0 0 0 .9 .9h14.2a0.9 .9 0 0 0 .9 -.9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12v7a2 2 0 1 0 4 0v-7"
      }
    }]
  })(props);
}
;
export function TbMusicOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "17",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.42 14.45a3 3 0 1 0 4.138 4.119"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17v-8m0 -4v-1h10v11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbMusic(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "17",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "17",
        "r": "3"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "9 17 9 4 19 4 19 17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "8",
        "x2": "19",
        "y2": "8"
      }
    }]
  })(props);
}
;
export function TbNetwork(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "9",
        "r": "6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3c1.333 .333 2 2.333 2 6s-.667 5.667 -2 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3c-1.333 .333 -2 2.333 -2 6s.667 5.667 2 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 19h7"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15v2"
      }
    }]
  })(props);
}
;
export function TbNewSection(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2m0 -5"
      }
    }]
  })(props);
}
;
export function TbNewsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 6h3a1 1 0 0 1 1 1v9m-.606 3.435a2 2 0 0 1 -3.394 -1.435v-2m0 -4v-7a1 1 0 0 0 -1 -1h-7m-3.735 .321a0.996 .996 0 0 0 -.265 .679v12a3 3 0 0 0 3 3h11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbNews(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "8",
        "x2": "12",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "16",
        "x2": "12",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbNfcOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 20a3 3 0 0 1 -3 -3v-9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 4a3 3 0 0 1 3 3v5m0 4v2l-5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h9a3 3 0 0 1 3 3v9m-.873 3.116a2.99 2.99 0 0 1 -2.127 .884h-10a3 3 0 0 1 -3 -3v-10c0 -.83 .337 -1.582 .882 -2.125"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbNfc(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 20a3 3 0 0 1 -3 -3v-11l5 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 4a3 3 0 0 1 3 3v11l-5 -5"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "3"
      }
    }]
  })(props);
}
;
export function TbNoCopyright(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 9.75a3.016 3.016 0 0 0 -4.163 .173a2.993 2.993 0 0 0 0 4.154a3.016 3.016 0 0 0 4.163 .173"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6l1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 16.5l1.5 1.5"
      }
    }]
  })(props);
}
;
export function TbNoCreativeCommons(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6l1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 16.5l1.5 1.5"
      }
    }]
  })(props);
}
;
export function TbNoDerivatives(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14h6"
      }
    }]
  })(props);
}
;
export function TbNorthStar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 7.5l9 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 16.5l9 -9"
      }
    }]
  })(props);
}
;
export function TbNoteOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 20l3.505 -3.505m1.994 -1.994l1.501 -1.501"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13h3v-7a2 2 0 0 0 -2 -2h-10m-3.427 .6c-.355 .36 -.573 .853 -.573 1.4v12a2 2 0 0 0 2 2h7v-6c0 -.272 .109 -.519 .285 -.699"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbNote(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "20",
        "x2": "20",
        "y2": "13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 20v-6a1 1 0 0 1 1 -1h6v-7a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7"
      }
    }]
  })(props);
}
;
export function TbNotebook(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "8",
        "x2": "15",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbNotesOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 11h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbNotes(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "3",
        "width": "14",
        "height": "18",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "7",
        "x2": "15",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "11",
        "x2": "15",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "13",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbNotificationOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.154 6.187a2 2 0 0 0 -1.154 1.813v9a2 2 0 0 0 2 2h9a2 2 0 0 0 1.811 -1.151"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "7",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbNotification(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "7",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbNumber0(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4z"
      }
    }]
  })(props);
}
;
export function TbNumber1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 20v-16l-5 5"
      }
    }]
  })(props);
}
;
export function TbNumber2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 9.185h8"
      }
    }]
  })(props);
}
;
export function TbNumber3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12a4 4 0 1 0 -4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16a4 4 0 1 0 4 -4"
      }
    }]
  })(props);
}
;
export function TbNumber4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 20v-15l-8 11h10"
      }
    }]
  })(props);
}
;
export function TbNumber5(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 20h4a4 4 0 1 0 0 -8h-4v-8h8"
      }
    }]
  })(props);
}
;
export function TbNumber6(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16a4 4 0 1 0 8 0v-1a4 4 0 1 0 -8 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8a4 4 0 1 0 -8 0v8"
      }
    }]
  })(props);
}
;
export function TbNumber7(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h8l-4 16"
      }
    }]
  })(props);
}
;
export function TbNumber8(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "8",
        "r": "4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "16",
        "r": "4"
      }
    }]
  })(props);
}
;
export function TbNumber9(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16a4 4 0 1 0 8 0v-8"
      }
    }]
  })(props);
}
;
export function TbNumbers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10v-7l-2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 16a2 2 0 1 1 4 0c0 .591 -.601 1.46 -1 2l-3 3.001h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 14a2 2 0 1 0 2 -2a2 2 0 1 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 10h3"
      }
    }]
  })(props);
}
;
export function TbNurse(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6c2.941 0 5.685 .847 8 2.31l-2 9.69h-12l-2 -9.691a14.93 14.93 0 0 1 8 -2.309z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10v4"
      }
    }]
  })(props);
}
;
export function TbOctagonOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.647 3.653l.353 -.353c.2 -.2 .4 -.3 .7 -.3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-.35 .35m-1.997 1.997l-2.353 2.353c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l2.35 -2.35"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbOctagon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z"
      }
    }]
  })(props);
}
;
export function TbOld(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 21l-1 -4l-2 -3v-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 14l-1 -3l4 -3l3 2l3 .5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "4",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 17l-2 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 21v-8.5a1.5 1.5 0 0 1 3 0v.5"
      }
    }]
  })(props);
}
;
export function TbOlympics(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "9",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "9",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "9",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "15",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "15",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbOmega(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5"
      }
    }]
  })(props);
}
;
export function TbOutlet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "12",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "12",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbOvalVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "transform": "matrix(0 -1 -1 0 24 24)",
        "cx": "12",
        "cy": "12",
        "rx": "6",
        "ry": "9"
      }
    }]
  })(props);
}
;
export function TbOval(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "12",
        "rx": "6",
        "ry": "9"
      }
    }]
  })(props);
}
;
export function TbOverline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 9v5a5 5 0 0 0 10 0v-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5h14"
      }
    }]
  })(props);
}
;
export function TbPackageOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.812 4.793l3.188 -1.793l8 4.5v8.5m-2.282 1.784l-5.718 3.216l-8 -4.5v-9l2.223 -1.25"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.543 10.57l5.457 -3.07"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-8 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5.25l-4.35 2.447m-2.564 1.442l-1.086 .611"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPackage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "20",
        "y2": "7.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "4",
        "y2": "7.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "5.25",
        "x2": "8",
        "y2": "9.75"
      }
    }]
  })(props);
}
;
export function TbPackgeExport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l8 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-8 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 18h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 15l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbPackgeImport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l8 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l-8 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 18h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 15l-3 3l3 3"
      }
    }]
  })(props);
}
;
export function TbPacman(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.636 5.636a9 9 0 0 1 13.397 .747l-5.619 5.617l5.619 5.617a9 9 0 1 1 -13.397 -11.981z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "11.5",
        "cy": "7.5",
        "r": "1",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbPageBreak(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3v4a1 1 0 0 0 1 1h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 14h3m4.5 0h3m4.5 0h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2"
      }
    }]
  })(props);
}
;
export function TbPaintOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h10a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-4m-4 0h-2a2 2 0 0 1 -2 -2v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5m-4 0h-1v2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "15",
        "width": "4",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPaint(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "3",
        "width": "14",
        "height": "6",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5l-5 0v2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "15",
        "width": "4",
        "height": "6",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbPaletteOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.934 3.97a8.993 8.993 0 0 1 4.066 -.97c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828a4.515 4.515 0 0 1 -1.118 .726m-3.564 .446h-1a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25a9 9 0 0 1 -6.372 -15.356"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7.5",
        "cy": "10.5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7.5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16.5",
        "cy": "10.5",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPalette(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21a9 9 0 1 1 0 -18a9 8 0 0 1 9 8a4.5 4 0 0 1 -4.5 4h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7.5",
        "cy": "10.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16.5",
        "cy": "10.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbPanoramaHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.338 5.53c5.106 1.932 10.211 1.932 15.317 .002a1 1 0 0 1 1.345 .934v11c0 .692 -.692 1.2 -1.34 .962c-5.107 -1.932 -10.214 -1.932 -15.321 0c-.648 .246 -1.339 -.242 -1.339 -.935v-11.027a1 1 0 0 1 1.338 -.935z"
      }
    }]
  })(props);
}
;
export function TbPanoramaVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.463 4.338c-1.932 5.106 -1.932 10.211 0 15.317a1 1 0 0 1 -.934 1.345h-11c-.692 0 -1.208 -.692 -.962 -1.34c1.932 -5.107 1.932 -10.214 0 -15.321c-.246 -.648 .243 -1.339 .935 -1.339h11.028c.693 0 1.18 .691 .935 1.338z"
      }
    }]
  })(props);
}
;
export function TbPaperBagOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.158 3.185c.256 -.119 .542 -.185 .842 -.185h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v2.82m-.177 3.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.185 13.173a2 2 0 1 0 2.64 2.647"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21a2 2 0 0 0 2 -2v-5.82a5 5 0 0 0 -.528 -2.236l-1.472 -2.944"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPaperBag(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 3h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v5.82a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-3a2 2 0 0 1 2 -2z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "15",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21a2 2 0 0 0 2 -2v-5.82a5 5 0 0 0 -.528 -2.236l-1.472 -2.944"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h2"
      }
    }]
  })(props);
}
;
export function TbPaperclip(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9l6.5 -6.5"
      }
    }]
  })(props);
}
;
export function TbParachuteOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12c0 -5.523 -4.477 -10 -10 -10c-1.737 0 -3.37 .443 -4.794 1.222m-2.28 1.71a9.969 9.969 0 0 0 -2.926 7.068"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12c0 -1.66 -1.46 -3 -3.25 -3c-1.63 0 -2.973 1.099 -3.212 2.54m-.097 -.09c-.23 -1.067 -1.12 -1.935 -2.29 -2.284m-3.445 .568c-.739 .55 -1.206 1.36 -1.206 2.266c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 12l10 10l-3.5 -10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.582 14.624l-2.582 7.376l4.992 -4.992m2.014 -2.014l2.994 -2.994"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbParachute(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12a10 10 0 1 0 -20 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3c0 -1.66 -1.57 -3 -3.5 -3s-3.5 1.34 -3.5 3c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 12l10 10l-3.5 -10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.5 12l-3.5 10l10 -10"
      }
    }]
  })(props);
}
;
export function TbParenthesesOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.743 5.745a12.253 12.253 0 0 0 1.257 14.255"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4a12.25 12.25 0 0 1 2.474 11.467m-1.22 2.794a12.291 12.291 0 0 1 -1.254 1.739"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbParentheses(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 4a12.25 12.25 0 0 0 0 16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4a12.25 12.25 0 0 1 0 16"
      }
    }]
  })(props);
}
;
export function TbParkingOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h10a2 2 0 0 1 2 2v10m-.582 3.41c-.362 .365 -.864 .59 -1.418 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.056 .59 -1.418"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16v-7m3 -1h1a2 2 0 0 1 1.817 2.836m-2.817 1.164h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbParking(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 16v-8h4a2 2 0 0 1 0 4h-4"
      }
    }]
  })(props);
}
;
export function TbPaw(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.7 13.5c-1.1 -1.996 -1.441 -2.5 -2.7 -2.5c-1.259 0 -1.736 .755 -2.836 2.747c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3.004 -1 4.5 -1s3.241 1 4.5 1c1.013 0 1.8 -.823 1.8 -2c0 -.285 -.049 -.697 -.146 -.962c-.475 -1.451 -2.512 -1.835 -3.454 -3.538z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.474 9c.055 0 .109 -.004 .163 -.011c.944 -.128 1.533 -1.346 1.32 -2.722c-.203 -1.297 -1.047 -2.267 -1.932 -2.267c-.055 0 -.109 .004 -.163 .011c-.944 .128 -1.533 1.346 -1.32 2.722c.204 1.293 1.048 2.267 1.933 2.267z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082z"
      }
    }]
  })(props);
}
;
export function TbPeace(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "18.3",
        "y2": "18.3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "5.7",
        "y2": "18.3"
      }
    }]
  })(props);
}
;
export function TbPencilOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.003 9.997l-6.003 6.003v4h4l6.006 -6.006m1.99 -1.99l2.504 -2.504a2.828 2.828 0 1 0 -4 -4l-2.5 2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 6.5l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPencil(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13.5",
        "y1": "6.5",
        "x2": "17.5",
        "y2": "10.5"
      }
    }]
  })(props);
}
;
export function TbPennant2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 21h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 21v-18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 4l-9 4l9 4"
      }
    }]
  })(props);
}
;
export function TbPennantOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 21h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21v-11m0 -4v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4l9 4l-4.858 2.16m-2.764 1.227l-1.378 .613"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPennant(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "21",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "21",
        "x2": "10",
        "y2": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4l9 4l-9 4"
      }
    }]
  })(props);
}
;
export function TbPentagon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.2 3.394l7.033 5.237a2 2 0 0 1 .7 2.247l-2.973 8.764a2 2 0 0 1 -1.894 1.358h-8.12a2 2 0 0 1 -1.9 -1.373l-2.896 -8.765a2 2 0 0 1 .696 -2.225l6.958 -5.237a2 2 0 0 1 2.397 -.006z"
      }
    }]
  })(props);
}
;
export function TbPepperOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.59 12.59c-.77 1.418 -2.535 2.41 -4.59 2.41c-2.761 0 -5 -1.79 -5 -4a8 8 0 0 0 13.643 5.67m1.64 -2.357a7.97 7.97 0 0 0 .717 -3.313a3 3 0 0 0 -5.545 -1.59"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8c0 -2 2 -4 4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPepper(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 11c0 2.21 -2.239 4 -5 4s-5 -1.79 -5 -4a8 8 0 1 0 16 0a3 3 0 0 0 -6 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8c0 -2 2 -4 4 -4"
      }
    }]
  })(props);
}
;
export function TbPercentage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "7",
        "r": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "18",
        "x2": "18",
        "y2": "6"
      }
    }]
  })(props);
}
;
export function TbPerspectiveOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.511 4.502l9.63 1.375a1 1 0 0 1 .859 .99v8.133m-.859 3.123l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 .01 -.137"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPerspective(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.141 4.163l12 1.714a1 1 0 0 1 .859 .99v10.266a1 1 0 0 1 -.859 .99l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 1.141 -.99z"
      }
    }]
  })(props);
}
;
export function TbPhoneCall(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 7a2 2 0 0 1 2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3a6 6 0 0 1 6 6"
      }
    }]
  })(props);
}
;
export function TbPhoneCalling(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "7",
        "x2": "15",
        "y2": "7.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "7",
        "x2": "18",
        "y2": "7.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "7",
        "x2": "21",
        "y2": "7.01"
      }
    }]
  })(props);
}
;
export function TbPhoneCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6l2 2l4 -4"
      }
    }]
  })(props);
}
;
export function TbPhoneIncoming(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 5 15 9 19 9"
      }
    }]
  })(props);
}
;
export function TbPhoneOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.831 14.161a15.946 15.946 0 0 1 -2.831 -8.161a2 2 0 0 1 2 -2h4l2 5l-2.5 1.5c.108 .22 .223 .435 .345 .645m1.751 2.277c.843 .84 1.822 1.544 2.904 2.078l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a15.963 15.963 0 0 1 -10.344 -4.657"
      }
    }]
  })(props);
}
;
export function TbPhoneOutgoing(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "9",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 4 20 4 20 8"
      }
    }]
  })(props);
}
;
export function TbPhonePause(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "3",
        "x2": "20",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "3",
        "x2": "16",
        "y2": "7"
      }
    }]
  })(props);
}
;
export function TbPhonePlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6h6m-3 -3v6"
      }
    }]
  })(props);
}
;
export function TbPhoneX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbPhone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
      }
    }]
  })(props);
}
;
export function TbPhotoOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "8",
        "x2": "15.01",
        "y2": "8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.121 19.122a3 3 0 0 1 -2.121 .878h-10a3 3 0 0 1 -3 -3v-10c0 -.833 .34 -1.587 .888 -2.131m3.112 -.869h9a3 3 0 0 1 3 3v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l5 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.32 12.34c.577 -.059 1.162 .162 1.68 .66l2 2"
      }
    }]
  })(props);
}
;
export function TbPhoto(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "8",
        "x2": "15.01",
        "y2": "8"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15l4 -4a3 5 0 0 1 3 0l5 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 14l1 -1a3 5 0 0 1 3 0l2 2"
      }
    }]
  })(props);
}
;
export function TbPhysotherapist(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 15l-1 -3l4 -2l4 1h3.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "4",
        "cy": "19",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "6",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 20h7l1 -4l4 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20h3"
      }
    }]
  })(props);
}
;
export function TbPictureInPictureOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "14",
        "width": "7",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "9",
        "x2": "11",
        "y2": "13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12v-3h3"
      }
    }]
  })(props);
}
;
export function TbPictureInPictureOn(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "14",
        "width": "7",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "9",
        "x2": "11",
        "y2": "13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13h3v-3"
      }
    }]
  })(props);
}
;
export function TbPictureInPictureTop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 5h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "transform": "matrix(1 0 0 -1 0 15)",
        "x": "14",
        "y": "5",
        "width": "7",
        "height": "5",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbPictureInPicture(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "14",
        "width": "7",
        "height": "5",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbPigOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h1.499l4.5 -3l.001 3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.057 .16 -.12 .318 -.19 .472m-1.467 2.528v1.5a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 1.5 -9.928"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPig(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3l0 3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342a6.008 6.008 0 0 1 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l.001 -.027a6 6 0 0 1 3.999 -10.473h2.5l4.5 -3z"
      }
    }]
  })(props);
}
;
export function TbPillOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.495 6.505l2.005 -2.005a4.95 4.95 0 0 1 7 7l-1.998 1.998m-2 2l-4.002 4.002a4.95 4.95 0 0 1 -7 -7l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.5 8.5l7 7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPill(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8.5",
        "y1": "8.5",
        "x2": "15.5",
        "y2": "15.5"
      }
    }]
  })(props);
}
;
export function TbPills(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "8",
        "r": "5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 4.5l7 7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.5 14.5l-5 5"
      }
    }]
  })(props);
}
;
export function TbPin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4.5l-4 4l-4 1.5l-1.5 1.5l7 7l1.5 -1.5l1.5 -4l4 -4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "4.5",
        "y2": "19.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.5",
        "y1": "4",
        "x2": "20",
        "y2": "9.5"
      }
    }]
  })(props);
}
;
export function TbPinnedOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4.5l-3.249 3.249m-2.57 1.433l-2.181 .818l-1.5 1.5l7 7l1.5 -1.5l.82 -2.186m1.43 -2.563l3.25 -3.251"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "4.5",
        "y2": "19.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.5",
        "y1": "4",
        "x2": "20",
        "y2": "9.5"
      }
    }]
  })(props);
}
;
export function TbPinned(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4v6l-2 4v2h10v-2l-2 -4v-6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "16",
        "y2": "4"
      }
    }]
  })(props);
}
;
export function TbPizzaOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.313 6.277l1.687 -3.277l5.34 10.376m2.477 6.463a19.093 19.093 0 0 1 -7.817 1.661c-3.04 0 -5.952 -.714 -8.5 -1.983l5.434 -10.559"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634c1.56 .002 3.105 -.24 4.582 -.713"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 14v-.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPizza(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21.5c-3.04 0 -5.952 -.714 -8.5 -1.983l8.5 -16.517l8.5 16.517a19.09 19.09 0 0 1 -8.5 1.983z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634a14.944 14.944 0 0 0 6.502 -1.479"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 11.01v-.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 14v-.01"
      }
    }]
  })(props);
}
;
export function TbPlaneArrival(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12h5a2 2 0 0 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3z",
        "transform": "rotate(15 12 12) translate(0 -1)"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbPlaneDeparture(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12h5a2 2 0 0 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3z",
        "transform": "rotate(-15 12 12) translate(0 -1)"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbPlaneInflight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11.085h5a2 2 0 1 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3l4 7z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21h18"
      }
    }]
  })(props);
}
;
export function TbPlaneOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.788 5.758l-.788 -2.758h3l4 7h4a2 2 0 1 1 0 4h-2m-2.718 1.256l-3.282 5.744h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPlane(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 10h4a2 2 0 0 1 0 4h-4l-4 7h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h4l-2 -7h3z"
      }
    }]
  })(props);
}
;
export function TbPlanetOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.816 13.58c1.956 1.825 3.157 3.449 3.184 4.445m-3.428 .593c-2.098 -.634 -4.944 -2.03 -7.919 -3.976c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.32 -.628 1.591 -.6 3.294 -.113"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.042 7.059a7 7 0 0 0 9.908 9.89m1.581 -2.425a7 7 0 0 0 -9.057 -9.054"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPlanet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.816 13.58c2.292 2.138 3.546 4 3.092 4.9c-.745 1.46 -5.783 -.259 -11.255 -3.838c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.464 -.91 2.926 -.444 5.803 .805"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "7"
      }
    }]
  })(props);
}
;
export function TbPlant2Off(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 9c0 5.523 4.477 10 10 10a9.953 9.953 0 0 0 5.418 -1.593m2.137 -1.855a9.961 9.961 0 0 0 2.445 -6.552"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19c0 -1.988 .58 -3.84 1.58 -5.397m1.878 -2.167a9.961 9.961 0 0 1 6.542 -2.436"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 9a10 10 0 0 1 10 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4a9.7 9.7 0 0 1 3.002 7.013"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.01 11.5a9.696 9.696 0 0 1 .163 -2.318m1.082 -2.942a9.696 9.696 0 0 1 1.745 -2.24"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPlant2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 9a10 10 0 1 0 20 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19a10 10 0 0 1 10 -10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 9a10 10 0 0 1 10 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4a9.7 9.7 0 0 1 2.99 7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5"
      }
    }]
  })(props);
}
;
export function TbPlantOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.9 7.908a6.006 6.006 0 0 0 -4.79 -4.806m-4.11 -.102v2a6 6 0 0 0 6 6h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.531 8.528a6.001 6.001 0 0 1 5.469 -3.528h3v1a6.002 6.002 0 0 1 -5.037 5.923"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPlant(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 15h10v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 11a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbPlayCardOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 18h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.716 13.712l-1.716 2.288l-3 -4l1.29 -1.72"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPlayCard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "transform": "rotate(90 12 12)",
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "6",
        "x2": "8.01",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "18",
        "x2": "16.01",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16l-3 -4l3 -4l3 4z"
      }
    }]
  })(props);
}
;
export function TbPlayerEject(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12h14l-7 -8z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "16",
        "width": "14",
        "height": "4",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbPlayerPause(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "5",
        "width": "4",
        "height": "14",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "5",
        "width": "4",
        "height": "14",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbPlayerPlay(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 4v16l13 -8z"
      }
    }]
  })(props);
}
;
export function TbPlayerRecord(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "7"
      }
    }]
  })(props);
}
;
export function TbPlayerSkipBack(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 5v14l-12 -7z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "5",
        "x2": "4",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbPlayerSkipForward(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 5v14l12 -7z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "5",
        "x2": "20",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbPlayerStop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "5",
        "width": "14",
        "height": "14",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbPlayerTrackNext(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 5v14l8 -7z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 5v14l8 -7z"
      }
    }]
  })(props);
}
;
export function TbPlayerTrackPrev(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 5v14l-8 -7z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5v14l-8 -7z"
      }
    }]
  })(props);
}
;
export function TbPlaylistAdd(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 8h-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 16h-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 16h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 13v6"
      }
    }]
  })(props);
}
;
export function TbPlaylistOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 14a3 3 0 1 0 3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13v-9h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 5h-4m-4 0h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 13h-6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPlaylistX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 8h-14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 12h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 14l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 14l-4 4"
      }
    }]
  })(props);
}
;
export function TbPlaylist(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14",
        "cy": "17",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v-13h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 5h-10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "9",
        "x2": "13",
        "y2": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 13h-6"
      }
    }]
  })(props);
}
;
export function TbPlugConnectedX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 16l-4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21l2.5 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 5.5l2.5 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11l-2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 14l-2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16l4 4"
      }
    }]
  })(props);
}
;
export function TbPlugConnected(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21l2.5 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 5.5l2.5 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11l-2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 14l-2 2"
      }
    }]
  })(props);
}
;
export function TbPlugOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.123 16.092l-.177 .177a5.81 5.81 0 1 1 -8.215 -8.215l.159 -.159"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20l3.5 -3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4l-3.5 3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 9l-3.5 3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPlugX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.55 17.733a5.806 5.806 0 0 1 -7.356 -4.052a5.81 5.81 0 0 1 1.537 -5.627l2.054 -2.054l7.165 7.165"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20l3.5 -3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4l-3.5 3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 9l-3.5 3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 16l-4 4"
      }
    }]
  })(props);
}
;
export function TbPlug(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.785 6l8.215 8.215l-2.054 2.054a5.81 5.81 0 1 1 -8.215 -8.215l2.054 -2.054z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20l3.5 -3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4l-3.5 3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 9l-3.5 3.5"
      }
    }]
  })(props);
}
;
export function TbPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbPodium(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 8h14l-.621 2.485a2 2 0 0 1 -1.94 1.515h-8.878a2 2 0 0 1 -1.94 -1.515l-.621 -2.485z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 8v-2a3 3 0 0 1 3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12l1 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12l-1 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 21h10"
      }
    }]
  })(props);
}
;
export function TbPointOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.15 9.194a4 4 0 0 0 5.697 5.617m1.153 -2.811a4 4 0 0 0 -4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPoint(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }]
  })(props);
}
;
export function TbPokeball(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "9",
        "r": "9",
        "transform": "translate(3 3)"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h6m6 0h6"
      }
    }]
  })(props);
}
;
export function TbPolaroid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "20",
        "y2": "16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12l3 -3c.928 -.893 2.072 -.893 3 0l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 12l2 -2c.928 -.893 2.072 -.893 3 0l2 2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "7",
        "x2": "14.01",
        "y2": "7"
      }
    }]
  })(props);
}
;
export function TbPolygonOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "8",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "11",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 9.5l1.546 -1.311"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 5.5l3 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 10l-1.185 3.318m-1.062 2.972l-.253 .71"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 17.5l-7 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPolygon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "8",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "11",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 9.5l3.5 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 5.5l3 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 10l-2.5 7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 17.5l-7 -5"
      }
    }]
  })(props);
}
;
export function TbPool(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12v-7.5a1.5 1.5 0 0 1 3 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12v-7.5a1.5 1.5 0 0 0 -3 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "5",
        "x2": "9",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "15",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbPower(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 6a7.75 7.75 0 1 0 10 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbPray(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20h8l-4 -4v-7l4 3l2 -2"
      }
    }]
  })(props);
}
;
export function TbPremiumRights(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 15v2"
      }
    }]
  })(props);
}
;
export function TbPrescription(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 19v-16h4.5a4.5 4.5 0 1 1 0 9h-4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 21l-9 -9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 21l6 -6"
      }
    }]
  })(props);
}
;
export function TbPresentationAnalytics(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 12v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 4h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 20h6"
      }
    }]
  })(props);
}
;
export function TbPresentationOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 4h1m4 0h13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4v10a2 2 0 0 0 2 2h10m3.42 -.592c.359 -.362 .58 -.859 .58 -1.408v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 20h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12l2 -2m4 0l2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPresentation(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "4",
        "x2": "21",
        "y2": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "20",
        "x2": "15",
        "y2": "20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12l3 -3l2 2l3 -3"
      }
    }]
  })(props);
}
;
export function TbPrinterOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.412 16.416c.363 -.362 .588 -.863 .588 -1.416v-4a2 2 0 0 0 -2 -2h-6m-4 0h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 9v-4a2 2 0 0 0 -2 -2h-6c-.551 0 -1.05 .223 -1.412 .584m-.588 3.416v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPrinter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "13",
        "width": "10",
        "height": "8",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbPrison(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 4v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 9h-6v6h6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 15v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12h-.01"
      }
    }]
  })(props);
}
;
export function TbPrompt(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "5 7 10 12 5 17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "17",
        "x2": "19",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbPropellerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.448 10.432a3 3 0 1 0 4.106 4.143"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.272 10.272c.66 -1.459 1.058 -2.888 1.198 -4.286c.22 -1.63 -.762 -2.986 -3.47 -2.986c-1.94 0 -2.994 .696 -3.355 1.69m.697 4.653c.145 .384 .309 .77 .491 1.157"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.02 .789 2.265 .853 3.408 -.288m1.479 -2.493c.492 -1.634 -.19 -2.726 -1.416 -3.229c-.82 -.37 -1.703 -.654 -2.65 -.852"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.664 12.999c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPropeller(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "13",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.167 10.5c.722 -1.538 1.156 -3.043 1.303 -4.514c.22 -1.63 -.762 -2.986 -3.47 -2.986s-3.69 1.357 -3.47 2.986c.147 1.471 .581 2.976 1.303 4.514"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.3 1.006 2.967 .833 4.321 -1.512c1.354 -2.345 .67 -3.874 -.85 -4.498c-1.348 -.608 -2.868 -.985 -4.562 -1.128"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.664 12.999c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386"
      }
    }]
  })(props);
}
;
export function TbPuzzle2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v2.5a0.5 .5 0 0 1 -.5 .5a1.5 1.5 0 0 0 0 3a0.5 .5 0 0 1 .5 .5v1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v1.5a0.5 .5 0 0 0 .5 .5a1.5 1.5 0 0 1 0 3a0.5 .5 0 0 0 -.5 .5v2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12h-2.5a0.5 .5 0 0 1 -.5 -.5a1.5 1.5 0 0 0 -3 0a0.5 .5 0 0 1 -.5 .5h-1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12h-1.5a0.5 .5 0 0 0 -.5 .5a1.5 1.5 0 0 1 -3 0a0.5 .5 0 0 0 -.5 -.5h-2.5"
      }
    }]
  })(props);
}
;
export function TbPuzzleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.18 4.171a2 2 0 0 1 3.82 .829v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 .819 3.825m-2.819 1.175v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 1 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 1 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPuzzle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7h3a1 1 0 0 0 1 -1v-1a2 2 0 0 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-1a1 1 0 0 0 -1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 0 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 0 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1"
      }
    }]
  })(props);
}
;
export function TbPyramidOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.483 8.471l-5.483 8.529l9 4l6.22 -2.764m2.78 -1.236l-9 -14l-1.937 3.014"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v5m0 4v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbPyramid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17l9 4l9 -4l-9 -14z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v18"
      }
    }]
  })(props);
}
;
export function TbQrcode(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "17",
        "x2": "7",
        "y2": "17.01"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "4",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "7",
        "x2": "7",
        "y2": "7.01"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "14",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "7",
        "x2": "17",
        "y2": "7.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "14",
        "x2": "17",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "14",
        "x2": "20",
        "y2": "14.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "14",
        "x2": "14",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "20",
        "x2": "17",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "17",
        "x2": "20",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "17",
        "x2": "20",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbQuestionMark(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "12",
        "y2": "19.01"
      }
    }]
  })(props);
}
;
export function TbQuoteOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1m4 4v3c0 2.667 -1.333 4.333 -4 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 11h-4m-1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 .66 -.082 1.26 -.245 1.798m-1.653 2.29c-.571 .4 -1.272 .704 -2.102 .912"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbQuote(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
      }
    }]
  })(props);
}
;
export function TbRadar2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.51 15.56a5 5 0 1 0 -3.51 1.44"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.832 17.86a9 9 0 1 0 -6.832 3.14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v9"
      }
    }]
  })(props);
}
;
export function TbRadar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12h-8a1 1 0 1 0 -1 1v8a9 9 0 0 0 9 -9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.999 8.998a5 5 0 1 0 -6.999 7.003"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.486 8.995a9 9 0 1 0 -11.482 11.495"
      }
    }]
  })(props);
}
;
export function TbRadio(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 3l-9.371 3.749a1 1 0 0 0 -.629 .928v11.323a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-11a1 1 0 0 0 -1 -1h-14.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 16v.01"
      }
    }]
  })(props);
}
;
export function TbRadioactiveOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.118 14.127c-.182 .181 -.39 .341 -.618 .473l3 5.19a8.994 8.994 0 0 0 1.856 -1.423m1.68 -2.32a8.993 8.993 0 0 0 .964 -4.047h-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 9.4l3 -5.19a9 9 0 0 0 -8.536 -.25"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 14.6l-3 5.19a9 9 0 0 1 -4.5 -7.79h6a3 3 0 0 0 1.5 2.6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRadioactive(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 14.6l3 5.19a9 9 0 0 0 4.5 -7.79h-6a3 3 0 0 1 -1.5 2.6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.5 9.4l3 -5.19a9 9 0 0 0 -9 0l3 5.19a3 3 0 0 1 3 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 14.6l-3 5.19a9 9 0 0 1 -4.5 -7.79h6a3 3 0 0 0 1.5 2.6"
      }
    }]
  })(props);
}
;
export function TbRadiusBottomLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 19h-6a8 8 0 0 1 -8 -8v-6"
      }
    }]
  })(props);
}
;
export function TbRadiusBottomRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5v6a8 8 0 0 1 -8 8h-6"
      }
    }]
  })(props);
}
;
export function TbRadiusTopLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19v-6a8 8 0 0 1 8 -8h6"
      }
    }]
  })(props);
}
;
export function TbRadiusTopRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5h6a8 8 0 0 1 8 8v6"
      }
    }]
  })(props);
}
;
export function TbRainbowOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 17c0 -5.523 -4.477 -10 -10 -10c-.308 0 -.613 .014 -.914 .041m-3.208 .845a10.002 10.002 0 0 0 -5.878 9.114"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.088 11.069a6.001 6.001 0 0 0 -5.088 5.931"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17a2 2 0 1 0 -4 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRainbow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 17c0 -5.523 -4.477 -10 -10 -10s-10 4.477 -10 10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 17a6 6 0 1 0 -12 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 17a2 2 0 1 0 -4 0"
      }
    }]
  })(props);
}
;
export function TbReceipt2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 8h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5m2 0v1.5m0 -9v1.5"
      }
    }]
  })(props);
}
;
export function TbReceiptOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-16m2 -2h10a2 2 0 0 1 2 2v10m0 4.01v1.99l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "7",
        "x2": "15",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "11",
        "x2": "11",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "15",
        "x2": "15",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "11",
        "x2": "15",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbReceiptRefund(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 14v-2a2 2 0 0 0 -2 -2h-4l2 -2m0 4l-2 -2"
      }
    }]
  })(props);
}
;
export function TbReceiptTax(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "14",
        "x2": "15",
        "y2": "8"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9.5",
        "cy": "8.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "14.5",
        "cy": "13.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
      }
    }]
  })(props);
}
;
export function TbReceipt(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2m4 -14h6m-6 4h6m-2 4h2"
      }
    }]
  })(props);
}
;
export function TbRecharging(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.038 4.5a9 9 0 0 0 -2.495 2.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.186 10.209a9 9 0 0 0 0 3.508"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 16.962a9 9 0 0 0 2.47 2.495"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.209 20.814a9 9 0 0 0 3.5 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.962 19.5a9 9 0 0 0 2.495 -2.47"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.814 13.791a9 9 0 0 0 0 -3.508"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.5 7.038a9 9 0 0 0 -2.47 -2.495"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.791 3.186a9 9 0 0 0 -3.508 -.02"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8l-2 4h4l-2 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21a9 9 0 0 0 0 -18"
      }
    }]
  })(props);
}
;
export function TbRecordMailOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.569 14.557a3 3 0 1 0 -4.113 -4.149"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 15h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRecordMail(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "15",
        "x2": "17",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbRectangleVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "3",
        "width": "14",
        "height": "18",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbRectangle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbRecycleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17l-2 2l2 2m-2 -2h9m1.896 -2.071a1.999 1.999 0 0 0 -.146 -.679l-.55 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.536 11l-.732 -2.732l-2.732 .732m2.732 -.732l-4.5 7.794a2 2 0 0 0 1.506 2.89l1.141 .024"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.464 11l2.732 .732l.732 -2.732m-.732 2.732l-4.5 -7.794a2 2 0 0 0 -3.256 -.14l-.591 .976"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRecycle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17l-2 2l2 2m-2 -2h9a2 2 0 0 0 1.75 -2.75l-.55 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17l-2 2l2 2m-2 -2h9a2 2 0 0 0 1.75 -2.75l-.55 -1",
        "transform": "rotate(120 12 13)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17l-2 2l2 2m-2 -2h9a2 2 0 0 0 1.75 -2.75l-.55 -1",
        "transform": "rotate(240 12 13)"
      }
    }]
  })(props);
}
;
export function TbRefreshAlert(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12.01",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbRefreshDot(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbRefreshOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 11a8.1 8.1 0 0 0 -11.271 -6.305m-2.41 1.624a8.083 8.083 0 0 0 -1.819 2.681m-.5 -4v4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13a8.1 8.1 0 0 0 13.671 4.691m2.329 -1.691v-1h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRefresh(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
      }
    }]
  })(props);
}
;
export function TbRegistered(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 15v-6h2a2 2 0 1 1 0 4h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15l-2 -2"
      }
    }]
  })(props);
}
;
export function TbRelationManyToMany(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 14v-4l3 4v-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 14v-4l3 4v-4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "10.5",
        "x2": "12",
        "y2": "10.51"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "13.5",
        "x2": "12",
        "y2": "13.51"
      }
    }]
  })(props);
}
;
export function TbRelationOneToMany(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 10h1v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 14v-4l3 4v-4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "10.5",
        "x2": "11",
        "y2": "10.51"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "13.5",
        "x2": "11",
        "y2": "13.51"
      }
    }]
  })(props);
}
;
export function TbRelationOneToOne(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 10h1v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10h1v4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "10.5",
        "x2": "12",
        "y2": "10.51"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "13.5",
        "x2": "12",
        "y2": "13.51"
      }
    }]
  })(props);
}
;
export function TbRepeatOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v-3c0 -1.336 .873 -2.468 2.08 -2.856m3.92 -.144h10m-3 -3l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v3a3 3 0 0 1 -.133 .886m-1.99 1.984a3 3 0 0 1 -.877 .13h-13m3 3l-3 -3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRepeatOnce(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 11l1 -1v4"
      }
    }]
  })(props);
}
;
export function TbRepeat(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"
      }
    }]
  })(props);
}
;
export function TbReplace(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "15",
        "y": "15",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"
      }
    }]
  })(props);
}
;
export function TbReportAnalytics(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 17v-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 17v-3"
      }
    }]
  })(props);
}
;
export function TbReportMedical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "14",
        "x2": "14",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbReportMoney(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v1m0 -8v1"
      }
    }]
  })(props);
}
;
export function TbReportOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.576 5.595a1.994 1.994 0 0 0 -.576 1.405v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-8a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 1 1 0 4h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbReportSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 12v-5a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 15h3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16.5",
        "cy": "17.5",
        "r": "2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 19.5l2.5 2.5"
      }
    }]
  })(props);
}
;
export function TbReport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 14v4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 11v-4a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "3",
        "width": "6",
        "height": "4",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "18",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 11h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 15h3"
      }
    }]
  })(props);
}
;
export function TbResize(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 11v8a1 1 0 0 0 1 1h8m-9 -14v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h7a1 1 0 0 1 1 1v7"
      }
    }]
  })(props);
}
;
export function TbRippleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7c.915 -.61 1.83 -1.034 2.746 -1.272m4.212 .22c.68 .247 1.361 .598 2.042 1.052c3 2 6 2 9 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17c3 -2 6 -2 9 0c2.092 1.395 4.184 1.817 6.276 1.266"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12c3 -2 6 -2 9 0m5.482 1.429c1.173 -.171 2.345 -.647 3.518 -1.429"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRipple(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7c3 -2 6 -2 9 0s6 2 9 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17c3 -2 6 -2 9 0s6 2 9 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12c3 -2 6 -2 9 0s6 2 9 0"
      }
    }]
  })(props);
}
;
export function TbRoadOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 19l3.332 -11.661"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5l2.806 9.823"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRoadSign(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14v-2c0 -.59 .414 -1 1 -1h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9l2 2l-2 2"
      }
    }]
  })(props);
}
;
export function TbRoad(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 19l4 -14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5l4 14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v-2"
      }
    }]
  })(props);
}
;
export function TbRobotOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h6a2 2 0 0 1 2 2v1l1 1v3l-1 1m-.171 3.811a2 2 0 0 1 -1.829 1.189h-10a2 2 0 0 1 -2 -2v-3l-1 -1v-3l1 -1v-1a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16h4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "11.5",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.854 11.853a0.498 .498 0 0 0 -.354 -.853a0.498 .498 0 0 0 -.356 .149"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.336 4.343l-.336 -1.343"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 7l1 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRobot(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7h10a2 2 0 0 1 2 2v1l1 1v3l-1 1v3a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-3l-1 -1v-3l1 -1v-1a2 2 0 0 1 2 -2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16h4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "11.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "11.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 7l-1 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 7l1 -4"
      }
    }]
  })(props);
}
;
export function TbRocketOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.29 9.275a9.03 9.03 0 0 0 -.29 .725a6 6 0 0 0 -5 3a8 8 0 0 1 7 7a6 6 0 0 0 3 -5c.241 -.085 .478 -.18 .708 -.283m2.428 -1.61a8.998 8.998 0 0 0 2.864 -6.107a3 3 0 0 0 -3 -3a8.998 8.998 0 0 0 -6.107 2.864"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "9",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRocket(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3 -5a9 9 0 0 0 6 -8a3 3 0 0 0 -3 -3a9 9 0 0 0 -8 6a6 6 0 0 0 -5 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "9",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbRollerSkating(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.905 5h3.418a1 1 0 0 1 .928 .629l1.143 2.856a3 3 0 0 0 2.207 1.83l4.717 .926a2.084 2.084 0 0 1 1.682 2.045v.714a1 1 0 0 1 -1 1h-13.895a1 1 0 0 1 -.995 -1.1l.8 -8a1 1 0 0 1 .995 -.9z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "17",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbRollercoaster(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21a5.55 5.55 0 0 0 5.265 -3.795l.735 -2.205a8.775 8.775 0 0 1 8.325 -6h3.675"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 9v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 21v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 9.5v11.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3h5v3h-5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8l4 -3l2 2.5l-4 3l-1.8 -.5z"
      }
    }]
  })(props);
}
;
export function TbRotate2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4.55a8 8 0 0 0 -6 14.9m0 -4.45v5h-5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18.37",
        "y1": "7.16",
        "x2": "18.37",
        "y2": "7.17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "19.94",
        "x2": "13",
        "y2": "19.95"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16.84",
        "y1": "18.37",
        "x2": "16.84",
        "y2": "18.38"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19.37",
        "y1": "15.1",
        "x2": "19.37",
        "y2": "15.11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19.94",
        "y1": "11",
        "x2": "19.94",
        "y2": "11.01"
      }
    }]
  })(props);
}
;
export function TbRotate360(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.458 11.042c.86 -2.366 .722 -4.58 -.6 -5.9c-2.272 -2.274 -7.185 -1.045 -10.973 2.743c-3.788 3.788 -5.017 8.701 -2.744 10.974c2.227 2.226 6.987 1.093 10.74 -2.515"
      }
    }]
  })(props);
}
;
export function TbRotateClockwise2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4.55a8 8 0 0 1 6 14.9m0 -4.45v5h5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5.63",
        "y1": "7.16",
        "x2": "5.63",
        "y2": "7.17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.06",
        "y1": "11",
        "x2": "4.06",
        "y2": "11.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.63",
        "y1": "15.1",
        "x2": "4.63",
        "y2": "15.11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.16",
        "y1": "18.37",
        "x2": "7.16",
        "y2": "18.38"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "19.94",
        "x2": "11",
        "y2": "19.95"
      }
    }]
  })(props);
}
;
export function TbRotateClockwise(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5"
      }
    }]
  })(props);
}
;
export function TbRotateDot(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbRotateRectangle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.3 5h.7a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h5l-2.82 -2.82m0 5.64l2.82 -2.82",
        "transform": "rotate(-45 12 12)"
      }
    }]
  })(props);
}
;
export function TbRotate(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"
      }
    }]
  })(props);
}
;
export function TbRouteOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19h4.5c.71 0 1.372 -.212 1.924 -.576m1.545 -2.459a3.5 3.5 0 0 0 -3.469 -3.965h-.499m-4 0h-3.501a3.5 3.5 0 0 1 -2.477 -5.972m2.477 -1.028h3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRoute(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19h4.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h3.5"
      }
    }]
  })(props);
}
;
export function TbRouter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "13",
        "width": "18",
        "height": "8",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "17",
        "x2": "17",
        "y2": "17.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "17",
        "x2": "13",
        "y2": "17.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "13",
        "x2": "15",
        "y2": "11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.75 8.75a4 4 0 0 1 6.5 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.5 6.5a8 8 0 0 1 13 0"
      }
    }]
  })(props);
}
;
export function TbRowInsertBottom(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "17",
        "x2": "10",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbRowInsertTop(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9v-4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "7",
        "x2": "14",
        "y2": "7"
      }
    }]
  })(props);
}
;
export function TbRss(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4a16 16 0 0 1 16 16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 11a9 9 0 0 1 9 9"
      }
    }]
  })(props);
}
;
export function TbRuler2Off(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.03 7.97l4.97 -4.97l4 4l-5 5m-2 2l-7 7l-4 -4l7 -7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7l-1.5 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13l-1.5 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16l-1.5 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRuler2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3l4 4l-14 14l-4 -4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7l-1.5 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 10l-1.5 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13l-1.5 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16l-1.5 -1.5"
      }
    }]
  })(props);
}
;
export function TbRulerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h11a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-4m-3.713 .299a0.997 .997 0 0 0 -.287 .701v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14c0 -.284 .118 -.54 .308 -.722"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbRuler(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "6",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "7",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "16",
        "x2": "6",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "4",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 4 12 7 "
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 4 16 6 "
      }
    }]
  })(props);
}
;
export function TbRun(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "13",
        "cy": "4",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17l5 1l.75 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 21l0 -4l-4 -3l1 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12l0 -3l5 -1l3 3l3 1"
      }
    }]
  })(props);
}
;
export function TbSailboat(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18l-1 -3h18l-1 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 12h7l-7 -9v9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "7",
        "x2": "6",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbSalt(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 8h9l-.281 -2.248a2 2 0 0 0 -1.985 -1.752h-4.468a2 2 0 0 0 -1.986 1.752l-.28 2.248z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 8l-1.612 9.671a2 2 0 0 0 1.973 2.329h8.278a2 2 0 0 0 1.973 -2.329l-1.612 -9.671"
      }
    }]
  })(props);
}
;
export function TbSatelliteOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.707 3.707l5.586 5.586m-1.293 2.707l-1.293 1.293a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414l1.293 -1.293"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10l-3 3l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6l3 -3l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.5 17c.69 0 1.316 -.28 1.769 -.733"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 21c1.654 0 3.151 -.67 4.237 -1.752m1.507 -2.507a6 6 0 0 0 .256 -1.741"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSatellite(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.707 6.293l2.586 -2.586a1 1 0 0 1 1.414 0l5.586 5.586a1 1 0 0 1 0 1.414l-2.586 2.586a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10l-3 3l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6l3 -3l3 3l-3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "13.5",
        "y2": "13.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.5 17a2.5 2.5 0 0 0 2.5 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 21a6 6 0 0 0 6 -6"
      }
    }]
  })(props);
}
;
export function TbSausage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.5 5.5a2.5 2.5 0 0 0 -2.5 2.5c0 7.18 5.82 13 13 13a2.5 2.5 0 1 0 0 -5a8 8 0 0 1 -8 -8a2.5 2.5 0 0 0 -2.5 -2.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.195 5.519l-1.243 -1.989a1 1 0 0 1 .848 -1.53h1.392a1 1 0 0 1 .848 1.53l-1.245 1.99"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.482 18.225l1.989 -1.243a1 1 0 0 1 1.53 .848v1.392a1 1 0 0 1 -1.53 .848l-1.991 -1.245"
      }
    }]
  })(props);
}
;
export function TbScaleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 20h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.452 5.425l2.548 -.425l6 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v5m0 4v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.873 14.871a3.001 3.001 0 0 0 2.127 -2.871l-3 -6l-2.677 5.355"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbScaleOutlineOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h10a4 4 0 0 1 4 4v10m-1.173 2.83a3.987 3.987 0 0 1 -2.827 1.17h-10a4 4 0 0 1 -4 -4v-10c0 -1.104 .447 -2.103 1.17 -2.827"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.062 7.062c.31 -.041 .622 -.062 .938 -.062c1.956 0 3.724 .802 4.994 2.095a142.85 142.85 0 0 0 -1.994 1.905m-3.723 .288a3 3 0 0 0 -1.315 .71l-2.956 -2.903a6.977 6.977 0 0 1 1.142 -.942"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbScaleOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7c1.956 0 3.724 .802 4.994 2.095l-2.956 2.904a3 3 0 0 0 -2.038 -.799a3 3 0 0 0 -2.038 .798l-2.956 -2.903a6.979 6.979 0 0 1 4.994 -2.095z"
      }
    }]
  })(props);
}
;
export function TbScale(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "20",
        "x2": "17",
        "y2": "20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6l6 -1l6 1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12l-3 -6l-3 6a3 3 0 0 0 6 0"
      }
    }]
  })(props);
}
;
export function TbScan(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7v-1a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17v1a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h2a2 2 0 0 0 2 -2v-1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbSchoolOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 9l-10 -4l-2.136 .854m-2.864 1.146l-5 2l10 4l.697 -.279m2.878 -1.151l6.425 -2.57v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10.6v5.4c0 1.657 2.686 3 6 3c2.334 0 4.357 -.666 5.35 -1.64m.65 -3.36v-3.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSchool(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 9l-10 -4l-10 4l10 4l10 -4v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10.6v5.4a6 3 0 0 0 12 0v-5.4"
      }
    }]
  })(props);
}
;
export function TbScissorsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.432 4.442a3 3 0 1 0 4.114 4.146"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "17",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.6 15.4l3.4 -3.4m2 -2l5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbScissors(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "7",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "17",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8.6",
        "y1": "8.6",
        "x2": "19",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8.6",
        "y1": "15.4",
        "x2": "19",
        "y2": "5"
      }
    }]
  })(props);
}
;
export function TbScooterElectric(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4l-2 4h3l-2 4"
      }
    }]
  })(props);
}
;
export function TbScooter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
      }
    }]
  })(props);
}
;
export function TbScreenShareOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "20",
        "x2": "17",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "16",
        "x2": "9",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "16",
        "x2": "15",
        "y2": "20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 8l4 -4m-4 0l4 4"
      }
    }]
  })(props);
}
;
export function TbScreenShare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "20",
        "x2": "17",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "16",
        "x2": "9",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "16",
        "x2": "15",
        "y2": "20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4h4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 9l5 -5"
      }
    }]
  })(props);
}
;
export function TbScribble(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 15c2 3 4 4 7 4s7 -3 7 -7s-3 -7 -6 -7s-5 1.5 -5 4s2 5 6 5s8.408 -2.453 10 -5"
      }
    }]
  })(props);
}
;
export function TbScubaMask(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7h12a1 1 0 0 1 1 1v4.5a2.5 2.5 0 0 1 -2.5 2.5h-.5a2 2 0 0 1 -2 -2a2 2 0 1 0 -4 0a2 2 0 0 1 -2 2h-.5a2.5 2.5 0 0 1 -2.5 -2.5v-4.5a1 1 0 0 1 1 -1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 17a2 2 0 0 0 2 2h3.5a5.5 5.5 0 0 0 5.5 -5.5v-9.5"
      }
    }]
  })(props);
}
;
export function TbSearchOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.039 5.062a7 7 0 0 0 9.91 9.89m1.584 -2.434a7 7 0 0 0 -9.038 -9.057"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbSectionSign(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.172 19.004a3.001 3.001 0 1 0 2.828 -4.004"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.83 5.002a3.001 3.001 0 1 0 -2.83 3.998"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbSection(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 20h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 20h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4l0 0"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "8",
        "width": "16",
        "height": "8",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbSeedingOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.412 7.407a6.025 6.025 0 0 0 -2.82 -2.82m-4.592 -.587h-1v2a6 6 0 0 0 6 6h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14a6 6 0 0 1 .255 -1.736m1.51 -2.514a5.981 5.981 0 0 1 4.235 -1.75h3v1c0 2.158 -1.14 4.05 -2.85 5.107m-3.15 .893h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 20v-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSeeding(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 10a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbSelect(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 11l3 3l3 -3"
      }
    }]
  })(props);
}
;
export function TbSelector(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 9 12 5 16 9"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 15 12 19 8 15"
      }
    }]
  })(props);
}
;
export function TbSend(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "14",
        "x2": "21",
        "y2": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5"
      }
    }]
  })(props);
}
;
export function TbSeparatorHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 8 12 4 16 8"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 16 12 20 8 16"
      }
    }]
  })(props);
}
;
export function TbSeparatorVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "20"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 8 4 12 8 16"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 16 20 12 16 8"
      }
    }]
  })(props);
}
;
export function TbSeparator(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "3",
        "y2": "12.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "12",
        "x2": "17",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "12",
        "x2": "21",
        "y2": "12.01"
      }
    }]
  })(props);
}
;
export function TbServer2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "8",
        "rx": "3"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "12",
        "width": "18",
        "height": "8",
        "rx": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "8",
        "x2": "7",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "16",
        "x2": "7",
        "y2": "16.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 8h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 16h6"
      }
    }]
  })(props);
}
;
export function TbServerOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12h-6a3 3 0 0 1 -3 -3v-2c0 -1.083 .574 -2.033 1.435 -2.56m3.565 -.44h10a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12h2a3 3 0 0 1 3 3v2m-1.448 2.568a2.986 2.986 0 0 1 -1.552 .432h-12a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 8v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 16v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbServer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "8",
        "rx": "3"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "12",
        "width": "18",
        "height": "8",
        "rx": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "8",
        "x2": "7",
        "y2": "8.01"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "16",
        "x2": "7",
        "y2": "16.01"
      }
    }]
  })(props);
}
;
export function TbServicemark(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 15v-6l3 4l3 -4v6"
      }
    }]
  })(props);
}
;
export function TbSettingsAutomation(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 9v6l5 -3z"
      }
    }]
  })(props);
}
;
export function TbSettingsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.456 5.435c.416 -.22 .745 -.609 .869 -1.118c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.187 1.016m-.126 3.666c-.516 .522 -1.348 .733 -2.123 .261a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.468 -.768 -.266 -1.59 .246 -2.108"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.879 9.878a3 3 0 1 0 4.256 4.23m.552 -3.444a3.012 3.012 0 0 0 -1.412 -1.38"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSettings(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbShadowOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.634 5.638a9 9 0 0 0 12.728 12.727m1.68 -2.32a9 9 0 0 0 -12.086 -12.088"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 15h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 18h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 6h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbShadow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 12h5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 15h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 18h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 6h1"
      }
    }]
  })(props);
}
;
export function TbShape2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 17.5l11 -11m-12.5 .5v10m14 -10v10"
      }
    }]
  })(props);
}
;
export function TbShape3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 5h10m-12 2v10m14 -10v10"
      }
    }]
  })(props);
}
;
export function TbShapeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.575 3.597a2 2 0 0 0 2.849 2.808"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.574 17.598a2 2 0 0 0 2.826 2.83"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 19h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 7v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbShape(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "7",
        "x2": "5",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "5",
        "x2": "17",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "19",
        "x2": "17",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "7",
        "x2": "19",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbShareOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "6",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.861 15.896a3 3 0 0 0 4.265 4.22m.578 -3.417a3.012 3.012 0 0 0 -1.507 -1.45"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.7 10.7l1.336 -.688m2.624 -1.352l2.64 -1.36"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.7 13.3l6.6 3.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbShare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "6",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "18",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8.7",
        "y1": "10.7",
        "x2": "15.3",
        "y2": "7.3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8.7",
        "y1": "13.3",
        "x2": "15.3",
        "y2": "16.7"
      }
    }]
  })(props);
}
;
export function TbShieldCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12l2 2l4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
      }
    }]
  })(props);
}
;
export function TbShieldCheckered(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.5 12h17"
      }
    }]
  })(props);
}
;
export function TbShieldChevron(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 14l8 -3l8 3"
      }
    }]
  })(props);
}
;
export function TbShieldLock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "11",
        "r": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "14.5"
      }
    }]
  })(props);
}
;
export function TbShieldOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.669 17.669a12 12 0 0 1 -5.669 3.331a12 12 0 0 1 -8.5 -15c.797 .036 1.589 0 2.366 -.126m3.092 -.912a12 12 0 0 0 3.042 -1.962a12 12 0 0 0 8.5 3a12 12 0 0 1 -1.117 9.379"
      }
    }]
  })(props);
}
;
export function TbShieldX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbShield(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
      }
    }]
  })(props);
}
;
export function TbShip(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18l-1 -5h18l-2 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 13v-6h8l4 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7v-4h-1"
      }
    }]
  })(props);
}
;
export function TbShirtOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.243 4.252l.757 -.252c0 .43 .09 .837 .252 1.206m1.395 1.472a3 3 0 0 0 4.353 -2.678l6 2v5h-3v3m0 4v1a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l2.26 -.753"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbShirt(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0"
      }
    }]
  })(props);
}
;
export function TbShoeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.846 9.868l4.08 .972a4 4 0 0 1 3.074 3.89v2.27m-3 1h-14a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 18v-1a4 4 0 0 0 -4 -4h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12l.663 -1.327"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbShoe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6h5.426a1 1 0 0 1 .863 .496l1.064 1.823a3 3 0 0 0 1.896 1.407l4.677 1.114a4 4 0 0 1 3.074 3.89v2.27a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 13l1 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 18v-1a4 4 0 0 0 -4 -4h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12l1.5 -3"
      }
    }]
  })(props);
}
;
export function TbShoppingCartDiscount(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h-11v-14h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 6l-1 7h-13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10l6 -6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10.5",
        "cy": "4.5",
        "r": ".5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15.5",
        "cy": "9.5",
        "r": ".5"
      }
    }]
  })(props);
}
;
export function TbShoppingCartOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17a2 2 0 1 0 2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h-11v-11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.239 5.231l10.761 .769l-1 7h-2m-4 0h-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbShoppingCartPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h-11v-14h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 5l6.005 .429m7.138 6.573l-.143 .998h-13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6h6m-3 -3v6"
      }
    }]
  })(props);
}
;
export function TbShoppingCartX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h-11v-14h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 5l7.999 .571m5.43 4.43l-.429 2.999h-13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3l-4 4"
      }
    }]
  })(props);
}
;
export function TbShoppingCart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17h-11v-14h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 5l14 1l-1 7h-13"
      }
    }]
  })(props);
}
;
export function TbShovel(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 5.5l-8 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.276 11.284l4.44 4.44a0.968 .968 0 0 1 0 1.369l-2.704 2.704a4.108 4.108 0 0 1 -5.809 -5.81l2.704 -2.703a0.968 .968 0 0 1 1.37 0z"
      }
    }]
  })(props);
}
;
export function TbShredder(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "10",
        "width": "16",
        "height": "5",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 10v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4m5 5v5m4 -5v2m-8 -2v3"
      }
    }]
  })(props);
}
;
export function TbSignLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 21h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 21v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 6v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 6h-10l-2 2.5l2 2.5h10z"
      }
    }]
  })(props);
}
;
export function TbSignRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 21h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 21v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6h10l2 2.5l-2 2.5h-10z"
      }
    }]
  })(props);
}
;
export function TbSignatureOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17c3.333 -3.333 5 -6 5 -8c0 -.394 -.017 -.735 -.05 -1.033m-1.95 -1.967c-1 0 -2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.219 0 .708 -.341 1.231 -.742m3.769 -.258c.303 .245 .64 .677 1 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSignature(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2"
      }
    }]
  })(props);
}
;
export function TbSitemapOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "15",
        "width": "6",
        "height": "6",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 15a2 2 0 0 1 2 2m-.591 3.42c-.362 .358 -.86 .58 -1.409 .58h-2a2 2 0 0 1 -2 -2v-2c0 -.549 .221 -1.046 .579 -1.407"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15v-1a2 2 0 0 1 2 -2h4m4 0a2 2 0 0 1 2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSitemap(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "15",
        "width": "6",
        "height": "6",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "15",
        "y": "15",
        "width": "6",
        "height": "6",
        "rx": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "6",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbSkateboard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "15",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "15",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9a2 1 0 0 0 2 1h14a2 1 0 0 0 2 -1"
      }
    }]
  })(props);
}
;
export function TbSleigh(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19h15a4 4 0 0 0 4 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 15h-9a4 4 0 0 1 -4 -4v-6l1.243 1.243a6 6 0 0 0 4.242 1.757h3.515v2a2 2 0 0 0 2 2h.5a1.5 1.5 0 0 0 1.5 -1.5a1.5 1.5 0 0 1 3 0v1.5a3 3 0 0 1 -3 3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 15v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 15v4"
      }
    }]
  })(props);
}
;
export function TbSlice(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19l15 -15l3 3l-6 6l2 2a14 14 0 0 1 -14 4"
      }
    }]
  })(props);
}
;
export function TbSlideshow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "6",
        "x2": "15.01",
        "y2": "6"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "14",
        "rx": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 13l4 -4a3 5 0 0 1 3 0l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 12l2 -2a3 5 0 0 1 3 0l3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "21",
        "x2": "8.01",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12.01",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "21",
        "x2": "16.01",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbSmartHomeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.097 7.125l-2.037 1.585a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12c.559 0 1.064 -.229 1.427 -.598m.572 -3.417v-5.185c0 -.823 -.38 -1.6 -1.03 -2.105l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-1.029 .8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.332 15.345c-2.213 .976 -5.335 .86 -7.332 -.345"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSmartHome(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 8.71l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-5.334 4.148a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-7.2c0 -.823 -.38 -1.6 -1.03 -2.105"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 15c-2.21 1.333 -5.792 1.333 -8 0"
      }
    }]
  })(props);
}
;
export function TbSmokingNo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "13",
        "x2": "8",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 13h3a1 1 0 0 1 1 1v2c0 .28 -.115 .533 -.3 .714m-3.7 .286h-13a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h9"
      }
    }]
  })(props);
}
;
export function TbSmoking(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "13",
        "width": "18",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "13",
        "x2": "8",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5"
      }
    }]
  })(props);
}
;
export function TbSnowflakeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4l2 1l2 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 2v6m1.196 1.186l1.804 1.034"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.928 6.268l.134 2.232l1.866 1.232"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.66 7l-5.629 3.25l-.031 .75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19.928 14.268l-1.015 .67"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.212 14.226l-2.171 1.262"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 20l-2 -1l-2 1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 22v-6.5l-3 -1.72"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.072 17.732l-.134 -2.232l-1.866 -1.232"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.34 17l5.629 -3.25l-.01 -3.458"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.072 9.732l1.866 -1.232l.134 -2.232"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.34 7l5.629 3.25l.802 -.466"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSnowflake(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
        "transform": "rotate(60 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
        "transform": "rotate(120 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
        "transform": "rotate(180 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
        "transform": "rotate(240 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
        "transform": "rotate(300 12 12)"
      }
    }]
  })(props);
}
;
export function TbSoccerField(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9h3v6h-3z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 9h3v6h-3z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "5",
        "width": "18",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbSocialOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.57 17.602a2 2 0 0 0 2.83 2.827"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.113 11.133a3.001 3.001 0 1 0 3.765 3.715"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.7 17.8l2.8 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.3 17.8l-2.8 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSocial(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "7",
        "x2": "12",
        "y2": "11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6.7",
        "y1": "17.8",
        "x2": "9.5",
        "y2": "15.8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17.3",
        "y1": "17.8",
        "x2": "14.5",
        "y2": "15.8"
      }
    }]
  })(props);
}
;
export function TbSock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 3v6l4.798 5.142a4 4 0 0 1 -5.441 5.86l-6.736 -6.41a2 2 0 0 1 -.621 -1.451v-9.141h8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.895 15.768c.708 -.721 1.105 -1.677 1.105 -2.768a4 4 0 0 0 -4 -4"
      }
    }]
  })(props);
}
;
export function TbSofa(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 11a2 2 0 0 1 2 2v1h12v-1a2 2 0 1 1 4 0v5a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-5a2 2 0 0 1 2 -2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 11v-3a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v9"
      }
    }]
  })(props);
}
;
export function TbSortAscending2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 9l3 -3l3 3"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "5",
        "width": "5",
        "height": "5",
        "rx": ".5"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "14",
        "width": "5",
        "height": "5",
        "rx": ".5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 6v12"
      }
    }]
  })(props);
}
;
export function TbSortAscendingLetters(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 21h-4l4 -7h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 6v12"
      }
    }]
  })(props);
}
;
export function TbSortAscendingNumbers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "16",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 16v3a2 2 0 0 1 -2 2h-1.5"
      }
    }]
  })(props);
}
;
export function TbSortAscending(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "11",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "11",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "18",
        "x2": "13",
        "y2": "18"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 9 18 6 21 9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "6",
        "x2": "18",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbSortDescending2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "5",
        "width": "5",
        "height": "5",
        "rx": ".5"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "5",
        "y": "14",
        "width": "5",
        "height": "5",
        "rx": ".5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 18v-12"
      }
    }]
  })(props);
}
;
export function TbSortDescendingLetters(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 21v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 10h-4l4 -7h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 6v12"
      }
    }]
  })(props);
}
;
export function TbSortDescendingNumbers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15l3 3l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 6v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 14a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5v3a2 2 0 0 1 -2 2h-1.5"
      }
    }]
  })(props);
}
;
export function TbSortDescending(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "13",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "11",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "18",
        "x2": "11",
        "y2": "18"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 15 18 18 21 15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "6",
        "x2": "18",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbSoup(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19h18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11h18a8 8 0 0 1 -8 8h-2a8 8 0 0 1 -8 -8z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 8v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5v3"
      }
    }]
  })(props);
}
;
export function TbSpaceOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 10v3a1 1 0 0 0 1 1h9m4 0h1a1 1 0 0 0 1 -1v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSpace(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3"
      }
    }]
  })(props);
}
;
export function TbSpacingHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 20h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8v8"
      }
    }]
  })(props);
}
;
export function TbSpacingVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20v-2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12h-8"
      }
    }]
  })(props);
}
;
export function TbSpade(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3l4.919 4.5c.61 .587 1.177 1.177 1.703 1.771a5.527 5.527 0 0 1 .264 6.979c-1.18 1.56 -3.338 1.92 -4.886 .75v1l1 3h-6l1 -3v-1c-1.54 1.07 -3.735 .772 -4.886 -.75a5.527 5.527 0 0 1 .264 -6.979a30.883 30.883 0 0 1 1.703 -1.771a1541.72 1541.72 0 0 1 4.919 -4.5z"
      }
    }]
  })(props);
}
;
export function TbSpeakerphone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 8a3 3 0 0 1 0 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8h0l4.524 -3.77a0.9 .9 0 0 1 1.476 .692v12.156a0.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8"
      }
    }]
  })(props);
}
;
export function TbSpeedboat(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17h13.4a3 3 0 0 0 2.5 -1.34l3.1 -4.66h0h-6.23a4 4 0 0 0 -1.49 .29l-3.56 1.42a4 4 0 0 1 -1.49 .29h-3.73h0h-1l-1.5 4z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "13",
        "x2": "7.5",
        "y2": "8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8h8l2 3"
      }
    }]
  })(props);
}
;
export function TbSportBillard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "10",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "8"
      }
    }]
  })(props);
}
;
export function TbSquare0(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquare1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 16v-8l-2 2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquare2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquare3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12a2 2 0 1 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14a2 2 0 1 0 2 -2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquare4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 16v-8l-4 6h5"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquare5(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquare6(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "transform": "rotate(180 12 14)",
        "cx": "12",
        "cy": "14",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10a2 2 0 1 0 -4 0v4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquare7(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 8h4l-2 8"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquare8(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "10",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "14",
        "r": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquare9(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "10",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14a2 2 0 1 0 4 0v-4"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquareAsterisk(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8.5v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 10l6 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 14l6 -4"
      }
    }]
  })(props);
}
;
export function TbSquareCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12l2 2l4 -4"
      }
    }]
  })(props);
}
;
export function TbSquareDot(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbSquareForbid2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "15",
        "x2": "15",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbSquareForbid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "9",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbSquareHalf(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 4v16"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13l7.5 -7.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18l8 -8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 20l5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8l4 -4"
      }
    }]
  })(props);
}
;
export function TbSquareMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbSquareOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h10a2 2 0 0 1 2 2v10m-.584 3.412a1.994 1.994 0 0 1 -1.416 .588h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.052 .586 -1.414"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSquarePlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "12",
        "x2": "15",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbSquareRoot2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 12h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 19c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h1l3 8l3 -16h10"
      }
    }]
  })(props);
}
;
export function TbSquareRoot(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h2l4 8l4 -16h8"
      }
    }]
  })(props);
}
;
export function TbSquareRotatedForbid2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 9.5l5 5"
      }
    }]
  })(props);
}
;
export function TbSquareRotatedForbid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.5 14.5l5 -5"
      }
    }]
  })(props);
}
;
export function TbSquareRotatedOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.964 16.952l-3.462 3.461c-.782 .783 -2.222 .783 -3.004 0l-6.911 -6.91c-.783 -.783 -.783 -2.223 0 -3.005l3.455 -3.456m2.003 -2.003l1.453 -1.452c.782 -.783 2.222 -.783 3.004 0l6.911 6.91c.783 .783 .783 2.223 0 3.005l-1.448 1.45"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSquareRotated(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
      }
    }]
  })(props);
}
;
export function TbSquareToggleHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12h-20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 14v-8a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20a2 2 0 0 0 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18a2 2 0 0 0 2 2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "20",
        "x2": "10",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbSquareToggle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "2",
        "x2": "12",
        "y2": "22"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 6a2 2 0 0 0 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20a2 2 0 0 0 2 -2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "10",
        "x2": "20",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbSquareX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbSquaresDiagonal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "8",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.586 19.414l10.827 -10.827"
      }
    }]
  })(props);
}
;
export function TbSquaresFilled(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "8",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 14.5l6.492 -6.492"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.496 20.004l6.504 -6.504l-6.504 6.504z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.586 19.414l10.827 -10.827"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
      }
    }]
  })(props);
}
;
export function TbStack2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 4 4 8 12 12 20 8 12 4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "4 12 12 16 20 12"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "4 16 12 20 20 16"
      }
    }]
  })(props);
}
;
export function TbStack3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 2l-8 4l8 4l8 -4l-8 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 10l8 4l8 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18l8 4l8 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 14l8 4l8 -4"
      }
    }]
  })(props);
}
;
export function TbStack(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6l-8 4l8 4l8 -4l-8 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 14l8 4l8 -4"
      }
    }]
  })(props);
}
;
export function TbStairsDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20h4v-4h4v-4h4v-4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 4l-7 7v-4m4 4h-4"
      }
    }]
  })(props);
}
;
export function TbStairsUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20h4v-4h4v-4h4v-4h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 11l7 -7v4m-4 -4h4"
      }
    }]
  })(props);
}
;
export function TbStairs(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18h4v-4h4v-4h4v-4h4"
      }
    }]
  })(props);
}
;
export function TbStarHalf(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253z"
      }
    }]
  })(props);
}
;
export function TbStarOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.012 6.016l1.981 -4.014l3.086 6.253l6.9 1l-4.421 4.304m.012 4.01l.588 3.426l-6.158 -3.245l-6.172 3.245l1.179 -6.873l-5 -4.867l6.327 -.917"
      }
    }]
  })(props);
}
;
export function TbStar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
      }
    }]
  })(props);
}
;
export function TbStars(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.8 19.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.2 19.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
      }
    }]
  })(props);
}
;
export function TbSteeringWheel(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "12",
        "x2": "3.25",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "12",
        "x2": "20.75",
        "y2": "10"
      }
    }]
  })(props);
}
;
export function TbStepInto(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "11",
        "x2": "12",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "11",
        "x2": "12",
        "y2": "15"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "20",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbStepOut(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "7",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "7",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "20",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbStethoscope(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 4h-1a2 2 0 0 0 -2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 15a6 6 0 1 0 12 0v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 3v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 3v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "20",
        "cy": "10",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbSticker(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12l-2 .5a6 6 0 0 1 -6.5 -6.5l.5 -2l8 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12a8 8 0 1 1 -8 -8"
      }
    }]
  })(props);
}
;
export function TbStrikethrough(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 6.5a4 2 0 0 0 -4 -1.5h-1a3.5 3.5 0 0 0 0 7h2a3.5 3.5 0 0 1 0 7h-1.5a4 2 0 0 1 -4 -1.5"
      }
    }]
  })(props);
}
;
export function TbSubmarine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11v6h2l1 -1.5l3 1.5h10a3 3 0 0 0 0 -6h-10h0l-3 1.5l-1 -1.5h-2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 11l-1 -3h-5l-1 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 8v-2a1 1 0 0 1 1 -1h1"
      }
    }]
  })(props);
}
;
export function TbSubscript(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7l8 10m-8 0l8 -10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"
      }
    }]
  })(props);
}
;
export function TbSubtask(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "9",
        "x2": "12",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "5",
        "x2": "8",
        "y2": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 5v11a1 1 0 0 0 1 1h5"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "12",
        "y": "7",
        "width": "8",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "12",
        "y": "15",
        "width": "8",
        "height": "4",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbSumOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 18a1 1 0 0 1 -1 1h-11l6 -7m-3 -7h8a1 1 0 0 1 1 1v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSum(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 16v2a1 1 0 0 1 -1 1h-11l6 -7l-6 -7h11a1 1 0 0 1 1 1v2"
      }
    }]
  })(props);
}
;
export function TbSunOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12a4 4 0 0 0 -4 -4m-2.834 1.177a4 4 0 0 0 5.66 5.654"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
      }
    }]
  })(props);
}
;
export function TbSun(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
      }
    }]
  })(props);
}
;
export function TbSunrise(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 9v-6l3 3m-6 0l3 -3"
      }
    }]
  })(props);
}
;
export function TbSunset(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "21",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v6l3 -3m-6 0l3 3"
      }
    }]
  })(props);
}
;
export function TbSuperscript(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7l8 10m-8 0l8 -10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"
      }
    }]
  })(props);
}
;
export function TbSwimming(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "9",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 11l4 -2l3.5 3l-1.5 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 16.75a2.4 2.4 0 0 0 1 .25a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 1 -.25"
      }
    }]
  })(props);
}
;
export function TbSwitch2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17h5l1.67 -2.386m3.66 -5.227l1.67 -2.387h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7h5l7 10h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20l3 -3l-3 -3"
      }
    }]
  })(props);
}
;
export function TbSwitch3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17h2.397a5 5 0 0 0 4.096 -2.133l.177 -.253m3.66 -5.227l.177 -.254a5 5 0 0 1 4.096 -2.133h3.397"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 4l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 7h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 20l3 -3l-3 -3"
      }
    }]
  })(props);
}
;
export function TbSwitchHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 3 20 7 16 11"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "7",
        "x2": "20",
        "y2": "7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "8 13 4 17 8 21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "17",
        "x2": "13",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbSwitchVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "3 8 7 4 11 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "4",
        "x2": "7",
        "y2": "13"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "13 16 17 20 21 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "10",
        "x2": "17",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbSwitch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 4 19 4 19 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.75",
        "y1": "9.25",
        "x2": "19",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "19",
        "x2": "9",
        "y2": "15"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 19 19 19 19 15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "5",
        "x2": "19",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbSwordOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.934 7.942l3.066 -3.942h5v5l-3.93 3.057m-2.253 1.752l-2.817 2.191l-4 4l-3 -3l4 -4l2.174 -2.795"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 11.5l6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbSword(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 11.5l6 6"
      }
    }]
  })(props);
}
;
export function TbSwords(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 3v5l-11 9l-4 4l-3 -3l4 -4l9 -11z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 13l6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.32 17.32l3.68 3.68l3 -3l-3.365 -3.365"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5.5l-2 -2.5h-5v5l3 2.5"
      }
    }]
  })(props);
}
;
export function TbTableExport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 20h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7.5m-16 -3.5h16m-10 -6v16m4 -1h7m-3 -3l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbTableImport(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 13.5v-7.5a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6m-8 -10h16m-10 -6v11.5m-8 3.5h7m-3 -3l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbTableOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h10a2 2 0 0 1 2 2v10m-.588 3.417c-.362 .36 -.86 .583 -1.412 .583h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.053 .586 -1.414"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 10h6m4 0h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 4v2m0 4v10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbTable(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "10",
        "x2": "20",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "4",
        "x2": "10",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbTagOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.792 7.793a1 1 0 0 0 1.414 1.414"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.88 4.877a2.99 2.99 0 0 0 -.88 2.123v3.859c0 .537 .213 1.052 .593 1.432l8.116 8.116a2.025 2.025 0 0 0 2.864 0l2.416 -2.416m2.002 -2.002l.416 -.416a2.025 2.025 0 0 0 0 -2.864l-8.117 -8.116a2.025 2.025 0 0 0 -1.431 -.593h-2.859"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTag(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "8.5",
        "r": "1",
        "fill": "currentColor"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7v3.859c0 .537 .213 1.052 .593 1.432l8.116 8.116a2.025 2.025 0 0 0 2.864 0l4.834 -4.834a2.025 2.025 0 0 0 0 -2.864l-8.117 -8.116a2.025 2.025 0 0 0 -1.431 -.593h-3.859a3 3 0 0 0 -3 3z"
      }
    }]
  })(props);
}
;
export function TbTagsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 6h-.975a2.025 2.025 0 0 0 -2.025 2.025v2.834c0 .537 .213 1.052 .593 1.432l6.116 6.116a2.025 2.025 0 0 0 2.864 0l2.834 -2.834c.028 -.028 .055 -.056 .08 -.085"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.573 18.407l.418 -.418m1.997 -1.997l.419 -.419a2.025 2.025 0 0 0 0 -2.864l-7.117 -7.116"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9h-.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTags(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.859 6h-2.834a2.025 2.025 0 0 0 -2.025 2.025v2.834c0 .537 .213 1.052 .593 1.432l6.116 6.116a2.025 2.025 0 0 0 2.864 0l2.834 -2.834a2.025 2.025 0 0 0 0 -2.864l-6.117 -6.116a2.025 2.025 0 0 0 -1.431 -.593z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.573 18.407l2.834 -2.834a2.025 2.025 0 0 0 0 -2.864l-7.117 -7.116"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 9h-.01"
      }
    }]
  })(props);
}
;
export function TbTallymark1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbTallymark2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "5",
        "x2": "10",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "5",
        "x2": "14",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbTallymark3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "5",
        "x2": "8",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "5",
        "x2": "16",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbTallymark4(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "5",
        "x2": "6",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "5",
        "x2": "10",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "5",
        "x2": "14",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "5",
        "x2": "18",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbTallymarks(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "5",
        "x2": "6",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "5",
        "x2": "10",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "5",
        "x2": "14",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "5",
        "x2": "18",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "17",
        "x2": "21",
        "y2": "7"
      }
    }]
  })(props);
}
;
export function TbTank(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "12",
        "width": "18",
        "height": "6",
        "rx": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12l1 -5h5l3 5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "9",
        "x2": "13.2",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbTargetOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.286 11.3a1 1 0 0 0 1.41 1.419"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.44 8.49a5 5 0 0 0 7.098 7.044m1.377 -2.611a5 5 0 0 0 -5.846 -5.836"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.649 5.623a9 9 0 1 0 12.698 12.758m1.683 -2.313a9 9 0 0 0 -12.076 -12.11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTarget(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }]
  })(props);
}
;
export function TbTelescopeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21.002l6 -5l6 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13.002v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.238 8.264l-4.183 2.51c-1.02 .614 -1.357 1.898 -.76 2.906l.165 .28c.52 .88 1.624 1.266 2.605 .91l6.457 -2.34m2.907 -1.055l4.878 -1.77a1.023 1.023 0 0 0 .565 -1.455l-2.62 -4.705a1.087 1.087 0 0 0 -1.447 -.42l-.056 .032l-6.016 3.61"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 5.002l3 5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTelescope(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21l6 -5l6 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.294 13.678l.166 .281c.52 .88 1.624 1.265 2.605 .91l14.242 -5.165a1.023 1.023 0 0 0 .565 -1.456l-2.62 -4.705a1.087 1.087 0 0 0 -1.447 -.42l-.056 .032l-12.694 7.618c-1.02 .613 -1.357 1.897 -.76 2.905z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 5l3 5.5"
      }
    }]
  })(props);
}
;
export function TbTemperatureCelsius(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "8",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 9a3 3 0 0 0 -3 -3h-1a3 3 0 0 0 -3 3v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3 -3"
      }
    }]
  })(props);
}
;
export function TbTemperatureFahrenheit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "8",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "12",
        "x2": "18",
        "y2": "12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 6h-6a1 1 0 0 0 -1 1v11"
      }
    }]
  })(props);
}
;
export function TbTemperatureMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "9",
        "x2": "12",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "9",
        "x2": "22",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbTemperatureOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10v3.5a4 4 0 1 0 5.836 2.33m-1.836 -5.83v-5a2 2 0 1 0 -4 0v1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 9h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTemperaturePlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "9",
        "x2": "12",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "9",
        "x2": "22",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "6",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbTemperature(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "9",
        "x2": "14",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbTemplateOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4h11a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-7m-4 0h-3a1 1 0 0 1 -1 -1v-2c0 -.271 .108 -.517 .283 -.697"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "12",
        "width": "6",
        "height": "8",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 16h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 20h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTemplate(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "12",
        "width": "6",
        "height": "8",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "16",
        "x2": "20",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "20",
        "x2": "20",
        "y2": "20"
      }
    }]
  })(props);
}
;
export function TbTent(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 14l4 6h6l-9 -16l-9 16h6l4 -6"
      }
    }]
  })(props);
}
;
export function TbTerminal2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 9l3 3l-3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "15",
        "x2": "16",
        "y2": "15"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "16",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbTerminal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7l5 5l-5 5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "19",
        "x2": "19",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbTestPipe2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3v15a3 3 0 0 1 -6 0v-15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 12h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 3h8"
      }
    }]
  })(props);
}
;
export function TbTestPipeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8.04a803.533 803.533 0 0 0 -4 3.96m-2 2c-1.085 1.085 -3.125 3.14 -6.122 6.164a2.857 2.857 0 0 1 -4.041 -4.04c3.018 -2.996 5.073 -5.037 6.163 -6.124m2 -2c.872 -.872 2.191 -2.205 3.959 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 13h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 15l1.5 1.6m-.74 3.173a2 2 0 0 1 -2.612 -2.608"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3l6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTestPipe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 8.04l-12.122 12.124a2.857 2.857 0 1 1 -4.041 -4.04l12.122 -12.124"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 13h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 15l1.5 1.6a2 2 0 1 1 -3 0l1.5 -1.6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3l6 6"
      }
    }]
  })(props);
}
;
export function TbTextDirectionLtr(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19h14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 21l2 -2l-2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15v-11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 15v-11"
      }
    }]
  })(props);
}
;
export function TbTextDirectionRtl(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 15v-11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 15v-11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19h14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 21l-2 -2l2 -2"
      }
    }]
  })(props);
}
;
export function TbTextResize(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 5h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 19h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 7v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14v-4"
      }
    }]
  })(props);
}
;
export function TbTextWrapDisabled(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "14",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "18",
        "x2": "14",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h17l-3 -3m0 6l3 -3"
      }
    }]
  })(props);
}
;
export function TbTextWrap(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "6",
        "x2": "20",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "18",
        "x2": "9",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2"
      }
    }]
  })(props);
}
;
export function TbThermometer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5a2.828 2.828 0 0 1 0 4l-8 8h-4v-4l8 -8a2.828 2.828 0 0 1 4 0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7l-1.5 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 10l-1.5 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13l-1.5 -1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 17l-3 3"
      }
    }]
  })(props);
}
;
export function TbThumbDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 13v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 0 0 4 0v-5h3a2 2 0 0 0 2 -2l-1 -5a2 3 0 0 0 -2 -2h-7a3 3 0 0 0 -3 3"
      }
    }]
  })(props);
}
;
export function TbThumbUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3"
      }
    }]
  })(props);
}
;
export function TbTicketOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 5v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 17v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h10a2 2 0 0 1 2 2v3a2 2 0 1 0 0 4v3m-2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 1 0 0 -4v-3a2 2 0 0 1 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTicket(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "5",
        "x2": "15",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "11",
        "x2": "15",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "17",
        "x2": "15",
        "y2": "19"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2"
      }
    }]
  })(props);
}
;
export function TbTie(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 22l4 -4l-2.5 -11l.993 -2.649a1 1 0 0 0 -.936 -1.351h-3.114a1 1 0 0 0 -.936 1.351l.993 2.649l-2.5 11l4 4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 7h3l5 5.5"
      }
    }]
  })(props);
}
;
export function TbTiltShiftOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.56 3.69a9 9 0 0 0 -.577 .263"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.56 20.31a9 9 0 0 0 3.44 .69"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.57 10.602a2 2 0 0 0 2.862 2.795"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTiltShift(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.56 20.31a9 9 0 0 0 3.44 .69"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbTimeline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16l6 -7l5 5l5 -6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "14",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "9",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "4",
        "cy": "16",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "20",
        "cy": "8",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbTir(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18h8m4 0h2v-6a5 7 0 0 0 -5 -7h-1l1.5 7h4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 18v-13h3"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "3 17 3 12 12 12"
      }
    }]
  })(props);
}
;
export function TbToggleLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "6",
        "width": "20",
        "height": "12",
        "rx": "6"
      }
    }]
  })(props);
}
;
export function TbToggleRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "12",
        "r": "2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "2",
        "y": "6",
        "width": "20",
        "height": "12",
        "rx": "6"
      }
    }]
  })(props);
}
;
export function TbToiletPaperOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.27 4.28c-.768 1.27 -1.27 3.359 -1.27 5.72c0 3.866 1.343 7 3 7s3 -3.134 3 -7c0 -.34 -.01 -.672 -.03 -.999"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10c0 -3.866 -1.343 -7 -3 -7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10v7m-1.513 2.496l-1.487 -.496l-3 2l-3 -3l-3 2v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10h.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbToiletPaper(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "6",
        "cy": "10",
        "rx": "3",
        "ry": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10c0 -3.866 -1.343 -7 -3 -7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 3h12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 10v10l-3 -1l-3 2l-3 -3l-3 2v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 10h.01"
      }
    }]
  })(props);
}
;
export function TbTool(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"
      }
    }]
  })(props);
}
;
export function TbToolsKitchen2Off(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.386 10.409c.53 -2.28 1.766 -4.692 4.614 -7.409v12m-4 0h-1c-.002 -.313 -.002 -.627 .002 -.941"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 19v2h-1v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8v13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 5v2a3 3 0 0 0 4.546 2.572m1.454 -2.572v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbToolsKitchen2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12zm0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3"
      }
    }]
  })(props);
}
;
export function TbToolsKitchenOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 3h5l-.5 4.5m-.4 3.595l-.1 .905h-6l-.875 -7.874"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18h2v3h-2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.225 11.216c.42 -2.518 1.589 -5.177 4.775 -8.216v12h-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 15v1m0 4v1h-1v-2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbToolsKitchen(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 3h8l-1 9h-6z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18h2v3h-2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 3v12h-5c-.023 -3.681 .184 -7.406 5 -12z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 15v6h-1v-3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "8",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbToolsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12l4 -4a2.828 2.828 0 1 0 -4 -4l-4 4m-2 2l-7 7v4h4l7 -7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.5 5.5l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8l-5 -5m-2.004 2.004l-1.996 1.996l5 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 8l-1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12l5 5m-2 2l-2 2l-5 -5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 17l-1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTools(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.5",
        "y1": "5.5",
        "x2": "18.5",
        "y2": "9.5"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 8 7 3 3 7 8 12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "8",
        "x2": "5.5",
        "y2": "9.5"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 12 21 17 17 21 12 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "17",
        "x2": "14.5",
        "y2": "18.5"
      }
    }]
  })(props);
}
;
export function TbTornado(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "4",
        "x2": "3",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "16",
        "x2": "7",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "11",
        "y1": "20",
        "x2": "15",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "8",
        "x2": "20",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "12",
        "x2": "16",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbTournament(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 14h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 7h4a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "12",
        "x2": "20",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbTrack(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 15l11 -11m5 5l-11 11m-4 -8l7 7m-3.5 -10.5l7 7m-3.5 -10.5l7 7"
      }
    }]
  })(props);
}
;
export function TbTractor(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "15",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "15",
        "x2": "7",
        "y2": "15.01"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10.5",
        "y1": "17",
        "x2": "17",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 15.2v-4.2a1 1 0 0 0 -1 -1h-6l-2 -5h-6v6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 5h-1a1 1 0 0 0 -1 1v4"
      }
    }]
  })(props);
}
;
export function TbTrademark(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.5 9h5m-2.5 0v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 15v-6l3 4l3 -4v6"
      }
    }]
  })(props);
}
;
export function TbTrafficConeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.4 10h.6m4 0h.6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.8 15h7.2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20l3.5 -10.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 6.5l.5 -1.5h2l2 6m2 6l1 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTrafficCone(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "20",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9.4",
        "y1": "10",
        "x2": "14.6",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7.8",
        "y1": "15",
        "x2": "16.2",
        "y2": "15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 20l5 -15h2l5 15"
      }
    }]
  })(props);
}
;
export function TbTrafficLightsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 4c.912 -1.219 2.36 -2 4 -2a5 5 0 0 1 5 5v6m0 4a5 5 0 0 1 -10 0v-10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8a1 1 0 1 0 -1 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.291 11.295a1 1 0 0 0 1.418 1.41"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "17",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTrafficLights(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "7",
        "y": "2",
        "width": "10",
        "height": "20",
        "rx": "5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "17",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbTrain(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 13c0 -3.87 -3.37 -7 -10 -7h-8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 15h16a2 2 0 0 0 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6v5h17.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "3",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "11",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "11",
        "x2": "13",
        "y2": "6.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "19",
        "x2": "21",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbTransferIn(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 18v3h16v-14l-8 -4l-8 4v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 14h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 11l3 3l-3 3"
      }
    }]
  })(props);
}
;
export function TbTransferOut(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 19v2h16v-14l-8 -4l-8 4v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 14h-9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11l-3 3l3 3"
      }
    }]
  })(props);
}
;
export function TbTrashOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7h3m4 0h9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "11",
        "x2": "10",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "14",
        "x2": "14",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l.077 -.923"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18.384",
        "y1": "14.373",
        "x2": "19",
        "y2": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
      }
    }]
  })(props);
}
;
export function TbTrashX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 7h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbTrash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "7",
        "x2": "20",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "11",
        "x2": "10",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "11",
        "x2": "14",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
      }
    }]
  })(props);
}
;
export function TbTree(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 13l-2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12l2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.824 15.995a3 3 0 0 1 -2.743 -3.69a2.998 2.998 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a2.997 2.997 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z"
      }
    }]
  })(props);
}
;
export function TbTrees(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 5l3 3l-2 1l4 4l-3 1l4 4h-9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "21",
        "x2": "15",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 13l-2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12l2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 21v-13"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.824 15.995a3 3 0 0 1 -2.743 -3.69a2.998 2.998 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a2.997 2.997 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z"
      }
    }]
  })(props);
}
;
export function TbTrendingDown2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6h5l7 10h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19l3 -3l-3 -3"
      }
    }]
  })(props);
}
;
export function TbTrendingDown3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19l3 -3l-3 -3"
      }
    }]
  })(props);
}
;
export function TbTrendingDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "3 7 9 13 13 9 21 17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "21 10 21 17 14 17"
      }
    }]
  })(props);
}
;
export function TbTrendingUp2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 5l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h5l7 -10h6"
      }
    }]
  })(props);
}
;
export function TbTrendingUp3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 5l3 3l-3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18h2.397a5 5 0 0 0 4.096 -2.133l4.014 -5.734a5 5 0 0 1 4.096 -2.133h3.397"
      }
    }]
  })(props);
}
;
export function TbTrendingUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "3 17 9 11 13 15 21 7"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "14 7 21 7 21 14"
      }
    }]
  })(props);
}
;
export function TbTriangleInverted(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4h14a2 2 0 0 1 1.84 2.75l-7.1 12.25a2 2 0 0 1 -3.5 0l-7.1 -12.25a2 2 0 0 1 1.75 -2.75"
      }
    }]
  })(props);
}
;
export function TbTriangleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19h14m1.986 -2.014a2 2 0 0 0 -.146 -.736l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.825 1.424m-1.467 2.53l-4.808 8.296a2 2 0 0 0 1.75 2.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTriangleSquareCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3l-4 7h8z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "3"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "14",
        "width": "6",
        "height": "6",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbTriangle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
      }
    }]
  })(props);
}
;
export function TbTriangles(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.974 21h8.052a0.975 .975 0 0 0 .81 -1.517l-4.025 -6.048a0.973 .973 0 0 0 -1.622 0l-4.025 6.048a0.977 .977 0 0 0 .81 1.517z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.98 16h14.04c.542 0 .98 -.443 .98 -.989a0.995 .995 0 0 0 -.156 -.534l-7.02 -11.023a0.974 .974 0 0 0 -1.648 0l-7.02 11.023a0.994 .994 0 0 0 .294 1.366a0.973 .973 0 0 0 .53 .157z"
      }
    }]
  })(props);
}
;
export function TbTrident(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6l2 -2v3a7 7 0 0 0 14 0v-3l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-18l-2 2m4 0l-2 -2"
      }
    }]
  })(props);
}
;
export function TbTrophy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "21",
        "x2": "16",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "4",
        "x2": "17",
        "y2": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 4v8a5 5 0 0 1 -10 0v-8"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "5",
        "cy": "9",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "9",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbTruckDelivery(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "9",
        "x2": "7",
        "y2": "9"
      }
    }]
  })(props);
}
;
export function TbTruckLoading(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M2 3h1a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2h15"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "6",
        "width": "10",
        "height": "8",
        "rx": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "19",
        "r": "2"
      }
    }]
  })(props);
}
;
export function TbTruckOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.585 15.586a2 2 0 0 0 2.826 2.831"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h1m3.96 0h4.04v4m0 4v4m-4 0h6m6 0v-6h-6m-2 -5h5l3 5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbTruckReturn(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h9v6h-5l2 2m0 -4l-2 2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "17",
        "x2": "15",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 6h5l3 5v6h-2"
      }
    }]
  })(props);
}
;
export function TbTruck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
      }
    }]
  })(props);
}
;
export function TbTypographyOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20h3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 20h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.9 15h6.9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 13l3 7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 20l4.09 -10.906"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.181 6.183l.819 -2.183h2l3.904 8.924"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbTypography(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "7",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "20",
        "x2": "21",
        "y2": "20"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6.9",
        "y1": "15",
        "x2": "13.8",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10.2",
        "y1": "6.3",
        "x2": "16",
        "y2": "20"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "5 20 11 4 13 4 20 20"
      }
    }]
  })(props);
}
;
export function TbUmbrellaOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12h-8c0 -2.209 .895 -4.208 2.342 -5.656m2.382 -1.645a8 8 0 0 1 11.276 7.301l-4 .001"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v6a2 2 0 1 0 4 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbUmbrella(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 12a8 8 0 0 1 16 0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v6a2 2 0 0 0 4 0"
      }
    }]
  })(props);
}
;
export function TbUnderline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 5v5a5 5 0 0 0 10 0v-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 19h14"
      }
    }]
  })(props);
}
;
export function TbUnlink(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "21",
        "x2": "16",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "16",
        "x2": "21",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "8",
        "x2": "5",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "3",
        "x2": "8",
        "y2": "5"
      }
    }]
  })(props);
}
;
export function TbUpload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 9 12 4 17 9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "4",
        "x2": "12",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbUrgent(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16v-4a4 4 0 0 1 8 0v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "6",
        "y": "16",
        "width": "12",
        "height": "4",
        "rx": "1"
      }
    }]
  })(props);
}
;
export function TbUsb(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 17v-11.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 10v3l5 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 14.5l5 -2v-2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 10h2v-2h-2z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "7",
        "cy": "9",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5.5h4l-2 -2.5z"
      }
    }]
  })(props);
}
;
export function TbUserCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 11l2 2l4 -4"
      }
    }]
  })(props);
}
;
export function TbUserCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "10",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"
      }
    }]
  })(props);
}
;
export function TbUserExclamation(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "7",
        "x2": "19",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "14",
        "x2": "19",
        "y2": "14.01"
      }
    }]
  })(props);
}
;
export function TbUserMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "11",
        "x2": "22",
        "y2": "11"
      }
    }]
  })(props);
}
;
export function TbUserOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.274 10.291a4 4 0 1 0 -5.554 -5.58m-.548 3.453a4.01 4.01 0 0 0 2.62 2.65"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 1.147 .167m2.685 2.681a4 4 0 0 1 .168 1.152v2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbUserPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 11h6m-3 -3v6"
      }
    }]
  })(props);
}
;
export function TbUserSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21v-2a4 4 0 0 1 4 -4h1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16.5",
        "cy": "17.5",
        "r": "2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 19.5l2.5 2.5"
      }
    }]
  })(props);
}
;
export function TbUserX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 9l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbUser(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
      }
    }]
  })(props);
}
;
export function TbUsers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3.13a4 4 0 0 1 0 7.75"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 21v-2a4 4 0 0 0 -3 -3.85"
      }
    }]
  })(props);
}
;
export function TbVaccineBottle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "3",
        "width": "6",
        "height": "3",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6v.98c0 .877 -.634 1.626 -1.5 1.77c-.866 .144 -1.5 .893 -1.5 1.77v8.48a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-8.48c0 -.877 -.634 -1.626 -1.5 -1.77a1.795 1.795 0 0 1 -1.5 -1.77v-.98"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 12h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 18h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 15h2"
      }
    }]
  })(props);
}
;
export function TbVaccineOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5l-4.5 4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 6.5l6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 11.5l-.5 .5m-2 2l-4 4h-4v-4l4 -4m2 -2l.5 -.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 12.5l1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbVaccine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 3l4 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 5l-4.5 4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 6.5l6 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.5 11.5l-6.5 6.5h-4v-4l6.5 -6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7.5 12.5l1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 9.5l1.5 1.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21l3 -3"
      }
    }]
  })(props);
}
;
export function TbVariableOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.675 4.68c-2.17 4.776 -2.062 9.592 .325 15.32"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 4c1.959 3.917 2.383 7.834 1.272 12.232m-.983 3.051c-.093 .238 -.189 .477 -.289 .717"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.696 11.696c.095 .257 .2 .533 .32 .831c.984 2.473 .984 3.473 1.984 3.473h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16c1.5 0 3 -2 4 -3.5m2.022 -2.514c.629 -.582 1.304 -.986 1.978 -.986"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbVariable(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 4c-2.5 5 -2.5 10 0 16m14 -16c2.5 5 2.5 10 0 16m-10 -11h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
      }
    }]
  })(props);
}
;
export function TbVectorBezier2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "17",
        "y": "17",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "5",
        "x2": "14",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "19",
        "x2": "17",
        "y2": "19"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "19",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 5.5a5 6.5 0 0 1 5 6.5a5 6.5 0 0 0 5 6.5"
      }
    }]
  })(props);
}
;
export function TbVectorBezier(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "14",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "17",
        "y": "14",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "6",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 8.5a6 6 0 0 0 -5 5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 8.5a6 6 0 0 1 5 5.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "8",
        "x2": "4",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "8",
        "x2": "14",
        "y2": "8"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "3",
        "cy": "8",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "21",
        "cy": "8",
        "r": "1"
      }
    }]
  })(props);
}
;
export function TbVectorOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.68 6.733a0.996 .996 0 0 1 -.68 .267h-2a1 1 0 0 1 -1 -1v-2c0 -.276 .112 -.527 .293 -.708"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "17",
        "y": "3",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.72 20.693a0.997 .997 0 0 1 -.72 .307h-2a1 1 0 0 1 -1 -1v-2c0 -.282 .116 -.536 .304 -.718"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "17",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 7v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 7v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 5h8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 19h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbVectorTriangleOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6v-1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "17",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.705 20.709a0.997 .997 0 0 1 -.705 .291h-2a1 1 0 0 1 -1 -1v-2c0 -.28 .115 -.532 .3 -.714"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 17.1l3.749 -6.823"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13.158 9.197l-.658 -1.197"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 19h10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbVectorTriangle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "4",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "17",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "17",
        "y": "17",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6.5",
        "y1": "17.1",
        "x2": "11.5",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17.5",
        "y1": "17.1",
        "x2": "12.5",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "19",
        "x2": "17",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbVector(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "17",
        "y": "3",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "17",
        "y": "17",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "17",
        "width": "4",
        "height": "4",
        "rx": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "7",
        "x2": "5",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "7",
        "x2": "19",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "5",
        "x2": "17",
        "y2": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "19",
        "x2": "17",
        "y2": "19"
      }
    }]
  })(props);
}
;
export function TbVenus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "9",
        "r": "5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "14",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "18",
        "x2": "15",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbVersionsOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.184 6.162a2 2 0 0 1 1.816 -1.162h6a2 2 0 0 1 2 2v9m-1.185 2.827a1.993 1.993 0 0 1 -.815 .173h-6a2 2 0 0 1 -2 -2v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7v10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8v8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbVersions(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "10",
        "y": "5",
        "width": "10",
        "height": "14",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "7",
        "x2": "7",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "8",
        "x2": "4",
        "y2": "16"
      }
    }]
  })(props);
}
;
export function TbVideoMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "6",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "12",
        "x2": "11",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbVideoOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 11v-1l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -.675 .946"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h3a2 2 0 0 1 2 2v3m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
      }
    }]
  })(props);
}
;
export function TbVideoPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "6",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "12",
        "x2": "11",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "10",
        "x2": "9",
        "y2": "14"
      }
    }]
  })(props);
}
;
export function TbVideo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "6",
        "width": "12",
        "height": "12",
        "rx": "2"
      }
    }]
  })(props);
}
;
export function TbView360Off(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.335 8.388a18.998 18.998 0 0 0 -.335 3.612c0 4.97 1.79 9 4 9c1.622 0 3.018 -2.172 3.646 -5.294m.354 -3.706c0 -4.97 -1.79 -9 -4 -9c-1.035 0 -1.979 .885 -2.689 2.337"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.65 5.623a9 9 0 1 0 12.71 12.745m1.684 -2.328a9 9 0 0 0 -12.094 -12.08"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.32 8.349c-3.136 .625 -5.32 2.025 -5.32 3.651c0 2.21 4.03 4 9 4c1.286 0 2.51 -.12 3.616 -.336m3.059 -.98c1.445 -.711 2.325 -1.653 2.325 -2.684c0 -2.21 -4.03 -4 -9 -4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbView360(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "12",
        "rx": "4",
        "ry": "9"
      }
    }, {
      "tag": "ellipse",
      "attr": {
        "cx": "12",
        "cy": "12",
        "rx": "4",
        "ry": "9",
        "transform": "rotate(90 12 12)"
      }
    }]
  })(props);
}
;
export function TbViewfinderOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.65 5.623a9 9 0 1 0 12.71 12.745m1.684 -2.328a9 9 0 0 0 -12.094 -12.08"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21v-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbViewfinder(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "7",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "12",
        "x2": "18",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "12.01"
      }
    }]
  })(props);
}
;
export function TbViewportNarrow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h7l-3 -3m0 6l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12h-7l3 -3m0 6l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 6v-3h6v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 18v3h6v-3"
      }
    }]
  })(props);
}
;
export function TbViewportWide(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 12h-7l3 -3m0 6l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 12h7l-3 -3m0 6l3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6v-3h18v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 18v3h18v-3"
      }
    }]
  })(props);
}
;
export function TbVinyl(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16.004 3.937a9 9 0 1 0 4.996 8.063"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "20",
        "cy": "4",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4l-3.5 10l-2.5 2"
      }
    }]
  })(props);
}
;
export function TbVirusOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.469 8.46a5 5 0 0 0 7.058 7.084m1.386 -2.608a5 5 0 0 0 -5.826 -5.853"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(45 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(90 12 12)"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "13",
        "y2": "3",
        "transform": "rotate(135 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(180 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(225 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(270 12 12)"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "11",
        "y2": "3",
        "transform": "rotate(315 12 12)"
      }
    }]
  })(props);
}
;
export function TbVirusSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 12a5 5 0 1 0 -5 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(45 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(90 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(180 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(225 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(270 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(315 12 12)"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17.5",
        "cy": "17.5",
        "r": "2.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "19.5",
        "y1": "19.5",
        "x2": "22",
        "y2": "22"
      }
    }]
  })(props);
}
;
export function TbVirus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(45 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(90 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(135 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(180 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(225 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(270 12 12)"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7v-4m-1 0h2",
        "transform": "rotate(315 12 12)"
      }
    }]
  })(props);
}
;
export function TbVocabulary(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5v16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 11h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 11h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 15h1"
      }
    }]
  })(props);
}
;
export function TbVolume2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 8a5 5 0 0 1 0 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
      }
    }]
  })(props);
}
;
export function TbVolume3(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 10l4 4m0 -4l-4 4"
      }
    }]
  })(props);
}
;
export function TbVolumeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 8a5 5 0 0 1 1.912 4.934m-1.377 2.602a5.001 5.001 0 0 1 -.535 .464"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.7 5a9 9 0 0 1 2.362 11.086m-1.676 2.299a9.005 9.005 0 0 1 -.686 .615"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.069 5.054l.431 -.554a0.8 .8 0 0 1 1.5 .5v2m0 4v8a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l1.294 -1.664"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbVolume(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 8a5 5 0 0 1 0 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17.7 5a9 9 0 0 1 0 14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
      }
    }]
  })(props);
}
;
export function TbWalk(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "13",
        "cy": "4",
        "r": "1"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "21",
        "x2": "10",
        "y2": "17"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 21l-2 -4l-3 -3l1 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 12l2 -3l4 -1l3 3l3 1"
      }
    }]
  })(props);
}
;
export function TbWall(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 8h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12h-16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16h16"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 4v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 8v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 16v4"
      }
    }]
  })(props);
}
;
export function TbWalletOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 8v-3a1 1 0 0 0 -1 -1h-8m-3.413 .584a2 2 0 0 0 1.413 3.416h2m4 0h6a1 1 0 0 1 1 1v3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 19a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12h4v4m-4 0a2 2 0 0 1 -2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbWallet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 12v4h-4a2 2 0 0 1 0 -4h4"
      }
    }]
  })(props);
}
;
export function TbWallpaperOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 6h8a2 2 0 0 1 2 2v8m-.58 3.409a1.994 1.994 0 0 1 -1.42 .591h-12"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 18v-10m-3.427 -3.402c-.353 .362 -.573 .856 -.573 1.402v12"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbWallpaper(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-12"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "18",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 18v-12a2 2 0 1 0 -4 0v12"
      }
    }]
  })(props);
}
;
export function TbWandOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.5 10.5l-7.5 7.5l3 3l7.5 -7.5m2 -2l5.5 -5.5l-3 -3l-5.5 5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 6l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.433 4.395c.35 -.36 .567 -.852 .567 -1.395a2 2 0 0 0 2 2c-.554 0 -1.055 .225 -1.417 .589"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.418 14.41c.36 -.36 .582 -.86 .582 -1.41a2 2 0 0 0 2 2c-.555 0 -1.056 .226 -1.419 .59"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbWand(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "6 21 21 6 18 3 3 18 6 21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "6",
        "x2": "18",
        "y2": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 3a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 13a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
      }
    }]
  })(props);
}
;
export function TbWaveSawTool(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h5l4 8v-16l4 8h5"
      }
    }]
  })(props);
}
;
export function TbWaveSine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12h-2c-.894 0 -1.662 -.857 -1.761 -2c-.296 -3.45 -.749 -6 -2.749 -6s-2.5 3.582 -2.5 8s-.5 8 -2.5 8s-2.452 -2.547 -2.749 -6c-.1 -1.147 -.867 -2 -1.763 -2h-2"
      }
    }]
  })(props);
}
;
export function TbWaveSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h5v8h4v-16h4v8h5"
      }
    }]
  })(props);
}
;
export function TbWebhook(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4.876 13.61a4 4 0 1 0 6.124 3.39h6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.066 20.502a4 4 0 1 0 1.934 -7.502c-.706 0 -1.424 .179 -2 .5l-3 -5.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 8a4 4 0 1 0 -8 0c0 1.506 .77 2.818 2 3.5l-3 5.5"
      }
    }]
  })(props);
}
;
export function TbWheelchair(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8",
        "cy": "16",
        "r": "5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "19",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 17a3 3 0 0 0 -3 -3h-3.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3h1a2 2 0 0 1 2 2v6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 8h11"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 8v6"
      }
    }]
  })(props);
}
;
export function TbWifi0(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12.01",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbWifi1(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12.01",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.172 15.172a4 4 0 0 1 5.656 0"
      }
    }]
  })(props);
}
;
export function TbWifi2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12.01",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.172 15.172a4 4 0 0 1 5.656 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.343 12.343a8 8 0 0 1 11.314 0"
      }
    }]
  })(props);
}
;
export function TbWifiOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12.01",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.172 15.172a4 4 0 0 1 5.656 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "3",
        "x2": "21",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbWifi(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "12.01",
        "y2": "18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.172 15.172a4 4 0 0 1 5.656 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.343 12.343a8 8 0 0 1 11.314 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
      }
    }]
  })(props);
}
;
export function TbWindOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 8h3m4 0h1.5a2.5 2.5 0 1 0 -2.34 -3.24"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 12h2.5a2.5 2.5 0 0 1 1.801 4.282"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbWind(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 8h8.5a2.5 2.5 0 1 0 -2.34 -3.24"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12h15.5a2.5 2.5 0 1 1 -2.34 3.24"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"
      }
    }]
  })(props);
}
;
export function TbWindmillOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15.061 11.06c1.18 -.824 1.939 -2.11 1.939 -3.56c0 -2.49 -2.24 -4.5 -5 -4.5v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12c0 2.76 2.01 5 4.5 5c.166 0 .33 -.01 .49 -.03m2.624 -1.36c.856 -.91 1.386 -2.19 1.386 -3.61h-5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12c-2.76 0 -5 2.01 -5 4.5s2.24 4.5 5 4.5v-9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.981 7.033c-2.244 .285 -3.981 2.402 -3.981 4.967h9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbWindmill(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12c2.76 0 5 -2.01 5 -4.5s-2.24 -4.5 -5 -4.5v9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12c0 2.76 2.01 5 4.5 5s4.5 -2.24 4.5 -5h-9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12c-2.76 0 -5 2.01 -5 4.5s2.24 4.5 5 4.5v-9z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 12c0 -2.76 -2.01 -5 -4.5 -5s-4.5 2.24 -4.5 5h9z"
      }
    }]
  })(props);
}
;
export function TbWindowOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.166 6.19a6.903 6.903 0 0 0 -1.166 3.81v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-1m0 -4v-5c0 -3.728 -3.134 -7 -7 -7a6.86 6.86 0 0 0 -3.804 1.158"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 13h8m4 0h2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3v5m0 4v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbWindow(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3c-3.866 0 -7 3.272 -7 7v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-10c0 -3.728 -3.134 -7 -7 -7z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "13",
        "x2": "19",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbWindsock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 3v18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 11l12 -1v-4l-12 -1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5.5v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 6v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 21h4"
      }
    }]
  })(props);
}
;
export function TbWiperWash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "20",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 6a4 4 0 0 1 .4 -1.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 2.1a4 4 0 0 1 2 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6a4 4 0 0 0 -.4 -1.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 6a4 4 0 0 1 .4 -1.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 2.1a4 4 0 0 1 2 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 6a4 4 0 0 0 -.4 -1.8"
      }
    }]
  })(props);
}
;
export function TbWiper(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "18",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 9l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "18",
        "x2": "9.8",
        "y2": "5.2"
      }
    }]
  })(props);
}
;
export function TbWoman(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 22v-4h-2l2 -6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1l2 6h-2v4"
      }
    }]
  })(props);
}
;
export function TbWorldDownload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12a9 9 0 1 0 -9 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.6 9h16.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.6 15h8.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.578 3a17 17 0 0 0 0 18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 3c1.719 2.755 2.5 5.876 2.5 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 14v7m-3 -3l3 3l3 -3"
      }
    }]
  })(props);
}
;
export function TbWorldLatitude(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.6",
        "y1": "7",
        "x2": "19.4",
        "y2": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.6",
        "y1": "17",
        "x2": "19.4",
        "y2": "17"
      }
    }]
  })(props);
}
;
export function TbWorldLongitude(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 3a11.2 11.2 0 0 0 0 18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 3a11.2 11.2 0 0 1 0 18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "3",
        "x2": "12",
        "y2": "21"
      }
    }]
  })(props);
}
;
export function TbWorldOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.6 9h5.4m4 0h7.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5.65 5.623a9 9 0 1 0 12.71 12.745m1.684 -2.328a9 9 0 0 0 -12.094 -12.08"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.6 15h11.4m4 0h1.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.335 8.388a18.998 18.998 0 0 0 -.335 3.612c0 4.97 1.79 9 4 9c1.622 0 3.018 -2.172 3.646 -5.294m.354 -3.706c0 -4.97 -1.79 -9 -4 -9c-1.035 0 -1.979 .885 -2.689 2.337"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbWorldUpload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12a9 9 0 1 0 -9 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.6 9h16.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.6 15h8.4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.578 3a17 17 0 0 0 0 18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 3c1.719 2.755 2.5 5.876 2.5 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 21v-7m3 3l-3 -3l-3 3"
      }
    }]
  })(props);
}
;
export function TbWorld(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3.6",
        "y1": "9",
        "x2": "20.4",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3.6",
        "y1": "15",
        "x2": "20.4",
        "y2": "15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.5 3a17 17 0 0 0 0 18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12.5 3a17 17 0 0 1 0 18"
      }
    }]
  })(props);
}
;
export function TbWreckingBall(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "19",
        "cy": "13",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "4",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "13",
        "cy": "17",
        "r": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "13",
        "y1": "19",
        "x2": "4",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "15",
        "x2": "13",
        "y2": "15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 12v-5h2a3 3 0 0 1 3 3v5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 15v-2a1 1 0 0 1 1 -1h7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 11v-7l-6 7"
      }
    }]
  })(props);
}
;
export function TbWritingOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v1l2 2l.5 -.5m1.5 -2.5v-11c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbWritingSignOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19c3.333 -2 5 -4 5 -6c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 2.877 2.5 4c1.5 2 2.5 2.5 3.5 1c.667 -1 1.167 -1.833 1.5 -2.5c1 2.333 2.333 3.5 4 3.5h2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 16v1l2 2l.5 -.5m1.5 -2.5v-11c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3l18 18"
      }
    }]
  })(props);
}
;
export function TbWritingSign(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 19c3.333 -2 5 -4 5 -6c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 2.877 2.5 4c1.5 2 2.5 2.5 3.5 1c.667 -1 1.167 -1.833 1.5 -2.5c1 2.333 2.333 3.5 4 3.5h2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7h4"
      }
    }]
  })(props);
}
;
export function TbWriting(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 7h4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3"
      }
    }]
  })(props);
}
;
export function TbX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "6",
        "x2": "6",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "6",
        "x2": "18",
        "y2": "18"
      }
    }]
  })(props);
}
;
export function TbYinYang(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 3a4.5 4.5 0 0 0 0 9a4.5 4.5 0 0 1 0 9"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "16.5",
        "r": ".5",
        "fill": "currentColor"
      }
    }]
  })(props);
}
;
export function TbYoga(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "4",
        "r": "1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 20h4l1.5 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 20l-1 -5h-5l1 -7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 10l4 -1l4 -1l4 1.5l4 1.5"
      }
    }]
  })(props);
}
;
export function TbZodiacAquarius(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 10l3 -3l3 3l3 -3l3 3l3 -3l3 3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 17l3 -3l3 3l3 -3l3 3l3 -3l3 3"
      }
    }]
  })(props);
}
;
export function TbZodiacAries(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 5a5 5 0 1 0 -4 8"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 13a5 5 0 1 0 -4 -8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "5"
      }
    }]
  })(props);
}
;
export function TbZodiacCancer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 12a10 6.5 0 0 1 14 -6.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12a10 6.5 0 0 1 -14 6.5"
      }
    }]
  })(props);
}
;
export function TbZodiacCapricorn(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4a3 3 0 0 1 3 3v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7a3 3 0 0 1 6 0v11a3 3 0 0 1 -3 3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "16",
        "cy": "17",
        "r": "3"
      }
    }]
  })(props);
}
;
export function TbZodiacGemini(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 3a21 21 0 0 0 18 0"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 21a21 21 0 0 1 18 0"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "4.5",
        "x2": "7",
        "y2": "19.5"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "4.5",
        "x2": "17",
        "y2": "19.5"
      }
    }]
  })(props);
}
;
export function TbZodiacLeo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 17a4 4 0 1 0 8 0"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "16",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 7c0 3 2 5 2 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 7c0 4 -2 6 -2 10"
      }
    }]
  })(props);
}
;
export function TbZodiacLibra(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "20",
        "x2": "19",
        "y2": "20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 17h5v-.3a7 7 0 1 1 4 0v.3h5"
      }
    }]
  })(props);
}
;
export function TbZodiacPisces(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 3a21 21 0 0 1 0 18"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 3a21 21 0 0 0 0 18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}
;
export function TbZodiacSagittarius(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "20",
        "x2": "20",
        "y2": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 4h7v7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6.5",
        "y1": "12.5",
        "x2": "11.5",
        "y2": "17.5"
      }
    }]
  })(props);
}
;
export function TbZodiacScorpio(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 4a2 2 0 0 1 2 2v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 6a2 2 0 0 1 4 0v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 6a2 2 0 0 1 4 0v10a3 3 0 0 0 3 3h5l-3 -3m0 6l3 -3"
      }
    }]
  })(props);
}
;
export function TbZodiacTaurus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 3a6 6 0 0 0 12 0"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "15",
        "r": "6"
      }
    }]
  })(props);
}
;
export function TbZodiacVirgo(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 4a2 2 0 0 1 2 2v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 6a2 2 0 0 1 4 0v9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9 6a2 2 0 0 1 4 0v10a7 5 0 0 0 7 5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 21a7 5 0 0 0 7 -5v-2a3 3 0 0 0 -6 0"
      }
    }]
  })(props);
}
;
export function TbZoomCancel(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "8",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "8",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbZoomCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 21l-6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M7 10l2 2l4 -4"
      }
    }]
  })(props);
}
;
export function TbZoomCode(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 21l-6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 8l-2 2l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8l2 2l-2 2"
      }
    }]
  })(props);
}
;
export function TbZoomExclamation(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 21l-6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13v.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 7v3"
      }
    }]
  })(props);
}
;
export function TbZoomInArea(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 13v4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 15h4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "15",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 22l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 18h-1a2 2 0 0 1 -2 -2v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6v-1a2 2 0 0 1 2 -2h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3h1a2 2 0 0 1 2 2v1"
      }
    }]
  })(props);
}
;
export function TbZoomIn(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "10",
        "x2": "13",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "7",
        "x2": "10",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbZoomMoney(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 21l-6 -6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 7h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 13v1m0 -8v1"
      }
    }]
  })(props);
}
;
export function TbZoomOutArea(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M13 15h4"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "15",
        "cy": "15",
        "r": "5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 22l-3 -3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6 18h-1a2 2 0 0 1 -2 -2v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11v-1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 6v-1a2 2 0 0 1 2 -2h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 3h1"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M15 3h1a2 2 0 0 1 2 2v1"
      }
    }]
  })(props);
}
;
export function TbZoomOut(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "7",
        "y1": "10",
        "x2": "13",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "15",
        "y2": "15"
      }
    }]
  })(props);
}
;
export function TbZoomPan(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M17 17l-2.5 -2.5"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 5l2 -2l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 10l2 2l-2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 10l-2 2l2 2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 19l2 2l2 -2"
      }
    }]
  })(props);
}
;
export function TbZoomQuestion(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "strokeWidth": "2",
      "stroke": "currentColor",
      "fill": "none",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "desc",
      "attr": {},
      "child": []
    }, {
      "tag": "path",
      "attr": {
        "stroke": "none",
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "10",
        "r": "7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 21l-6 -6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "13",
        "x2": "10",
        "y2": "13.01"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 10a1.5 1.5 0 1 0 -1.14 -2.474"
      }
    }]
  })(props);
}
;